/**
 * @fileoverview Arquivo responsável por definir as traduções em português da aplicação.
 */

const messages = {
  pt: {
    translations: {
      selectLanguage: "Selecione um idioma",
      triageNotice: {
        message: "OS {{number}} chegou para um cliente que você está atendendo. A triagem \"{{name}}\" está esperando: entregue à IA quando quiser.",
        open: "Abrir conversa",
      },
      billingStatusBanner: {
        overdue: "Pagamento pendente: pague até {{date}} para o envio de mensagens não parar.",
        overdueInternal: "Pagamento pendente: pague até {{date}} para o Chat Interno não parar.",
        overdueNoDeadline: "Pagamento pendente: há uma fatura vencida sem pagamento.",
        suspendedAdmin: "O envio de mensagens e o Chat Interno estão suspensos por pagamento pendente.",
        suspendedMember: "O envio de mensagens e o Chat Interno estão suspensos por pagamento pendente. Fale com o administrador da empresa.",
        suspendedInternalAdmin: "O Chat Interno está suspenso por pagamento pendente.",
        suspendedInternalMember: "O Chat Interno está suspenso por pagamento pendente. Fale com o administrador da empresa.",
        pay: "Pagar agora",
        adequacyDue: "Uma condição do plano acabou: escolha o que fica até {{date}}, ou o acesso fica restrito até a escolha.",
        choose: "Escolher o que fica",
        close: "Fechar até amanhã",
      },
      messageUsageBanner: {
        commonNear: "Já foram {{percent}}% das mensagens do mês ({{used}} de {{limit}}). Renova em {{date}}.",
        commonFull: "As mensagens do mês acabaram. Atendentes e automações voltam a enviar em {{date}}, ou antes com um plano maior.",
        aiNear: "A IA já usou {{percent}}% das mensagens dela no mês ({{used}} de {{limit}}). Renova em {{date}}.",
        aiFull: "As mensagens da IA acabaram. Até {{date}}, as conversas da IA vão para os atendentes. Um pacote maior de IA libera antes.",
        close: "Fechar aviso",
      },
      noResponseAlert: {
        messageOne:
          "Atenção: 1 conversa aguardando resposta há mais de 10 minutos.",
        messageMany:
          "Atenção: {{count}} conversas aguardando resposta há mais de 10 minutos.",
        action: "Ver Conversas Pendentes",
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome da empresa",
          email: "Email",
          phone: "Telefone com (DDD)",
          plan: "Plano",
          password: "Senha",
        },
        formErrors: {
          name: {
            required: "Nome da empresa é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          password: {
            short: "Senha muito curta",
            long: "Senha muito longa",
          },
          email: {
            required: "Email é obrigatório",
            invalid: "Email inválido",
          },
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
        plan: {
          attendant: "Atendente",
          whatsapp: "WhatsApp",
          queues: "Filas",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          submitting: "Entrando...",
          register: "Registre-se, agora mesmo!",
        },
        errors: {
          emailRequired: "Email é obrigatório",
          emailInvalid: "Email inválido",
          passwordRequired: "Senha é obrigatória",
        },
        capsLockOn: "Caps Lock ativado",
      },
      mfa: {
        setup: {
          title: "Configurar autenticação em duas etapas",
          scanQr: "Escaneie o QR Code com Google Authenticator, Duo Mobile ou app compatível.",
          manualSecret: "Não consegue escanear? Use este código manualmente:",
          next: "Próximo",
          back: "Voltar",
          confirmOtp: "Digite o código de 6 dígitos gerado pelo app:",
          confirm: "Confirmar",
          backupTitle: "Códigos de recuperação",
          backupHint: "Guarde em local seguro. Cada código é de uso único e substitui o app caso você perca o celular.",
          copyAll: "Copiar tudo",
          download: "Baixar .txt",
          savedAck: "Guardei meus códigos com segurança",
          oneTimeWarning: "Estes códigos serão exibidos uma única vez.",
          finish: "Concluir",
          cancel: "Cancelar",
          copied: "Códigos copiados",
        },
        login: {
          title: "Verificação em duas etapas",
          otpLabel: "Código do app autenticador",
          otpHint: "Digite o código de 6 dígitos do seu app.",
          backupLabel: "Código de recuperação",
          backupHint: "Use um dos códigos de recuperação que você salvou.",
          verify: "Verificar",
          useBackup: "Código de recuperação",
          useOtp: "Usar app autenticador",
          backToPassword: "Voltar",
        },
        policy: {
          title: "Autenticação em duas etapas da equipe",
          modeOff: "Desativado",
          modeOptional: "Opcional",
          modeRequired: "Obrigatório",
          gracePeriod: "Prazo para configurar (dias)",
          save: "Salvar",
          saved: "Política atualizada",
        },
        profile: {
          menuItem: "Autenticação em duas etapas",
          statusEnabled: "Ativa desde {{date}}",
          statusDisabled: "Não configurada",
          enable: "Ativar",
          disable: "Desativar",
          disableConfirm: "Confirme com o código atual para desativar MFA",
          adminReset: "Resetar MFA do usuário",
          adminResetConfirm: "Tem certeza? O usuário precisará reconfigurar o app no próximo login.",
          adminResetDone: "MFA resetado",
          enabledDesc: "Seu acesso está protegido: a cada login você precisa fornecer o código do aplicativo autenticador.",
          disabledDesc: "Ative a autenticação em duas etapas para reforçar a segurança da sua conta. Você precisará de um app como Google Authenticator ou Duo Mobile.",
        },
        banner: {
          title: "Sua empresa exige autenticação em duas etapas.",
          subtitle: "Configure em até {{days}} dia(s) para continuar acessando.",
          cta: "Configurar agora",
        },
        errors: {
          invalidOtp: "Código inválido ou expirado",
          ticketExpired: "Sessão de verificação expirou. Faça login novamente.",
          backupUsed: "Código de recuperação já utilizado",
        },
      },
      resetPassword: {
        title: "Redefinir Senha",
        toasts: {
          emailSent: "Email enviado com sucesso!",
          emailNotFound: "Email não encontrado!",
          passwordUpdated: "Senha atualizada com sucesso!",
        },
        formErrors: {
          email: {
            required: "Email é obrigatório",
            invalid: "Email inválido",
          },
          newPassword: {
            required: "Nova senha é obrigatória",
            matches:
                "Sua senha precisa ter no mínimo 8 caracteres, sendo uma letra maiúscula, uma minúscula e um número.",
          },
          confirmPassword: {
            required: "Confirmação de senha é obrigatória",
            matches: "As senhas não correspondem",
          },
        },
        form: {
          email: "Email",
          verificationCode: "Código de verificação",
          newPassword: "Nova senha",
          confirmPassword: "Confirme a nova senha",
        },
        buttons: {
          submitEmail: "Enviar email",
          submitPassword: "Redefinir senha",
          back: "Não tem uma conta? Cadastre-se!",
        },
      },
      dashboard: {
        scope: {
          label: "Números de",
          company: "Esta conta",
          allMine: "Todos os meus departamentos",
          units: "Minhas unidades",
        },
        toasts: {
          selectFilterError: "Parametrize o filtro",
          userChartError: "Erro ao obter informações da conversa",
          dateChartError: "Erro ao obter informações da conversa",
          noResponseChartError: "Erro ao obter informações dos tickets sem resposta",
          messagesPerUserError: "Erro ao carregar mensagens por usuário",
        },
        filters: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
          filterType: {
            title: "Tipo de Filtro",
            options: {
              perDate: "Filtro por Data",
              perPeriod: "Filtro por Período",
            },
            helper: "Selecione o tipo de filtro desejado",
          },
        },
        periodSelect: {
          title: "Período",
          options: {
            none: "Nenhum selecionado",
            last3: "Últimos 3 dias",
            last7: "Últimos 7 dias",
            last15: "Últimos 15 dias",
            last30: "Últimos 30 dias",
            last60: "Últimos 60 dias",
            last90: "Últimos 90 dias",
          },
          helper: "Selecione o período desejado",
        },
        counters: {
          inTalk: "Em conversa",
          waiting: "Aguardando",
          finished: "Finalizados",
          newContacts: "Novos contatos",
          averageTalkTime: "T.M. de Conversa",
          averageWaitTime: "T.M. de Espera",
        },
        buttons: {
          filter: "Filtrar",
        },
        onlineTable: {
          ratingLabel: "1 - Insatisfeito, 2 - Satisfeito, 3 - Muito Satisfeito",
          name: "Nome",
          ratings: "Avaliações",
          avgSupportTime: "T.M. de Atendimento",
          status: "Status (Atual)",
        },
        charts: {
          user: {
            label: "Gráfico de Conversas",
            title: "Total de Tickets Encerrados por Usuários",
            start: "Início",
            end: "Fim",
            filter: "Filtrar",
          },
          date: {
            label: "Gráfico de Conversas",
            title: "Total",
            start: "Início",
            end: "Fim",
            filter: "Filtrar",
          },
        },
      },
      dashboardGeral: {
        title: "Dashboard Geral",
        subtitle: "Visão consolidada do grupo {{groupName}}",
        accountsCount: "{{count}} contas",
        cards: {
          active: "Atendimentos Ativos",
          pending: "Pendentes",
          noResponse: "Sem Resposta +10min",
          noResponseRate: "Taxa sem resposta",
          avgPerAttendant: "Média/Atendente",
          art: "ART do Grupo",
        },
        table: {
          title: "Performance por Conta",
          headers: {
            account: "Conta",
            active: "Ativos",
            pending: "Pendentes",
            noResponse: "Sem Resp +10min",
            art: "ART",
            attendants: "Atendentes",
          },
        },
        states: {
          loading: "Carregando dashboard do grupo...",
          empty: "Nenhuma conta encontrada neste grupo",
          error: "Erro ao carregar dashboard. Tentar novamente?",
        },
      },
      plans: {
        toasts: {
          errorList: "Não foi possível carregar a lista de registros",
          errorOperation: "Não foi possível realizar a operação",
          error:
              "Não foi possível realizar a operação. Verifique se já existe uma plano com o mesmo nome ou se os campos foram preenchidos corretamente",
          success: "Operação realizada com sucesso!",
        },
        confirm: {
          title: "Exclusão de Registro",
          message: "Deseja realmente excluir o registro?",
        },
        buttons: {
          newCategory: "Nova Categoria",
          newPlan: "Novo Plano",
        },
        modal: {
          editPlan: "Editar Plano",
          newPlan: "Novo Plano",
          newCategory: "Nova Categoria",
          categoryName: "Nome da Categoria",
          categoryPlaceholder: "Ex: Premium, Enterprise, Starter",
          basicInfo: "Informações Básicas",
          emptyCategory: "Esta categoria está vazia. Clique em \"Novo Plano\" para adicionar.",
        },
        labels: {
          plans: "Planos",
          plan: "plano",
          plansPlural: "planos",
        },
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
          value: "Valor",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "CRM",
          integrations: "Integrações",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          leads: "CRM",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
        },
      },
      boardShare: {
        open: "Compartilhar quadro",
        title: "Compartilhar quadro",
        description: "Permita que outras pessoas visualizem este quadro por meio de um link seguro, sem precisar acessar o Sttelar Talk.",
        close: "Fechar",
        back: "Voltar",
        cancel: "Cancelar",
        newLink: "Novo link",
        listTitle: "Links deste quadro ({{count}})",
        loadError: "Não deu para carregar os links.",
        retry: "Tentar de novo",
        empty: "Nenhum link ainda.",
        form: {
          name: "Nome do link",
          namePlaceholder: "Ex.: Cliente Midea",
          nameHelp: "Para você saber com quem compartilhou.",
          nameRequired: "Dê um nome ao link.",
          validity: "Validade",
          permanent: "Permanente",
          permanentHelp: "Funciona até você revogar.",
          temporary: "Temporário",
          presets: {
            "1h": "1 hora",
            "24h": "24 horas",
            "7d": "7 dias",
            "30d": "30 dias",
            custom: "Personalizado",
          },
          customDate: "Data e hora",
          expiresOn: "Para de funcionar em {{date}}.",
          customRequired: "Escolha a data e a hora.",
          customInvalid: "Escolha uma data entre 5 minutos e 1 ano a partir de agora.",
          protection: "Proteção",
          password: "Exigir senha para acessar",
          passwordHint: "Recomendado quando o quadro tem dados de clientes.",
          passwordLabel: "Senha",
          passwordRule: "Mínimo de 8 caracteres.",
          passwordTooShort: "A senha precisa ter pelo menos 8 caracteres.",
          passwordTooLong: "A senha está longa demais.",
          generate: "Gerar senha forte",
          show: "Mostrar senha",
          hide: "Ocultar senha",
          copyPassword: "Copiar senha",
          visibility: "O que o link mostra",
          visibilityBase: "Sempre: nome do card, etapa, prioridade, prazo, responsável e andamento das subtarefas.",
          contactInfo: "Dados de contato",
          contactInfoHelp: "Telefone, e-mail, CPF (parcial) e endereço.",
          cardDetails: "Detalhes do card",
          cardDetailsHelp: "Campos personalizados, OS, descrição e subtarefas.",
          never: "Comentários, anexos e histórico nunca aparecem.",
          create: "Criar link",
          creating: "Criando...",
        },
        created: {
          newTitle: "Link criado",
          renewedTitle: "Novo link gerado",
          newText: "Copie o link e envie para quem vai ver o quadro.",
          copyOnlyTitle: "Link do compartilhamento",
          copyOnlyText: "Não deu para copiar sozinho. Selecione o endereço abaixo e copie.",
          renewedText: "O link anterior parou de funcionar. Envie este no lugar dele.",
          link: "Link",
          copyLink: "Copiar",
          copiedShort: "Copiado",
          copied: "Link copiado",
          copyFailed: "Não deu para copiar. Selecione o texto e copie.",
          passwordCopied: "Senha copiada",
          passwordNote: "Envie a senha por outro canal. Ela não aparece de novo.",
          done: "Concluir",
          seeLinks: "Ver links",
        },
        row: {
          active: "Ativo",
          expired: "Expirado",
          revoked: "Revogado",
          permanent: "Permanente",
          until: "Até {{date}}",
          expiredOn: "Expirou em {{date}}",
          revokedOn: "Revogado em {{date}}",
          revokedBy: "Revogado em {{date}} por {{name}}",
          withPassword: "Com senha",
          withoutPassword: "Sem senha",
          showsContact: "Mostra contato",
          showsDetails: "Mostra detalhes",
          createdBy: "Criado em {{date}} por {{name}}",
          createdAt: "Criado em {{date}}",
          lastAccess: "Último acesso em {{date}}",
          neverAccessed: "Ainda não foi aberto",
          copyLink: "Copiar link",
          more: "Mais ações",
          setPassword: "Definir senha",
          changePassword: "Alterar senha",
          changeValidity: "Alterar validade",
          renew: "Gerar novo link",
          revoke: "Revogar",
        },
        password: {
          title: "Senha do link",
          text: "Quem já abriu o quadro vai precisar digitar a senha nova.",
          save: "Salvar senha",
          remove: "Remover senha",
          saved: "Senha salva",
          removed: "Senha removida",
        },
        validity: {
          title: "Validade do link",
          current: "Hoje ele vale até {{date}}.",
          currentPermanent: "Hoje ele é permanente.",
          text: "A nova validade conta a partir de agora.",
          save: "Salvar validade",
          saved: "Validade salva",
        },
        renew: {
          title: "Gerar novo link?",
          text: "O link atual para de funcionar na hora. Quem tem ele vai precisar do novo.",
          confirm: "Gerar novo link",
        },
        revoke: {
          title: "Revogar link?",
          text: "Quem tem o link perde o acesso na hora, e não dá para desfazer.",
          confirm: "Revogar",
          done: "Link revogado",
        },
        removePassword: {
          title: "Remover a senha?",
          text: "Qualquer pessoa com o link vai poder ver o quadro, sem senha.",
          confirm: "Remover senha",
        },
      },
      sharedBoard: {
        pageTitle: "Quadro compartilhado",
        eyebrow: "Quadro compartilhado",
        readOnly: "Modo de visualização — Somente leitura",
        readOnlyShort: "Somente leitura",
        updatedAt: "Atualizado às {{time}}",
        validUntil: "Link válido até {{date}}",
        refresh: "Atualizar",
        themeLight: "Tema claro",
        themeDark: "Tema escuro",
        search: "Buscar card",
        allAssignees: "Todos os responsáveis",
        unassigned: "Sem responsável",
        noColumns: "Este quadro ainda não tem etapas.",
        emptyColumn: "Sem cards nesta etapa",
        truncated: "Mostrando os primeiros {{count}} cards.",
        offline: "Sem conexão agora. Os dados podem estar desatualizados.",
        loading: "Carregando o quadro",
        password: {
          title: "Quadro protegido",
          text: "Digite a senha que você recebeu para ver este quadro.",
          label: "Senha",
          submit: "Acessar quadro",
          wrong: "Senha incorreta.",
          tooMany: "Muitas tentativas. Aguarde alguns minutos e tente de novo.",
          failed: "Não deu para entrar agora. Tente de novo.",
          cookies: "Não deu para manter o acesso neste navegador. Verifique se os cookies estão permitidos e tente de novo.",
          sessionEnded: "A senha mudou ou o acesso terminou. Digite a senha de novo.",
          show: "Mostrar senha",
          hide: "Ocultar senha",
        },
        status: {
          invalid: {
            title: "Link inválido",
            text: "Este link não existe ou foi copiado pela metade. Confira com quem compartilhou.",
          },
          expired: {
            title: "Link expirado",
            text: "Este link não está mais disponível. Peça um novo a quem compartilhou.",
          },
          revoked: {
            title: "Acesso encerrado",
            text: "Quem compartilhou encerrou este link. Se precisar, peça um novo.",
          },
          unavailable: {
            title: "Quadro indisponível",
            text: "Este quadro não está disponível no momento.",
          },
          rateLimited: {
            title: "Muitos acessos",
            text: "Aguarde um minuto e tente de novo.",
          },
          error: {
            title: "Não deu para abrir o quadro",
            text: "Verifique sua conexão e tente de novo.",
          },
          retry: "Tentar de novo",
        },
        card: {
          priority: "Prioridade",
          dueAt: "Prazo",
          assignee: "Responsável",
          createdAt: "Criado em",
          products: "Produto de interesse",
          checklist: "Subtarefas",
          checklistProgress: "{{done}} de {{total}} feitas",
          phone: "Telefone",
          email: "E-mail",
          cpf: "CPF",
          address: "Endereço",
          serviceOrder: "OS",
          field: "Campo",
          description: "Descrição",
          nobody: "Ninguém",
          loadError: "Não deu para abrir este card.",
          close: "Fechar",
          priorities: {
            low: "Baixa",
            normal: "Média",
            high: "Alta",
            urgent: "Maior",
          },
        },
      },
      externalLeads: {
        title: "Boards",
        refresh: "Atualizar",
        stats: {
          total: "Total de cards",
          unviewed: "Novos",
          pending: "Validados",
          completed: "Agendados",
        },
        filters: {
          searchPlaceholder: "Buscar por nome, telefone, CPF ou O.S...",
          status: "Status",
          all: "Todos",
          sortBy: "Ordenar por",
          newestFirst: "Mais recentes",
          oldestFirst: "Mais antigos",
        },
        card: {
          new: "Novo",
          notInformed: "Não informado",
          attachments: "anexo(s)",
          serviceOrderPlaceholder: "Ordem de Serviço",
          saveServiceOrder: "Salvar O.S.",
          noChanges: "Nenhuma alteração",
          viewDetails: "Ver detalhes",
          delete: "Excluir",
          startConversation: "Iniciar conversa no WhatsApp",
        },
        modal: {
          clientInfo: "Informações do Cliente",
          name: "Nome",
          phone: "Telefone",
          email: "E-mail",
          cpf: "CPF",
          address: "Endereço",
          serviceOrder: "Ordem de Serviço",
          attachments: "Anexos",
          customFields: "Campos Adicionais",
          changeStatus: "Alterar Status",
          receivedAt: "Recebido em:",
          viewedAt: "Visualizado em:",
          close: "Fechar",
        },
        confirmDelete: {
          title: "Excluir card",
          message: "Tem certeza que deseja excluir este card? Esta ação não pode ser desfeita.",
        },
        empty: {
          title: "Nenhum card encontrado",
          description: "Os cards criados no quadro ou recebidos por integração aparecerão aqui",
        },
        loading: "Carregando...",
        toasts: {
          newLead: "Novo card:",
          deleted: "Card excluído com sucesso",
          statusUpdated: "Status atualizado!",
          serviceOrderSaved: "Ordem de Serviço salva!",
        },
        defaultStatus: "Pendente",
      },
      kanban: {
        title: "CRM Kanban",
        toasts: {
          removed: "Tag removida do ticket!",
          added: "Tag adicionada com sucesso!",
          refreshed: "Dados atualizados!",
          errorLoadingTags: "Erro ao carregar tags",
          errorLoadingTickets: "Erro ao carregar tickets",
          errorMoving: "Erro ao mover card",
        },
        open: "Em aberto",
        seeTicket: "Ver Ticket",
        tickets: "tickets",
        columns: "colunas",
        refresh: "Atualizar",
        searchPlaceholder: "Buscar por nome ou número...",
        allQueues: "Todas as filas",
        loading: "Carregando tickets...",
        noMessage: "Sem mensagem",
        unknownContact: "Contato desconhecido",
      },
      companies: {
        title: "Cadastrar Empresa",
        buttons: {
          newGroup: "Novo Grupo",
          newCompany: "Nova Empresa",
        },
        modal: {
          editCompany: "Editar Empresa",
          newCompany: "Nova Empresa",
          newGroup: "Novo Grupo",
          groupName: "Nome do Grupo",
          groupPlaceholder: "Ex: Cliente XYZ",
        },
        labels: {
          companies: "Empresas",
          company: "empresa",
          companiesPlural: "empresas",
        },
        tooltips: {
          addUser: "Adicionar novo usuário",
          editUser: "Editar usuário existente",
          editCompany: "Editar empresa",
          deleteCompany: "Excluir empresa",
        },
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      agentManager: {
        button: "Gerenciar Agentes",
        title: "Agentes de IA",
        subtitle: "A IA que atende nos fluxos. O que você muda num agente vale em todos os fluxos que usam ele.",
        close: "Fechar",
        search: "Buscar agente",
        assistant: "Criar com o assistente",
        blank: "Novo agente",
        emptyTitle: "Nenhum agente ainda",
        empty: "Crie com o assistente, que aprende com o site do seu negócio, ou comece um em branco.",
        noResults: "Nenhum agente com esse nome.",
        usedIn: "Usado em {{list}}",
        usedInMore: "Usado em {{list}} e mais {{count}}",
        unused: "Em nenhum fluxo",
        flowOff: "desligado",
        noVersion: "sem texto",
        updatedAt: "atualizado em {{date}}",
        edit: "Editar",
        view: "Ver",
        delete: "Excluir",
        deleteInUse: "Tire o agente dos fluxos antes de excluir.",
        confirmDeleteTitle: "Excluir o agente?",
        confirmDelete: "{{name}} sai com o texto, as versões e as fontes. Não dá para desfazer.",
        deleted: "Agente excluído.",
        loadMore: "Carregar mais",
        unsaved: "Alterações não salvas",
        discardConfirm: "As alterações deste agente vão se perder. Sair mesmo assim?",
        editor: {
          back: "Voltar para a lista",
          newTitle: "Novo agente",
          name: "Nome",
          namePlaceholder: "Ex.: Ana",
          tabs: {
            knowledge: "Conhecimento",
            sources: "Fontes",
            intelligence: "Inteligência",
            test: "Testar",
          },
          save: "Salvar",
          discard: "Descartar",
          saved: "Agente salvo.",
          created: "Agente criado.",
          unsavedHint: "Alterações não salvas.",
          readOnly: "Você pode ver este agente, mas não mudar.",
          nameRequired: "Dê um nome ao agente.",
          promptRequired: "O texto da IA não pode ficar vazio.",
          caseNeedsAnswer: "Escreva a resposta de cada resposta pronta, ou tire o cartão.",
          loadFailed: "Não deu para abrir este agente.",
          knowledge: {
            title: "Instruções e base de conhecimento",
            info: "O que a IA sabe e como ela atende. Cada texto salvo vira uma versão nova, e dá para voltar a uma anterior.",
            placeholder: "Ex.: Você é a Ana, atendente da Loja Azul. Responda com educação e só com as informações abaixo.",
            live: "No ar: versão {{number}}, de {{date}}.",
            liveNone: "Sem texto ainda: a IA usa um texto padrão.",
            history: "Versões",
            historyTitle: "Versões do texto",
            versionName: "Versão {{number}}",
            current: "No ar",
            useVersion: "Usar esta",
            versionUsed: "Versão {{number}} no ar.",
            by: "por {{name}}",
            closeHistory: "Fechar versões",
          },
          sources: {
            siteTitle: "Site de origem",
            siteInfo: "De onde veio a base (o assistente lê o site). Fica só de referência.",
            sitePlaceholder: "https://seusite.com.br",
            filesTitle: "Arquivos",
            filesInfo: "A IA lê os arquivos de texto e pode enviar qualquer arquivo daqui ao cliente quando fizer sentido.",
            filesAdd: "Enviar arquivo",
            filesEmpty: "Nenhum arquivo.",
            uploading: "Enviando...",
            remove: "Tirar",
            casesTitle: "Respostas prontas",
            casesInfo: "Quando perguntarem algo parecido, a IA responde com o que você escreveu.",
            casesAdd: "Nova resposta",
            casesEmpty: "Nenhuma resposta pronta.",
            caseWhen: "Quando perguntarem",
            caseWhenPlaceholder: "Ex.: Qual o prazo de garantia?",
            caseAnswer: "Responda",
            caseAnswerPlaceholder: "Ex.: A garantia é de 90 dias a partir da entrega.",
            webTitle: "Pesquisa na internet",
            webInfo: "A IA pesquisa só nos sites que você listar.",
            webToggle: "Pesquisar na internet",
            webDomains: "Sites permitidos",
            webDomainsPlaceholder: "seusite.com.br, outro.com.br",
            wooTitle: "Catálogo da loja",
            wooInfo: "A IA consulta produtos, preços e estoque nas lojas do WooCommerce marcadas.",
            wooEmpty: "Nenhuma loja do WooCommerce ativa. Conecte uma em Integrações.",
          },
          intelligence: {
            model: "Modelo",
            modelInfo: "Modelos maiores entendem mais e custam mais por mensagem.",
            reasoning: "Raciocínio",
            reasoningInfo: "Mais raciocínio deixa a resposta mais pensada e mais cara. Só vale nos modelos GPT-5.",
            reasoningOff: "Este modelo não usa raciocínio.",
            style: "Tamanho das respostas",
            styles: {
              concise: "Curtas",
              balanced: "Médias",
              detailed: "Detalhadas",
            },
            behavior: "Como ela conversa",
            split: "Dividir a resposta em várias mensagens, como uma pessoa",
            images: "Ler as imagens que o cliente enviar",
            audio: "Ouvir os áudios (transcreve, tem custo)",
            video: "Ver os vídeos",
            wait: "Espera antes de responder (segundos)",
            waitInfo: "Tempo para o cliente terminar de digitar: mensagens seguidas viram uma só resposta.",
            aiUser: "Quem aparece como atendente",
            aiUserInfo: "O usuário IA que fica com a conversa enquanto ela atende. Sem ele, aparece só o nome do agente.",
            aiUserNone: "Só o nome do agente",
            photo: "Foto",
            photoChange: "Trocar foto",
            photoSaveFirst: "Salve o agente para pôr uma foto.",
          },
          test: {
            title: "Converse como um cliente",
            info: "A IA responde com o que está salvo. Nenhuma ação acontece de verdade: transferir, etiquetar e o CRM só fingem.",
            saveFirst: "Há alterações não salvas: o teste usa a versão salva.",
            newFirst: "Salve o agente para testar.",
            placeholder: "Escreva como um cliente",
            send: "Enviar",
            clear: "Nova conversa",
            error: "Não deu para testar agora. Tente de novo.",
            empty: "Mande uma mensagem para ver como ela responde.",
            files: "Enviaria: {{files}}",
          },
        },
      },
      invitePage: {
        loading: "Abrindo o convite...",
        title: "{{name}} convidou você para a equipe",
        titleNoInviter: "Você recebeu um convite para a equipe",
        company: "Empresa",
        account: "Conta",
        accounts: "Contas",
        profile: "Perfil",
        email: "E-mail",
        expires: "Vale até",
        profiles: {
          user: "Atendente",
          admin: "Administrador",
        },
        createSubtitle: "Crie sua senha para entrar.",
        name: "Seu nome",
        password: "Crie uma senha",
        passwordHint: "Pelo menos 8 caracteres.",
        create: "Criar conta e entrar",
        hasAccount: "Esse e-mail já tem conta no Sttelar Talk. Entre com ele para aceitar.",
        login: "Entrar para aceitar",
        acceptSubtitle: "Aceite para entrar na equipe.",
        accept: "Aceitar convite",
        otherEmail: "Você está conectado como {{current}}. O convite é para {{email}}.",
        switchUser: "Sair e usar o e-mail do convite",
        joinedTitle: "Convite aceito",
        joined: "Você já faz parte da conta {{account}}. Para trocar de conta depois, use o seletor do menu.",
        goToAccount: "Entrar na conta {{account}}",
        stay: "Continuar na conta atual",
        notNow: "Agora não",
        invalidTitle: "Este convite não vale mais",
        invalid: "Ele pode ter vencido, já ter sido usado ou excluído. Peça um convite novo a quem convidou você.",
        failedTitle: "Não deu para abrir o convite",
        retry: "Tentar de novo",
      },
      setupChecklist: {
        title: "Deixe a conta pronta para atender",
        progress: "{{done}} de {{total}} prontos",
        dismiss: "Dispensar",
        dismissHint: "Some só para você",
        done: "pronto",
        items: {
          whatsapp: {
            title: "Conectar o WhatsApp",
            text: "As conversas chegam aqui.",
            action: "Conectar",
          },
          team: {
            title: "Chamar a equipe",
            text: "Convide quem vai atender.",
            action: "Convidar",
          },
          ai: {
            title: "Ligar a IA",
            text: "Ela responde e passa para a equipe.",
            action: "Ligar a IA",
          },
          hours: {
            title: "Definir o horário",
            text: "Os dias e as horas em que a empresa atende.",
            action: "Definir",
          },
        },
      },
      accountSwitcher: {
        label: "Conta ativa",
        reload: "A conta foi trocada. Recarregue a página para continuar nela.",
      },
      billingProfile: {
        title: "Dados para a cobrança",
        subtitle: "Quem paga as faturas do Sttelar Talk. Aparece na nota fiscal e é usado no cartão.",
        personType: "Tipo",
        company: "Pessoa jurídica",
        individual: "Pessoa física",
        nameCompany: "Razão social",
        nameIndividual: "Nome completo",
        email: "E-mail de cobrança",
        phone: "Telefone",
        zipCode: "CEP",
        street: "Endereço",
        number: "Número",
        complement: "Complemento",
        optional: "(opcional)",
        required: "Preencha este campo.",
        zipLoading: "Buscando o endereço pelo CEP",
        neighborhood: "Bairro",
        city: "Cidade",
        state: "UF",
        save: "Salvar",
        saved: "Dados de cobrança salvos.",
      },
      billingOverview: {
        legacy: {
          title: "Cobrança combinada com a Sttelar",
          text: "O plano e as faturas da sua Empresa são combinados direto com a Sttelar.",
          talk: "Falar com a Sttelar",
          message: "Olá! Quero falar sobre o plano da Empresa {{name}}.",
        },
        conditions: {
          title: "Condições combinadas",
          list: "Catálogo: {{amount}}",
          price: "Preço combinado {{item}}: {{amount}}",
          discount: "Desconto de {{value}}% {{item}}",
          courtesy: "Cortesia: {{item}}",
          courtesyLicense: "Cortesia: uma licença",
          until: " até {{date}}",
          from: " a partir de {{date}}",
          itemsOf: {
            plan: "da licença do plano",
            internal_chat: "da licença do Chat Interno",
            ai_pack: "do pacote de IA",
          },
          itemsOn: {
            all: "na mensalidade",
            plan: "na licença do plano",
            internal_chat: "na licença do Chat Interno",
            ai_pack: "no pacote de IA",
          },
          items: {
            all: "a mensalidade",
            plan: "a licença do plano",
            internal_chat: "a licença do Chat Interno",
            ai_pack: "o pacote de IA",
          },
        },
        loadError: "Não foi possível carregar o faturamento.",
        disputes: {
          title: "Contestação no cartão",
          text: "A cobrança de {{amount}} foi contestada no cartão em {{date}}. Enquanto a operadora analisa, a Empresa segue funcionando. Se a contestação for aceita (o valor volta para o cartão), a cobrança precisa ser paga de novo em até 7 dias.",
        },
        overdue: {
          title: "Pagamento pendente",
          titleSuspended: "Envio suspenso",
          titleSuspendedInternal: "Chat Interno suspenso",
          deadline: "Pague até {{date}}",
          text: "A fatura de {{amount}}, vencida em {{due}}, ainda não foi paga. Pague até {{date}} para {{what}} não parar.",
          whatSending: "o envio de mensagens",
          whatInternal: "o Chat Interno",
          textSuspended: "A fatura de {{amount}}, vencida em {{due}}, não foi paga, e o envio de mensagens (atendentes, automações e IA) e o Chat Interno estão parados. Nada foi apagado, e as mensagens dos clientes continuam chegando. Pago, tudo volta na hora.",
          textSuspendedInternal: "A fatura de {{amount}}, vencida em {{due}}, não foi paga, e o Chat Interno está parado. Nada foi apagado. Pago, ele volta na hora.",
          textNoDeadline: "A fatura de {{amount}}, vencida em {{due}}, ainda não foi paga. Em Faturamento, dá para pagar no Pix ou tentar de novo no cartão.",
          creatingPix: "Gerando o Pix...",
          disputeNote: "Inclui uma cobrança contestada no cartão: a contestação foi aceita, e o valor voltou para o cartão.",
          invoiceDispute: "Contestação aceita em {{date}}",
          invoice: "Fatura vencida em {{date}}",
          payPix: "Pagar no Pix",
          retryCard: "Tentar de novo no cartão {{brand}} final {{last4}}",
          retrySavedCard: "Tentar de novo no cartão salvo",
          retrying: "Tentando no cartão...",
          retryPaid: "Pagamento confirmado.",
          refresh: "Atualizar",
          pixExpiredHint: "Gere outro em \"Pagar no Pix\".",
          boletoSettling: "Pagou o boleto? A confirmação leva até 3 dias úteis.",
        },
        status: {
          free: "Grátis",
          active: "Ativo",
          courtesy: "Cortesia",
          failed: "Pagamento pendente",
          canceling: "Cancelado",
          resumed: "Retomado",
        },
        free: "Grátis",
        perMonth: "por mês",
        starterSummary: "Até {{users}} pessoas, {{accounts}} conta, {{whatsapps}} número de WhatsApp e {{boards}} quadro do CRM. {{common}} mensagens e {{ai}} da IA por mês.",
        summary: {
          seats: "{{count}} licença",
          seats_plural: "{{count}} licenças",
          internal: "{{count}} de Chat Interno",
          pack: "o pacote de {{messages}} mensagens da IA",
          starterInternal: "Chat Interno para {{count}} pessoa",
          starterInternal_plural: "Chat Interno para {{count}} pessoas",
          and: "e",
        },
        renewsCard: "Renova em {{date}}, no cartão {{brand}} final {{last4}}.",
        renewsBoleto: "Renova em {{date}}, no boleto.",
        renewsSavedCard: "Renova em {{date}}, no cartão cadastrado.",
        courtesyNote: "A Empresa está em cortesia e não é cobrada.",
        disabledNote: "A contratação está indisponível no momento.",
        changeNote: "Para mudar o plano ou as licenças, fale com o suporte da Sttelar.",
        starterChangeNote: "Para ir ao Basic ou ao Pro, fale com o suporte da Sttelar.",
        paymentPendingNote: "Regularize a mensalidade pendente antes de alterar o plano. Se precisar de ajuda, fale com o suporte da Sttelar.",
        reductionScheduledNote: "Para aumentar agora, desfaça antes a redução agendada.",
        nothingToReduceNote: "Não há o que reduzir: o plano já está no mínimo para o que a Empresa usa.",
        cancellationScheduledNote: "Com o cancelamento agendado, o plano não muda por aqui. Para continuar nele, desfaça o cancelamento.",
        resumeNote: "A assinatura retomada começa no fim do ciclo pago; até lá, o plano não muda por aqui.",
        paidUntil: "Pago até {{date}}. Depois, Starter.",
        resumeStarts: "A assinatura retomada começa em {{date}}, sem cobrança até lá.",
        actions: {
          upgrade: "Contratar Basic ou Pro",
          addInternal: "Adicionar Chat Interno",
          changeInternal: "Alterar Chat Interno",
          reduce: "Reduzir na renovação",
          change: "Alterar plano",
          cancel: "Cancelar plano",
          cancelInternal: "Cancelar Chat Interno",
        },
        pending: {
          titleBoleto: "Boleto aguardando pagamento",
          titlePix: "Pix aguardando pagamento",
          pixExpiredHint: "Desista para gerar outro.",
          textChange: "{{what}}. A pagar agora: {{amount}}, a diferença até a renovação. O plano muda quando o pagamento for confirmado.",
          verifyingChange: "O pagamento não foi confirmado a tempo. Estamos conferindo se o pedido foi criado; não altere de novo antes disso.",
          titleCard: "Confirmando o pagamento",
          what: "{{plan}} com {{details}}",
          verifying: "A Pagar.me não confirmou a tempo. Estamos conferindo se a assinatura foi criada; não contrate de novo antes disso.",
          keepBoleto: "Manter boleto",
          keep: "Manter pedido",
          text: "{{what}}, {{amount}} por mês. O plano muda quando o pagamento for confirmado.",
          due: "Vence em {{date}}.",
          line: "Linha digitável",
          copy: "Copiar",
          copied: "Linha digitável copiada.",
          open: "Abrir boleto",
          cancel: "Desistir",
          cancelConfirm: "Confirmar desistência",
          cancelHint: "Depois de desistir, não pague este boleto.",
          canceled: "Pedido cancelado.",
          refresh: "Atualizar",
        },
        reduction: {
          title: "Redução agendada para {{date}}",
          text: "A partir dessa data, a Empresa terá {{what}}, por {{amount}} por mês. Até lá, nada muda.",
          undo: "Desfazer redução",
          undoConfirm: "Confirmar: desfazer",
          keep: "Manter redução",
          undone: "Redução desfeita.",
          locked: "Não dá mais para desfazer: a redução vale na renovação. Depois dela, para aumentar, use Alterar plano.",
        },
        cancellation: {
          title: "Plano cancelado: vale até {{date}}",
          titleInternal: "Chat Interno cancelado: vale até {{date}}",
          text: "A assinatura parou na Pagar.me e nada mais é cobrado. Até essa data, a Empresa segue no {{plan}}; depois, passa ao Starter, grátis.",
          textInternal: "A assinatura parou na Pagar.me e nada mais é cobrado. O Chat Interno vale até essa data.",
          undo: "Desfazer cancelamento",
          undoHint: "Contrata de novo o {{plan}} a partir de {{date}}, {{paidWith}}, sem cobrar nada agora.",
          byCard: "no cartão {{brand}} final {{last4}}",
          bySavedCard: "no cartão cadastrado",
          byBoleto: "no boleto",
          undoConfirm: "Confirmar: continuar no plano",
          keep: "Manter cancelamento",
          undone: "Cancelamento desfeito: o plano continua depois do ciclo pago.",
          locked: "Não dá mais para desfazer: o plano termina agora. Depois, contrate de novo em Faturamento.",
        },
        adequacy: {
          needed: "O plano novo não comporta tudo o que a Empresa usa. Escolha o que fica até {{date}}; sem a escolha, o acesso fica restrito a Faturamento na renovação.",
          chosen: "A escolha do que fica está feita e vale na renovação.",
          choose: "Escolher o que fica",
          review: "Ver ou mudar a escolha",
          notNeeded: "Não há o que escolher: tudo cabe no plano.",
          saved: "Escolha salva. Ela vale na renovação.",
          doneRestricted: "Pronto: o acesso voltou ao normal.",
          doneDue: "Pronto: a Empresa cabe no plano.",
        },
        adequacyDue: {
          title: "Escolha o que fica até {{date}}",
          text: "Uma condição do plano acabou, e a Empresa passou dos limites do {{plan}}. Criar mais do que passou está bloqueado. Até {{date}}, escolha o que fica: o que sair é arquivado e fica guardado por 12 meses. Sem a escolha, o acesso fica restrito até ela. Nada é apagado.",
          action: "Escolher o que fica",
        },
        restricted: {
          title: "Escolha o que fica para continuar",
          text: "A Empresa passou dos limites do {{plan}}. Até a escolha do que fica, só esta tela funciona para todos da Empresa. O que sair é arquivado e fica guardado por 12 meses.",
          action: "Escolher o que fica",
        },
        archived: {
          title: "Itens arquivados ({{count}})",
          info: "Itens que saíram na adequação a um plano menor. Ficam guardados por 12 meses e voltam com Restaurar, se o plano comportar.",
          show: "Ver arquivados",
          hide: "Ocultar",
          loading: "Carregando...",
          empty: "Nenhum item arquivado.",
          restore: "Restaurar",
          restoring: "Restaurando...",
          restored: "{{name}} restaurado.",
          account: "Conta {{name}}",
          accountArchived: "arquivada",
          dates: "arquivado em {{archived}}, guardado até {{until}}",
          types: {
            account: "Conta",
            whatsapp: "Número",
            crm_board: "Quadro",
            user: "Pessoa",
          },
        },
        usage: {
          title: "Uso deste mês",
          period: "De {{start}} a {{end}}",
          info: "Contam as mensagens que saem pela plataforma; as enviadas pelo celular não contam. O mês começa no dia em que o plano começou.",
          users: "Pessoas",
          internalChat: "Chat Interno",
          common: "Mensagens",
          ai: "Mensagens da IA",
          accounts: "Contas",
          whatsapps: "Números de WhatsApp",
          crmBoards: "Quadros do CRM",
          of: "{{used}} de {{limit}}",
          unlimited: "{{used}}, sem limite",
          notContracted: "não contratado",
        },
        invoices: {
          title: "Faturas",
          empty: "Nenhuma fatura ainda.",
          date: "Data",
          amount: "Valor",
          method: "Forma",
          status: "Situação",
          credit_card: "Cartão",
          pix: "Pix",
          boleto: "Boleto",
          openBoleto: "Abrir boleto",
          abandoned: "Cancelado: não pague",
          replaced: "Trocada pelo Pix",
          refund: "Pedir estorno",
          partlyRefunded: "Paga, {{amount}} estornado",
          statuses: {
            paid: "Paga",
            overpaid: "Paga",
            underpaid: "Paga a menos",
            pending: "Pendente",
            processing: "Processando",
            failed: "Não aprovada",
            canceled: "Cancelada",
            refunded: "Estornada",
            chargedback: "Contestada",
          },
        },
        refunds: {
          title: "Pedidos de estorno",
          item: "Estorno de {{amount}}, pedido em {{date}}",
          refusedReason: "Motivo da recusa: {{reason}}",
          canceledReason: "Motivo: {{reason}}",
          statuses: {
            requested: "Em análise",
            refused: "Recusado",
            approved: "Aprovado: devolução em andamento",
            refunding: "Aprovado: devolução em andamento",
            refunded: "Estornado",
            canceled: "Não devolvido",
          },
        },
      },
      refundDialog: {
        title: "Pedir estorno",
        subtitle: "A Sttelar analisa o pedido e responde aqui, em Faturamento.",
        close: "Fechar",
        summary: "Estorno de {{refundable}}, da cobrança de {{amount}} de {{date}}.",
        reason: "Motivo",
        reasonPlaceholder: "Ex.: a mensalidade foi cobrada duas vezes neste mês",
        hint: "Pelo menos 10 caracteres. Aprovado, o valor volta pela mesma forma de pagamento; no boleto, a Sttelar combina a devolução.",
        cancel: "Cancelar",
        send: "Pedir estorno",
        sent: "Pedido de estorno enviado.",
      },
      plansDialog: {
        stepsLabel: "Etapas da contratação",
        stepCustomize: "Personalizar assinatura",
        stepPayment: "Revisar e pagar",
        choosePlan: "Escolha o plano",
        perSeatMonth: "por licença, por mês",
        perks: {
          accounts: "{{count}} conta",
          accounts_plural: "{{count}} contas",
          accountsUnlimited: "Contas sem limite",
          whatsapps: "{{count}} número de WhatsApp",
          whatsapps_plural: "{{count}} números de WhatsApp",
          whatsappsUnlimited: "Números de WhatsApp sem limite",
          boards: "{{count}} quadro do CRM",
          boards_plural: "{{count}} quadros do CRM",
          boardsUnlimited: "Quadros do CRM sem limite",
        },
        bothPlans: "Nos dois planos: mensagens sem limite e {{ai}} mensagens da IA por mês.",
        seatsHint: "Uma por pessoa da equipe. Mínimo de {{min}}.",
        addons: "Complementos",
        optional: "Opcional",
        internalHint: "Conversa da equipe dentro do Sttelar Talk.",
        internalPrice: "{{price}} por licença, por mês",
        howManyInternal: "Quantas pessoas vão usar",
        aiPackHint: "O plano já inclui {{ai}} mensagens da IA por mês.",
        aiPackNoneShort: "Sem pacote",
        aiPackOptionShort: "{{messages}} mensagens por {{price}}",
        lineSeats: "{{count}} licença de {{price}}",
        lineSeats_plural: "{{count}} licenças de {{price}}",
        linePack: "{{messages}} mensagens da IA por mês",
        continue: "Continuar para pagamento",
        continueFree: "Continuar",
        continueNote: "Você revisa tudo antes de pagar.",
        back: "Voltar para a assinatura",
        billingIntro: "Quem paga as faturas. O cartão pede também o endereço de cobrança.",
        billingSaveFailed: "Não deu para salvar agora. Confira a conexão e tente de novo.",
        billingLoadFailed: "Não deu para carregar os dados agora.",
        freeChangeTitle: "Sem cobrança agora",
        freeChangeText: "A alteração vale na hora, e o valor novo vem na próxima fatura.",
        billingEdit: "Alterar",
        billingCancel: "Cancelar",
        billingLoading: "Carregando os dados…",
        billingAddress: "{{street}}, {{number}}, {{city}}, {{state}}",
        saveBilling: "Salvar e continuar",
        cvvHelp: "Os 3 números no verso do cartão. No American Express, são 4 na frente.",
        cardErrors: {
          number: "Confira o número do cartão.",
          holder: "Digite o nome como está no cartão.",
          expiry: "Validade inválida ou vencida.",
          cvv: "Digite os 3 ou 4 números.",
        },
        boletoDue: "O boleto vence em 3 dias.",
        quoteTodayLabel: "Hoje, por mês",
        doneNext: "A próxima cobrança é em {{date}}.",
        confirmEmail: {
          title: "Confirme seu e-mail para contratar",
          cta: "Confirme seu e-mail para continuar",
          text: "Enviamos um link para {{email}}. Depois de clicar nele, volte aqui: suas escolhas continuam salvas.",
        },
        trust: {
          recurringCard: "Cobrado todo mês no cartão. A próxima cobrança é daqui a um mês.",
          recurringBoleto: "Um boleto novo todo mês. O próximo é daqui a um mês.",
          activationCard: "O plano é liberado assim que o pagamento for confirmado, em geral em segundos.",
          activationInternal: "O Chat Interno é liberado assim que o pagamento for confirmado, em geral em segundos.",
          activationBoleto: "O plano é liberado quando o pagamento for confirmado, até 3 dias úteis depois de pago.",
          cancel: "Cancele em Faturamento, com a mensalidade em dia. Vale até o fim do mês já pago.",
          changeCard: "A alteração vale assim que o pagamento for confirmado, em geral em segundos.",
          changePix: "A alteração vale assim que o Pix for pago.",
          changeBoleto: "A alteração vale quando o pagamento for confirmado, até 3 dias úteis depois de pago.",
        },
        title: "Contratar plano",
        titleInternal: "Adicionar Chat Interno",
        titleChange: "Alterar plano",
        subtitleChange: "Você paga agora só a diferença até a renovação.",
        savedCard: "Cartão final {{last4}}",
        quoteNowHint_plural: "Pelos {{count}} dias até a renovação",
        savedCardBrand: "{{brand}} final {{last4}}",
        savedCardShort: "final {{last4}}",
        submitDisabled: "Pagar",
        failedBoletoChange: "Não deu para gerar o boleto agora. Tente de novo em alguns minutos ou pague de outro jeito.",
        pixVerifyingText: "Estamos conferindo se o Pix foi criado. Não altere de novo antes disso.",
        pixVerifyingSlow: "Está demorando. Você pode fechar: o Pix aparece em Faturamento quando estiver pronto.",
        pixExpiredAt: "Este Pix venceu às {{time}}.",
        quoteNowInfo: "A diferença da mensalidade pelos dias que faltam. A data da renovação não muda.",
        summaryTitleChange: "Como fica",
        quoteFreeValue: "Sem cobrança",
        quoteRetry: "Tentar de novo",
        quoteFailed: "Não deu para calcular o valor agora.",
        quoting: "Calculando…",
        quoteChanged: "O valor mudou desde o cálculo. Confira o valor novo e pague de novo.",
        chargeCard: "Cobrado agora no cartão {{card}}.",
        chargePix: "Pague agora, no Pix.",
        chargeBoleto: "Pague no boleto, com vencimento em 3 dias.",
        boletoMinChange: "Boleto só para valores a partir de {{min}}.",
        boletoRenewal: "Boleto só com 10 dias ou mais até a renovação.",
        planCurrent: "Atual",
        packCurrent: "(atual)",
        planChangeInfo: "Aqui só dá para aumentar. Para diminuir ou ir ao Basic, use Reduzir na renovação.",
        seatsHelpChange: "Uma licença por pessoa da equipe (a IA não ocupa licença). No mínimo as {{min}} licenças que a Empresa já tem.",
        pixValidUntil: "Vale até {{time}}",
        pixGenerating: "Gerando o código Pix",
        pixCode: "Código Pix",
        pixCopyManual: "Não deu para copiar. Selecione o código e copie.",
        pixCloseHint: "Pode fechar: o Pix continua em Faturamento até vencer.",
        pixExpiredTitle: "O Pix venceu",
        pixExpiredText: "O código não foi pago em 30 minutos. Gere outro para pagar.",
        pixAgain: "Gerar outro Pix",
        failedPixTitle: "Não deu para gerar o Pix",
        failedSavedCard: "O cartão {{card}} não foi aceito. Pague com Pix ou boleto.",
        payOtherWay: "Pagar de outro jeito",
        reviewTitle: "Pagamento em conferência",
        reviewText: "Recebemos o pagamento. A equipe da Sttelar vai conferir o pedido e falar com você.",
        doneChangeTitle: "Alteração feita",
        verifyingChange: "O pagamento não foi confirmado a tempo. Estamos conferindo se o pedido foi criado; não altere de novo antes disso.",
        pix: "Pix",
        savedCardNote: "Cobrado no cartão da assinatura.",
        pixNote: "O código Pix vale por 30 minutos.",
        quoteMonthly: "Por mês, a partir de {{date}}",
        quoteNothing: "Escolha o que aumentar",
        quoteNow: "A pagar agora",
        quoteNowHint: "Pelo dia que falta até a renovação",
        quoteFree: "O valor novo vem na próxima fatura.",
        submitFree: "Alterar agora",
        submitPix: "Gerar Pix de {{amount}}",
        pixTitle: "Pague com Pix",
        pixText: "Abra o app do banco e leia o QR Code, ou copie o código e cole no app.",
        pixQrAlt: "QR Code do Pix",
        pixCopy: "Copiar código Pix",
        pixCopied: "Código Pix copiado.",
        pixWaiting: "Aguardando o pagamento…",
        doneChange: "A Empresa agora tem {{what}}.",
        failedPix: "Tente de novo em instantes ou pague de outro jeito.",
        plan: "Plano",
        quoteToday: "Hoje: {{amount}} por mês",
        perSeat: "{{price}} por licença",
        seats: "Licenças",
        seatsHelp: "Uma licença por pessoa da equipe (a IA não ocupa licença). No mínimo {{min}}: o plano cobra pelo menos {{billed}}, e não dá para contratar menos do que as pessoas que a Empresa já tem.",
        internal: "Chat Interno",
        internalHelp: "A conversa da equipe dentro do Sttelar Talk, para quem tiver licença dele. Vai até o número de licenças do plano.",
        internalStarterHelp: "A conversa da equipe dentro do Sttelar Talk. O Starter tem até {{max}} pessoas.",
        aiPack: "Pacote de IA",
        aiPackHelp: "O pacote substitui as mensagens da IA do plano: o de 10 mil dá 10 mil por mês.",
        aiPackNone: "Sem pacote ({{ai}} mensagens da IA por mês)",
        aiPackOption: "{{messages}} mensagens por mês, {{price}}",
        decrease: "Diminuir",
        increase: "Aumentar",
        summaryTitle: "Resumo da assinatura",
        items: {
          plan: "{{plan}}, {{count}} licença",
          plan_plural: "{{plan}}, {{count}} licenças",
          internal: "Chat Interno, {{count}} licença",
          internal_plural: "Chat Interno, {{count}} licenças",
          pack: "Pacote de IA, {{messages}} mensagens",
        },
        total: "Total por mês",
        payment: "Forma de pagamento",
        card: "Cartão de crédito",
        boleto: "Boleto",
        boletoMin: "Boleto só a partir de {{min}} por mês.",
        cardNumber: "Número do cartão",
        cardHolder: "Nome impresso no cartão",
        cardExpiry: "Validade",
        cardCvv: "CVV",
        cardSecure: "Os dados do cartão vão direto para a Pagar.me. O Sttelar Talk não os recebe nem guarda.",
        cardInvalid: "Confira os dados do cartão.",
        cardServiceDown: "Não deu para falar com a operadora do cartão. Nada foi cobrado; tente de novo em instantes.",
        cardExpiryPlaceholder: "MM/AA",
        verifying: "Conferindo com a Pagar.me",
        verifyingText: "A Pagar.me não confirmou a tempo. Estamos conferindo se a assinatura foi criada; não contrate de novo antes disso.",
        failedBoletoTitle: "Não deu para gerar o boleto",
        boletoGenerating: "Gerando o boleto",
        boletoTextNoDate: "O plano muda quando o pagamento for confirmado.",
        submitCard: "Pagar {{amount}}",
        submitBoleto: "Gerar boleto de {{amount}}",
        cancel: "Cancelar",
        close: "Fechar",
        paying: "Confirmando o pagamento",
        payingText: "Isso costuma levar alguns segundos.",
        payingSlow: "A confirmação está demorando. Você pode fechar: o plano muda assim que o pagamento for confirmado.",
        doneTitle: "Pagamento confirmado",
        donePlan: "A Empresa está no {{plan}}.",
        doneInternal: "O Chat Interno está liberado para {{count}} pessoa.",
        doneInternal_plural: "O Chat Interno está liberado para {{count}} pessoas.",
        failedTitle: "Pagamento recusado",
        failedCard: "O cartão não foi aceito. Confira os dados ou use outro cartão.",
        failedBoleto: "Não deu para gerar o boleto agora. Tente de novo em alguns minutos ou pague no cartão.",
        retry: "Tentar de novo",
        boletoTitle: "Boleto gerado",
        boletoText: "Pague até {{date}}. O plano muda quando o pagamento for confirmado.",
        openRequest: "Já existe um pedido aguardando pagamento. Ele aparece em Faturamento.",
      },
      reductionDialog: {
        title: "Reduzir na renovação",
        subtitle: "Vale a partir da renovação. Até lá, a Empresa fica com o que tem hoje.",
        planInfo: "No Basic, contas, números de WhatsApp e quadros do CRM passam a ter limite.",
        seatsHelp: "No mínimo {{min}}: as pessoas que a Empresa já tem, e nunca menos que o mínimo cobrado do plano.",
        internalHelp: "No mínimo {{min}}: quem já usa o Chat Interno.",
        internalHelpStarter: "No Starter, o Chat Interno fica com pelo menos 1 licença: para tirar a última, use Cancelar Chat Interno.",
        from: "Por mês, a partir de {{date}}",
        nothing: "Escolha o que diminuir",
        note: "Nada é cobrado agora, e nada do mês já pago volta.",
        submit: "Agendar redução",
        blockersHint: "Depois de confirmar, você escolhe o que fica, até a renovação. O resto é arquivado, sem apagar nada.",
        doneTitle: "Redução agendada",
        doneText: "A partir de {{date}}, a Empresa terá {{what}}, por {{amount}} por mês. Até lá, nada muda.",
        blockers: {
          users: "Pessoas: a Empresa tem {{used}}, e o plano menor deixa {{limit}}.",
          internalChatUsers: "Chat Interno: {{used}} pessoas usam, e o plano menor deixa {{limit}}.",
          accounts: "Contas: a Empresa tem {{used}}, e o plano menor deixa {{limit}}.",
          whatsapps: "Números de WhatsApp: a Empresa tem {{used}}, e o plano menor deixa {{limit}}.",
          crmBoards: "Quadros do CRM: a Empresa tem {{used}}, e o plano menor deixa {{limit}}.",
        },
        blockersTitle: "O plano novo não comporta tudo o que a Empresa usa:",
        chooseNow: "Escolha o que fica até {{date}}. Sem a escolha, o acesso fica restrito a Faturamento na renovação.",
        chooseAction: "Escolher o que fica",
        chooseLater: "Escolher depois",
        cancel: {
          title: "Cancelar o {{plan}}",
          titleInternal: "Cancelar o Chat Interno",
          subtitle: "A assinatura para agora na Pagar.me. Nada é devolvido nem cobrado de novo.",
          whatHappens: "O que acontece",
          text: "O {{plan}} vale até o fim do ciclo já pago. Depois, a Empresa passa ao Starter, grátis, e o pacote de IA sai.",
          textInternal: "O Chat Interno vale até o fim do ciclo já pago e depois sai.",
          starterLimits: "No Starter: até {{users}} pessoas, {{accounts}} conta, {{whatsapps}} número de WhatsApp, {{boards}} quadro do CRM, {{common}} mensagens e {{ai}} da IA por mês.",
          keepInternal: "Manter o Chat Interno no Starter",
          keepInternalHint: "{{price}} por pessoa, por mês. A assinatura continua só com ele.",
          keepHelp: "Até {{max}} pessoas, o máximo do Starter.",
          until: "Por mês, depois de {{date}}",
          note: "Desfazer é contratar de novo: o mesmo plano, a partir do dia seguinte ao fim do ciclo, sem cobrar nada agora.",
          submit: "Confirmar cancelamento",
          doneTitle: "Plano cancelado",
          doneText: "A assinatura parou na Pagar.me. O {{plan}} vale até {{date}}; depois, a Empresa passa ao Starter.",
          doneTitleInternal: "Chat Interno cancelado",
          doneTextInternal: "A assinatura parou na Pagar.me. O Chat Interno vale até {{date}} e depois sai.",
        },
      },
      restrictedAccess: {
        title: "Acesso restrito",
        textAdmin: "A Empresa passou dos limites do plano. Para voltar a usar o Sttelar Talk, escolha em Faturamento o que fica no plano. Nada é apagado: o que sair fica guardado por 12 meses.",
        textMember: "A Empresa passou dos limites do plano, e o administrador precisa escolher o que fica, em Faturamento. Até lá, o Sttelar Talk fica em pausa para a equipe. Fale com o administrador da sua Empresa.",
        action: "Ir para Faturamento",
      },
      adequacyDialog: {
        title: "Escolha o que fica no {{plan}}",
        subtitle: "Até {{date}}. O que sair é arquivado na renovação e fica guardado por 12 meses.",
        subtitleRestricted: "Para voltar a usar o Sttelar Talk, escolha o que fica no plano. O que sair é arquivado agora e fica guardado por 12 meses.",
        subtitleDue: "Uma condição do plano acabou. Escolha o que fica até {{date}}: o que sair é arquivado agora e fica guardado por 12 meses.",
        close: "Fechar",
        accounts: "Contas",
        whatsapps: "Números de WhatsApp",
        crmBoards: "Quadros do CRM",
        users: "Pessoas",
        internalChat: "Quem mantém o Chat Interno",
        count: "{{used}} de {{limit}}",
        countFree: "{{used}}, sem limite",
        accountGoesWith: "Os números e os quadros dela saem junto.",
        goesWithAccount: "Sai junto com a conta",
        noWhatsapps: "Nenhum número de WhatsApp.",
        noBoards: "Sem quadro: o Principal nasce sozinho.",
        defaultBoard: "Padrão",
        boardsNote: "A conta que ficar sem quadro ganha o Principal sozinha, e ele conta no limite.",
        you: "Você",
        admin: "Administrador",
        userWithoutAccount: "Sem conta que fica: sai junto",
        needAdmin: "Pelo menos um administrador precisa ficar.",
        internalOnly: "Só usa o Chat Interno: para tirar, a pessoa sai.",
        sharedPerson: "Também está em outra Empresa: o Chat Interno dela não muda por aqui.",
        summaryTitle: "No {{plan}}",
        limits: {
          users: "Pessoas",
          internalChatUsers: "Chat Interno",
          accounts: "Contas",
          whatsapps: "Números",
          crmBoards: "Quadros",
        },
        leavingTitle: "Sai na renovação",
        leavingNow: "Sai agora",
        leaving: {
          accounts: "{{count}} conta",
          accounts_plural: "{{count}} contas",
          whatsapps: "{{count}} número",
          whatsapps_plural: "{{count}} números",
          crmBoards: "{{count}} quadro",
          crmBoards_plural: "{{count}} quadros",
          users: "{{count}} pessoa",
          users_plural: "{{count}} pessoas",
          internalChatOff: "{{count}} sem o Chat Interno",
          nothing: "Nada",
        },
        keepNote: "Nada é apagado: o que sai fica guardado por 12 meses e volta com Restaurar, se o plano comportar.",
        overHint: "Desmarque até tudo caber nos limites do plano.",
        save: "Salvar escolha",
        saveRestricted: "Concluir e liberar o acesso",
        saveDue: "Concluir a escolha",
      },
      planLimit: {
        title: "O plano chegou ao limite",
        used: {
          users: "A Empresa usa {{used}} de {{limit}} pessoas do plano.",
          internalChat: "A Empresa usa {{used}} de {{limit}} licenças de Chat Interno.",
          accounts: "A Empresa usa {{used}} de {{limit}} contas do plano.",
          whatsapps: "A Empresa usa {{used}} de {{limit}} números de WhatsApp do plano.",
          crmBoards: "A Empresa usa {{used}} de {{limit}} quadros do CRM do plano.",
        },
        generic: "A Empresa chegou ao limite do plano.",
        starterOffer: "No Basic ou no Pro, você escolhe quantas licenças quer e tem mais contas, números e quadros.",
        internalOffer: "O Chat Interno custa {{price}} por pessoa, por mês.",
        otherPlan: "Para ter mais, fale com o suporte da Sttelar.",
        askAdmin: "Peça ao administrador da Empresa para mudar o plano.",
        changeOffer: "Aumente as licenças: você paga agora só a diferença até a renovação.",
        changeOfferPro: "No Pro, contas, números e quadros não têm limite. Você paga agora só a diferença até a renovação.",
        paymentPending: "Há uma mensalidade pendente. Regularize em Faturamento (ou fale com o suporte) antes de mudar o plano.",
        reductionScheduled: "Há uma redução agendada para a renovação. Para aumentar agora, desfaça a redução em Faturamento.",
        cancellationScheduled: "Há um cancelamento agendado: até o fim do ciclo pago, criar vale pelo Starter. Para continuar no plano, desfaça o cancelamento em Faturamento.",
        seeOptions: "Ver opções",
        pendingRequest: "Há um pedido aguardando pagamento. Ele está em Faturamento.",
        openBilling: "Ver em Faturamento",
        seePlans: "Ver planos",
        addInternal: "Adicionar Chat Interno",
        notNow: "Agora não",
        ok: "Entendi",
      },
      companySetup: {
        steps: {
          company: "Empresa",
          account: "Conta",
          ai: "IA",
          whatsapp: "WhatsApp",
          team: "Equipe",
        },
        progressLabel: "Etapas da configuração",
        leave: "Sair",
        company: {
          title: "Como se chama sua empresa?",
          subtitle: "É o nome que a sua equipe vai ver no Sttelar Talk.",
          label: "Nome da empresa",
          placeholder: "Ex.: Loja Azul Celulares",
          submit: "Continuar",
        },
        account: {
          title: "E o nome da primeira conta?",
          subtitle: "A conta reúne os números de WhatsApp, a equipe e os atendimentos de uma loja ou unidade. Se você tem uma só, pode usar o nome dela.",
          label: "Nome da conta",
          placeholder: "Ex.: Matriz",
          info: "Depois dá para criar outras contas, uma para cada loja ou unidade.",
          submit: "Criar conta",
          back: "Mudar o nome da empresa",
        },
        whatsapp: {
          title: "Conecte o WhatsApp da empresa",
          subtitle: "Com o número conectado, as conversas chegam aqui e a IA já pode responder.",
          connect: "Conectar agora",
          connectAnother: "Conectar outro número",
          later: "Fazer depois",
          next: "Continuar",
          showQr: "Mostrar o QR code",
          info: "No celular da empresa, abra o WhatsApp, vá em Aparelhos conectados e leia o QR code.",
          noPermission: "Quem cuida das conexões conecta o número depois.",
          verifyFirst: "Confirme seu e-mail para conectar o WhatsApp. O link foi para {{email}}.",
          resend: "Reenviar o e-mail",
          alreadyConfirmed: "Já confirmei",
          status: {
            CONNECTED: "Conectado",
            qrcode: "Falta ler o QR code",
            OPENING: "Conectando…",
            PAIRING: "Conectando…",
            TIMEOUT: "Desconectado",
            DISCONNECTED: "Desconectado",
          },
        },
        team: {
          pending: "Convite enviado",
          title: "Convide quem vai atender com você",
          subtitle: "A pessoa recebe um e-mail, cria a senha e já entra na sua conta.",
          email: "E-mail",
          emailPlaceholder: "nome@suaempresa.com.br",
          profile: "Perfil",
          profileInfo: "O administrador também configura a conta: equipe, conexões e IA.",
          profiles: {
            user: "Atendente",
            admin: "Administrador",
          },
          send: "Convidar",
          sent: "Convite enviado para {{email}}.",
          invited: "Convites enviados",
          verifyFirst: "Confirme seu e-mail para mandar convites. O link foi para {{email}}.",
          resend: "Reenviar o e-mail",
          resent: "Enviamos de novo. Confira a caixa de entrada.",
          emailInvalid: "Digite um e-mail válido.",
          later: "Fazer depois",
          next: "Continuar",
          noPermission: "Quem cuida da equipe manda os convites depois.",
        },
        done: {
          teamJoined: "A equipe já entrou",
          title: "Tudo pronto",
          subtitle: "Sua empresa já está no Sttelar Talk. O que ficou para depois aparece no painel.",
          aiOn: "Ligada",
          aiOff: "Ainda não ligada",
          whatsappOn: "Conectado",
          whatsappOff: "Ainda não conectado",
          teamNone: "Ninguém convidado ainda",
          teamOne: "1 convite enviado",
          teamMany: "{{count}} convites enviados",
          submit: "Ir para o painel",
          submitContract: "Contratar o {{plan}}",
        },
      },
      aiSetup: {
        confirmEmail: {
          title: "Primeiro, confirme seu e-mail",
          text: "Enviamos um link para {{email}}. A IA é liberada assim que você clicar nele.",
          check: "Já confirmei",
          notYet: "Ainda não recebemos a confirmação. Clique no link do e-mail e tente de novo.",
          resend: "Reenviar o e-mail",
          resent: "Enviamos de novo. Confira a caixa de entrada e o lixo eletrônico.",
        },
        step: "Passo {{current}} de {{total}}",
        reviewNote: "Você revisa tudo antes de ativar a IA.",
        skip: "Pular por agora",
        close: "Fechar",
        source: {
          title: "Ensine sua IA sobre o seu negócio",
          subtitle: "Cole o site da empresa e a IA monta a base de conhecimento sozinha.",
          subtitleDescription: "Conte como funciona o negócio e a IA organiza a base de conhecimento.",
          siteTitle: "Site da empresa",
          siteText: "A IA lê as páginas do site e separa o que importa para atender.",
          siteLabel: "Endereço do site",
          siteHint: "Ela lê só as páginas desse site.",
          siteRequired: "Informe o endereço do site.",
          siteSubmit: "Montar com o site",
          or: "ou",
          noSite: "Não tenho site, vou descrever o negócio",
          haveSite: "Tenho site",
          descriptionTitle: "Conte sobre o negócio",
          descriptionText: "Escreva como você explicaria a empresa para um atendente novo.",
          descriptionLabel: "Sobre o negócio",
          descriptionPlaceholder: "O que vocês vendem ou fazem, onde atendem, horários, formas de pagamento, entrega, trocas...",
          descriptionCountShort: "{{count}} de pelo menos {{min}} caracteres",
          descriptionCount: "{{count}} caracteres",
          descriptionSubmit: "Montar com a descrição",
          learnTitle: "O que a IA vai aprender",
        },
        learn: {
          about: { name: "Sobre a empresa", text: "O que vocês fazem e como atendem." },
          offerings: { name: "Produtos e serviços", text: "O que o cliente pode comprar ou pedir." },
          hours: { name: "Horários", text: "Quando a empresa atende." },
          faq: { name: "Perguntas frequentes", text: "As dúvidas que mais chegam, com resposta." },
          contact: { name: "Contato e endereços", text: "Telefones, e-mails e lojas." },
          policies: { name: "Políticas", text: "Trocas, garantia, entrega e pagamento." },
        },
        preparing: {
          title: "Preparando sua IA",
          failedTitle: "Não deu para montar a base",
          subtitle: {
            site: "Lendo o site e organizando tudo para ela responder seus clientes.",
            description: "Organizando o que você contou para ela responder seus clientes.",
          },
          stages: {
            readSite: "Lendo o site",
            readDescription: "Lendo a descrição",
            offerings: "Separando produtos e serviços",
            faq: "Montando as perguntas frequentes",
            review: "Revisando a base",
          },
          status: { done: "Feito", active: "Em andamento", queued: "Na fila" },
          eta: { site: "Costuma levar menos de 1 minuto.", description: "Costuma levar alguns segundos." },
          retry: "Tentar de novo",
          describeInstead: "Descrever o negócio",
        },
        learned: {
          cardTitle: "O que ela aprendeu",
          viewBase: "Ver e editar a base",
          nameLabel: "Nome da IA",
          defaultName: "Assistente",
          stepDone: "Aprendizado concluído",
          heroTitle: "Pronto! Sua IA acaba de aprender sobre a {{name}} 🎉",
          heroText: "Veja o que ela descobriu e converse com ela antes de colocá-la para atender seus clientes.",
          yourBusiness: "sua empresa",
          findings: { about: "Sobre a empresa", services: "Serviços e produtos", brands: "Marcas atendidas", highlights: "Informações úteis" },
          nothingFound: "Ela não achou um resumo do negócio. Veja e complete a base.",
          missing: { site: "O site não trouxe {{items}}. Complete a base para ela responder melhor.", description: "A descrição não trouxe {{items}}. Complete a base para ela responder melhor." },
          missingItems: { hours: "o horário de atendimento", contact: "os contatos e endereços", policies: "as políticas (trocas, garantia e pagamento)" },
          and: "e",
          complete: "Completar a base",
        },
        meet: {
          title: "Sua assistente quer se apresentar!",
          hello: "Oi! Aqui é {{name}}, assistente virtual de {{business}}.",
          helloDefault: "Oi! Sou a assistente virtual de {{business}}.",
          helpFallback: "Posso tirar as dúvidas dos seus clientes sobre o que aprendi.",
          ask: "Pergunte como se fosse um cliente:",
          free: "Escrever minha própria pergunta",
          preparing: "Preparando sua assistente...",
        },
        activate: {
          title: "Tudo pronto para {{name}} atender?",
          titleDefault: "Tudo pronto para a sua assistente atender?",
          what: "Ao ativar, ela responde na hora as conversas novas do WhatsApp e chama sua equipe quando precisar.",
          whenConnected: "O WhatsApp ainda não está conectado: ao ativar, ela começa a responder assim que você conectar.",
          undo: "Ela fica em Fluxos, no \"Atendimento com IA\", onde dá para desativar quando quiser.",
          cta: "Ativar minha IA",
          skip: "Continuar sem ativar",
          saved: "Tudo fica salvo. Dá para ativar depois.",
          savedAskEditor: "Tudo fica salvo. Quem pode editar os Fluxos ativa a IA.",
        },
        knowledge: {
          title: "Base de conhecimento",
          subtitle: "É o que a IA usa para responder. Ajuste o que quiser.",
          count: "{{count}} caracteres",
          pages: "Páginas lidas",
          cancel: "Cancelar",
          save: "Salvar",
        },
        test: {
          title: "Converse com {{name}}",
          subtitle: "Escreva como se fosse um cliente. Nada daqui vai para ninguém.",
          emptyTitle: "Faça uma pergunta",
          emptyText: "Comece por uma destas ou escreva a sua.",
          suggestions: {
            howItWorks: "Como funciona o atendimento?",
            services: "Quais serviços vocês oferecem?",
            hours: "Qual o horário de atendimento?",
          },
          placeholder: "Escreva uma mensagem",
          send: "Enviar",
          thinking: "{{name}} está digitando...",
          titleDefault: "Converse com a sua assistente",
          thinkingDefault: "Sua assistente está digitando...",
          restart: "Recomeçar",
          error: "Não deu para responder agora. Tente de novo.",
          praise: "É assim que sua IA pode atender seus clientes!",
          wrong: "Viu algo errado na resposta?",
          fix: "Ajustar a base",
        },
        errors: { generic: "Não deu para concluir agora. Tente de novo." },
      },
      auth: {
        language: "Idioma",
        showPassword: "Mostrar senha",
        hidePassword: "Esconder senha",
        backToLogin: "Voltar para o login",
        version: "Versão {{version}}",
        checkEmailTitle: "Confira seu e-mail",
        invalidLinkTitle: "Este link não vale mais",
        notArrived: "Não chegou? Veja a caixa de spam ou peça de novo.",
        resend: "Reenviar e-mail",
        resent: "Enviamos de novo. Confira a caixa de entrada.",
        passwordHint: "Use pelo menos 8 caracteres.",
        fields: {
          name: "Nome completo",
          email: "E-mail",
          password: "Senha"
        },
        errors: {
          generic: "Não deu certo agora. Tente de novo em instantes."
        },
        showcase: {
          label: "Sobre o Sttelar Talk",
          headline: "Transforme seu WhatsApp em uma central de atendimento inteligente.",
          lead: "Reúna seus números, sua equipe e uma IA que responde seus clientes automaticamente. Tudo em um só lugar.",
          preview: {
            customer: "Oi! Meu ar-condicionado parou de gelar. Vocês fazem esse conserto?",
            aiName: "Assistente",
            aiTag: "IA",
            ai: "Fazemos sim! 😊 Seu aparelho ainda está na garantia ou já está fora dela?",
            customer2: "Está fora da garantia. Posso agendar uma visita?",
            handoff: "A IA transferiu para Ana, do Suporte",
            humanName: "Ana",
            human: "Oi, Carla! 😊 Posso verificar os horários disponíveis para agendarmos sua visita.",
            statusAi: "IA atendendo",
            statusHuman: "Com Ana",
            otherLast1: "Obrigado, deu certo!",
            otherLast2: "Pode confirmar o horário da visita?"
          },
          benefits: {
            together: { title: "Todas as conversas. Uma só tela.", text: "Organize seus números de WhatsApp, atendentes e clientes em um único lugar." },
            ai: { title: "Sua IA e sua equipe trabalhando juntas.", text: "A IA responde automaticamente e encaminha conversas para os atendentes quando necessário." },
            free: { title: "Comece grátis. Cresça no seu ritmo.", text: "Experimente o Sttelar Talk com o plano Starter e evolua conforme seu negócio crescer." }
          }
        },
        login: {
          title: "Entre na sua conta",
          subtitle: "Use o e-mail e a senha do seu cadastro.",
          remember: "Manter conectado",
          forgot: "Esqueceu a senha?",
          noAccount: "Novo no Sttelar Talk?",
          createAccount: "Comece grátis",
          plans: "Conheça os planos"
        },
        signup: {
          title: "Crie sua conta",
          subtitle: "Comece grátis no Starter, sem cartão.",
          planChosen: "Você escolheu o {{plan}}. A contratação abre depois do cadastro.",
          planLater: "Você escolheu o {{plan}}. A conta começa grátis no Starter, e a contratação do {{plan}} é com a Sttelar.",
          planMessage: "Olá! Quero contratar o {{plan}} do Sttelar Talk.",
          talkToSales: "Falar com a Sttelar",
          closedMessage: "Olá! Quero começar a usar o Sttelar Talk.",
          submit: "Criar conta",
          haveAccount: "Já tem uma conta?",
          login: "Entrar",
          sent: "Enviamos um link para {{email}}. Abra o link para confirmar seu e-mail.",
          closedTitle: "Cadastro fechado",
          closedText: "O cadastro de novas contas está fechado no momento. Fale com a Sttelar para começar.",
          limited: "Muitas tentativas por aqui agora. Tente de novo em {{minutes}} min.",
          fixEmail: "Corrigir e-mail",
          legalPrefix: "Li e aceito os",
          legalTerms: "Termos de Uso",
          legalAnd: "e a",
          legalPrivacy: "Política de Privacidade",
          errors: {
            name: "Informe seu nome completo."
          }
        },
        forgot: {
          title: "Esqueceu a senha?",
          subtitle: "Informe o e-mail da sua conta. Enviamos um link para criar uma nova senha.",
          submit: "Enviar link",
          sent: "Se houver uma conta com {{email}}, o link chega em instantes. Ele vale por 1 hora."
        },
        reset: {
          title: "Crie uma nova senha",
          password: "Nova senha",
          confirm: "Repita a nova senha",
          submit: "Salvar nova senha",
          mismatch: "As duas senhas não são iguais.",
          invalid: "Ele já foi usado ou passou do prazo. Peça um novo para criar sua senha.",
          newLink: "Pedir um novo link",
          doneTitle: "Senha alterada",
          done: "Pronto. Use a nova senha para entrar. Por segurança, as outras sessões foram encerradas."
        },
        verify: {
          failedTitle: "Não deu para confirmar agora",
          retry: "Tentar de novo",
          checking: "Confirmando seu e-mail...",
          okTitle: "E-mail confirmado",
          ok: "Seu e-mail está confirmado. Digite sua senha para entrar. Não lembra dela ou não criou esta conta? Use \"Esqueceu a senha?\".",
          otherAccount: "O e-mail {{email}} está confirmado. Você continua conectado como {{current}}.",
          goToApp: "Ir para o sistema",
          invalid: "Ele já foi usado, passou do prazo ou foi trocado por um mais novo. Peça outro abaixo.",
          resend: "Enviar um novo link",
          resent: "Se o e-mail ainda precisar de confirmação, enviamos um link novo."
        },
        banner: {
          text: "Confirme seu e-mail para conectar o WhatsApp, ligar a IA, convidar pessoas, contratar e criar links. Enviamos o link para {{email}}.",
          sent: "Enviamos um novo link para {{email}}.",
          close: "Fechar aviso"
        },
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        token: "Token",
      },
      connections: {
        status: {
          connected: "Conectado",
          disconnected: "Desconectado",
          opening: "Conectando",
          starting: "Iniciando…",
          qrcode: "QR Code",
          scanQr: "Leia o QR Code",
          timeout: "Timeout",
          failed: "Falha na conexão",
          stopped: "Conexão parada",
          pairing: "Pareando",
          pending: "Pendente",
        },
        adminTools: {
          tooltip: "Ferramentas de Super Admin",
          eyebrow: "Super Admin · Ferramentas da conexão",
          close: "Fechar",
          provider: {
            waha: "WhatsApp Web",
            "meta-api": "WhatsApp Business API",
            livechat: "LiveChat",
          },
          nav: {
            tickets: "Excluir conversas",
            contacts: "Excluir contatos",
            resolve: "Resolver conversas",
            history: "Histórico",
            note: "Exclusões não têm volta. Tudo fica registrado no histórico com o seu usuário.",
          },
          status: {
            open: "Em atendimento",
            pending: "Aguardando",
            closed: "Resolvidas",
          },
          period: {
            today: "Hoje",
            "7d": "Últimos 7 dias",
            "30d": "Últimos 30 dias",
            custom: "Personalizado",
            all: "Todo o período",
            from: "De",
            to: "Até",
            customRange: "{{from}} a {{to}}",
          },
          summary: {
            withGroups: "com grupos",
            withoutGroups: "sem grupos",
          },
          cleanup: {
            tickets: {
              intro: "Apaga conversas desta conexão, com as mensagens e os arquivos delas. Os contatos continuam cadastrados.",
              statusTitle: "Status das conversas",
              periodTitle: "Início da conversa",
              periodHint: "Conta a data em que a conversa começou.",
              includeGroups: "Incluir conversas de grupo",
              pickStatus: "marque ao menos um status",
              note: "Roda em segundo plano, em lotes. Conversas que mudarem depois da confirmação (mensagem nova, reabertura, transferência) são preservadas. Não dá para desfazer.",
              submit: "Excluir {{n}} conversa",
              submit_plural: "Excluir {{n}} conversas",
            },
            contacts: {
              intro: "Apaga os contatos que têm conversa nesta conexão, com todas as conversas, mensagens e arquivos deles — inclusive as conversas em outras conexões.",
              periodTitle: "Cadastro do contato",
              periodHint: "Conta a data em que o contato foi cadastrado.",
              includeGroups: "Incluir contatos de grupo",
              note: "Roda em segundo plano, em lotes. Contatos com conversa nova ou alterada depois da confirmação são preservados. Não dá para desfazer.",
              submit: "Excluir {{n}} contato",
              submit_plural: "Excluir {{n}} contatos",
            },
            resolve: {
              intro: "Resolve as conversas desta conexão que estão em atendimento ou aguardando, sem mensagem de encerramento nem pedido de avaliação: o cliente não é avisado.",
              periodTitle: "Início da conversa",
              periodHint: "Conta a data em que a conversa começou.",
              includeGroups: "Incluir conversas de grupo",
              note: "Roda em segundo plano, em lotes. Conversas que mudarem depois da confirmação (mensagem nova, aceite, transferência) são preservadas. Se o cliente escrever de novo, a conversa volta como sempre.",
              submit: "Resolver {{n}} conversa",
              submit_plural: "Resolver {{n}} conversas",
            },
            groupsFound: "{{n}} com esses filtros",
            previewTitle: "Prévia",
            calculating: "Calculando…",
            computedAt: "Calculada às {{time}}",
            refresh: "Recalcular",
            range: "Período considerado: {{from}} até {{to}}",
            rangeAll: "Período considerado: todo o histórico",
            invalidDates: "Escolha as datas de início e fim (a final não pode passar de hoje).",
            recalculated: "A prévia foi recalculada — confira os números e confirme de novo.",
          },
          stats: {
            tickets: "Conversas",
            messages: "Mensagens",
            media: "Arquivos de mídia",
            contacts: "Contatos",
            contactsSplit: "só desta conexão: {{exclusive}} · compartilhados: {{shared}}",
            ticketsHere: "nesta conexão: {{n}}",
            messagesInGroups: "enviadas por eles em grupos: {{n}}",
          },
          warnings: {
            liveTickets: "Conversas em atendimento ou aguardando somem da tela dos atendentes assim que a exclusão chegar nelas.",
            sharedContacts: "Contatos que também conversam por outras conexões: {{shared}}. As conversas deles lá também serão apagadas ({{tickets}} no total):",
            otherConnection: "{{name}} — conversas: {{tickets}}, em atendimento ou aguardando: {{openOrPending}}",
            noConnection: "Sem conexão",
            liveTicketsHere: "Conversas em atendimento ou aguardando nesta conexão que serão apagadas: {{n}}.",
          },
          confirm: {
            eyebrow: "Ação irreversível",
            createTitle: "Confirmar exclusão",
            resumeTitle: "Retomar operação",
            intro: "Isto vai apagar definitivamente:",
            resumeIntro: "A operação continua de onde parou, com os mesmos filtros:",
            password: "Sua senha",
            phraseBefore: "Digite",
            phraseAfter: "para confirmar",
            cancel: "Cancelar",
            submit: "Excluir definitivamente",
            resumeSubmit: "Retomar",
            resolve: {
              eyebrow: "Ação em massa",
              createTitle: "Confirmar resolução",
              intro: "Isto vai resolver, sem avisar os clientes:",
              submit: "Resolver conversas",
            },
            summary: {
              tickets: "Conversas: {{n}} ({{filters}})",
              contacts: "Contatos: {{n}}, {{shared}} compartilhados com outras conexões ({{filters}})",
              contactTickets: "Conversas: {{n}}, {{other}} delas em outras conexões",
              messages: "Mensagens: {{messages}} · arquivos de mídia: {{media}}",
              resumeProgress: "Já processados: {{processed}} de {{total}}",
              previewAt: "Números da prévia das {{time}}",
            },
          },
          progress: {
            heading: {
              delete_tickets: "Exclusão de conversas",
              delete_contacts: "Exclusão de contatos",
              resolve_tickets: "Resolução de conversas",
            },
            count: "{{done}} de {{total}}",
            barLabel: "Progresso da exclusão",
            deletedTickets: "Conversas apagadas",
            deletedContacts: "Contatos apagados",
            skippedTickets: "Conversas preservadas",
            skippedContacts: "Contatos preservados",
            messages: "Mensagens apagadas",
            media: "Arquivos de mídia",
            queued: "Na fila — começa assim que a operação anterior do sistema terminar.",
            canceling: "Terminando o lote atual. O que já foi apagado não volta.",
            skippedNoteTickets: "Conversas preservadas: mudaram depois da confirmação ou deixaram de bater com os filtros.",
            skippedNoteContacts: "Contatos preservados: tiveram conversa nova ou alterada depois da confirmação.",
            failedHint: "A operação parou por erro. Dá para retomar de onde parou.",
            startedBy: "Iniciada por {{user}} em {{date}}",
            finishedAt: "terminou em {{date}}",
            resumedBy: "retomada por {{user}} em {{date}}",
            cancelRequestedBy: "cancelamento pedido por {{user}} em {{date}}",
            cancel: "Cancelar operação",
            cancelTitle: "Cancelar a exclusão?",
            cancelMessage: "O lote em andamento termina e a operação para. O que já foi apagado não volta.",
            resume: "Retomar",
            newCleanup: "Nova exclusão",
            resolve: {
              barLabel: "Progresso da resolução",
              processed: "Conversas resolvidas",
              canceling: "Terminando o lote atual. As conversas já resolvidas continuam resolvidas.",
              cancelTitle: "Cancelar a resolução?",
              cancelMessage: "O lote em andamento termina e a operação para. As conversas já resolvidas continuam resolvidas.",
              newCleanup: "Nova resolução",
            },
            keepRunning: "Voltar",
          },
          statusLabel: {
            pending: "Na fila",
            running: "Em andamento",
            cancel_requested: "Cancelando",
            canceled: "Cancelada",
            completed: "Concluída",
            failed: "Falhou",
            denied: "Negada",
          },
          history: {
            intro: "Tudo o que foi feito nesta conexão pelas ferramentas de Super Admin, inclusive as tentativas negadas.",
            empty: "Nenhuma operação nesta conexão ainda.",
            loadMore: "Carregar mais",
            by: "{{user}} · {{date}}",
            countsTickets: "Conversas: {{processed}} de {{total}}",
            countsContacts: "Contatos: {{processed}} de {{total}}",
            detailsTickets: "preservadas: {{skipped}} · mensagens: {{messages}}",
            detailsContacts: "preservados: {{skipped}} · mensagens: {{messages}}",
            detailsResolve: "preservadas: {{skipped}}",
            denied: {
              ERR_INVALID_PASSWORD: "Senha incorreta",
              ERR_INVALID_CONFIRMATION_PHRASE: "Frase incorreta",
            },
            operation: {
              delete_tickets: "Excluir conversas",
              delete_contacts: "Excluir contatos",
              resolve_tickets: "Resolver conversas",
            },
          },
          errors: {
            generic: "Não foi possível concluir. Tente de novo.",
          },
        },
        passkey: {
          pill: "Passkey",
          pillConfirm: "Confirmar passkey",
          finish: "Concluir passkey",
        },
        livechat: {
          tooltip: "LiveChat",
          active: "Ativo",
          inactive: "Inativo",
          copyCode: "Copiar código",
          preview: "Pré-visualizar",
          enable: "Ativar widget",
          disable: "Desativar widget",
          codeCopied: "Código de instalação copiado!",
          enabled: "Widget ativado",
          disabled: "Widget desativado",
        },
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
              "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
                "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
                "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
                "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        schedules: {
          title: "Horário de atendimento",
          description: "Ligado, esta conexão usa um horário próprio em vez do horário da empresa.",
          custom: "Horário personalizado",
          save: "Salvar horários",
          saveFirst: "Salve a conexão antes de configurar o horário personalizado.",
          saved: "Horários atualizados.",
          restored: "Horário da empresa restaurado.",
        },
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          expiresTicket: {
            number: "Informe um número válido",
            integer: "Use apenas números inteiros",
            min: "Valor mínimo é 0 (desligado)",
            max: "Valor máximo é 43200 minutos (30 dias)",
          },
          expiresInactiveMessage: {
            max: "Mensagem muito longa (máx 1000 caracteres)",
          },
          greetingAcceptedMessage: {
            max: "Mensagem muito longa (máx 1000 caracteres)",
          },
          livechatTitle: {
            required: "Título do widget é obrigatório",
            max: "Título muito longo (máx 40 caracteres)",
          },
          livechatColor: {
            invalid: "Cor inválida (use o formato #RRGGBB)",
          },
          livechatDefaultCountryCode: {
            invalid: "Use o formato +55",
          },
          livechatAllowedDomains: {
            required: "Informe pelo menos um domínio autorizado",
          },
        },
        livechat: {
          sectionAppearance: "Aparência do widget",
          sectionBehavior: "Comportamento",
          installTitle: "Código de instalação",
          installHelp: "Cole este código antes do fechamento da tag body do seu site.",
          preview: "Pré-visualizar",
          createdCopyCode: "Conexão criada! Copie o código de instalação abaixo.",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "Avaliações",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          livechatTitle: "Título do widget",
          livechatSubtitle: "Subtítulo",
          livechatButtonText: "Texto do botão",
          livechatColor: "Cor principal",
          livechatWelcomeMessage: "Mensagem de boas-vindas",
          livechatPhoneRequired: "Exigir telefone",
          livechatDefaultCountryCode: "DDI padrão",
          livechatDefaultCountryCodeHelp: "Ex.: +55",
          livechatDefaultQueue: "Fila padrão",
          livechatNoQueue: "Sem fila",
          livechatAllowedDomains: "Domínios autorizados",
          livechatAllowedDomainsHelp: "Um domínio por linha (ex.: www.seusite.com.br). O widget só funciona nos domínios listados.",
          livechatEnabled: "Widget ativo",
          name: "Nome",
          default: "Padrão",
          sendIdQueue: "Fila",
          timeSendQueue: "Redirecionar para fila em X minutos",
          queueRedirection: "Redirecionamento de Fila",
          outOfHoursMessage: "Mensagem de fora de expediente",
          queueRedirectionDesc:
              "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          prompt: "Prompt",
          queue: "Fila de Transferência",
          timeToTransfer: "Transferir após x (minutos)",
          metaInfo: "Informe as credenciais do app no Facebook Developers para usar a API oficial do WhatsApp.",
          metaAccessToken: "Access Token",
          metaPhoneNumberId: "Phone Number ID",
          metaBusinessAccountId: "Business Account ID (opcional)",
          metaAppId: "App ID (opcional)",
          metaAppSecret: "App Secret (chave secreta do app)",
          metaAppSecretHelp:
            "Facebook Developers → Configurações do app → Básico → Chave Secreta do Aplicativo. Valida a assinatura dos webhooks. Em branco, os webhooks são aceitos sem verificação.",
          metaWebhookToken: "Webhook Verify Token",
          metaApiVersion: "Versão da Graph API",
          //maxUseBotQueues: "Enviar bot x vezes",
          //timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          autoCloseTitle: "Encerramento automático",
          autoCloseHelp: "Fecha a conversa quando o cliente não responder ao atendente após o tempo definido. A mensagem abaixo é enviada antes do fechamento.",
          expiresTicket: "Tempo de inatividade",
          expiresTicketUnit: "minutos",
          expiresInactiveMessage: "Mensagem de encerramento",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          greetingAcceptedTitle: "Saudação ao aceitar ticket",
          greetingAcceptedMessage: "Mensagem ao aceitar atendimento",
          greetingAcceptedMessagePlaceholder: "Ex.: {{ms}} *{{name}}*, meu nome é *{{userName}}* e vou prosseguir com seu atendimento!",
          greetingAcceptedMessageHelp: "Enviada quando o atendente aceita um ticket pendente. Em branco, usa o texto padrão.",
          sendTransferQueueMessageTitle: "Mensagem ao transferir de fila",
          sendTransferUserMessageTitle: "Mensagem ao transferir de atendente",
          sendTransferQueueAndUserMessageTitle: "Mensagem ao transferir fila e atendente",
          integration: "Integrações"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      passkeyModal: {
        title: "Conectar com Passkey",
        subtitle:
          "O WhatsApp pediu uma passkey para vincular este número. A assinatura acontece no seu navegador, na página do WhatsApp Web — nenhuma senha ou credencial passa pelo Sttelar Talk.",
        extChecking: "Procurando a extensão…",
        extPresent: "Extensão detectada",
        extAbsent:
          "Para assinar a passkey você precisa da extensão oficial do WAHA no seu navegador. Ela abre o WhatsApp Web, você confirma com biometria/PIN e pronto.",
        installChrome: "Instalar no Chrome",
        installFirefox: "Instalar no Firefox",
        recheck: "Já instalei, verificar",
        signButton: "Assinar com passkey",
        signing: "Abrindo o WhatsApp Web…",
        submitting: "Enviando assinatura…",
        signHintTab:
          "Uma aba do WhatsApp Web foi aberta. Clique no botão e confirme com sua biometria/PIN para assinar.",
        fallbackToggle: "Não consegue instalar a extensão? Usar o console (DevTools)",
        fallbackTitle: "Assinar pelo console do navegador",
        fallbackStep1: "Abra web.whatsapp.com (logado) e pressione F12 → aba Console.",
        fallbackStep2: "Cole o script abaixo, tecle Enter e confirme com sua biometria/PIN.",
        fallbackStep3: "A assinatura é copiada automaticamente. Cole-a no campo abaixo e envie.",
        copyScript: "Copiar script",
        copied: "Copiado!",
        pasteLabel: "Cole aqui a assinatura",
        pastePlaceholder: '{"id":"...","rawId":"...","type":"public-key","response":{...}}',
        submitAssertion: "Enviar assinatura",
        confirmTitle: "Confirme o código no seu celular",
        confirmSubtitle:
          "O WhatsApp mostra um código no aparelho principal. Verifique se ele bate com o número abaixo e confirme.",
        confirmCodeLabel: "Código",
        confirmLoadingCode: "Obtendo o código…",
        confirmButton: "Já confirmei no celular",
        confirming: "Confirmando…",
        doneTitle: "Conectado!",
        doneSubtitle: "A conexão foi vinculada com sucesso via passkey.",
        close: "Fechar",
        errors: {
          sign: "Não foi possível assinar a passkey. Tente novamente.",
          confirm: "Não foi possível confirmar. Tente novamente.",
          failed: "O WhatsApp recusou o pareamento. Gere um novo QR e tente de novo.",
          assertionParse: "A assinatura colada é inválida. Copie o JSON completo do console.",
        },
      },
      qrCodeModal: {
        title: "Utilize o seu WhatsApp:",
        steps: {
          one: "1 - Abra o WhatsApp no seu celular",
          two: {
            partOne: "2 - Toque em Mais opções no Android",
            partTwo: "ou em Configurações",
            partThree: "no iPhone",
          },
          three:
              "3 - Toque em Dispositivos conectados e, em seguida, em Conectar dispositivos",
          four: "4 - Aponte seu celular para essa tela para capturar o QR Code",
        },
        waiting: "Aguardando leitura do QR Code",
        tabs: {
          qr: "QR Code",
          pairing: "Código de pareamento",
        },
        pairing: {
          title: "Conectar com código",
          phoneLabel: "Número com DDI e DDD",
          phonePlaceholder: "Ex: 5511999999999",
          generate: "Gerar código",
          generating: "Gerando...",
          instructions: "No WhatsApp do celular: Dispositivos conectados → Conectar com número → digite o código abaixo.",
          copy: "Copiar",
          copied: "Copiado!",
          invalidPhone: "Informe um número válido com DDI e DDD.",
        },
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
          deletedAll: "Todos contatos excluídos com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          deleteAllTitle: "Deletar Todos",
          importTitle: "Importar contatos",
          deleteMessage:
              "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          deleteAllMessage:
              "Tem certeza que deseja deletar todos os contatos? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importar todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contatos",
          delete: "Excluir Todos Contatos",
          startConversation: "Iniciar conversa no WhatsApp",
          edit: "Editar contato",
          deleteSingle: "Excluir contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      syncHistoryModal: {
        menuItem: "Sincronizar histórico",
        title: "Sincronizar histórico",
        description: "Traz mensagens antigas do WhatsApp pra dentro do atendimento. Disponível apenas para conexões não oficiais.",
        fields: {
          period: "Período",
          days7: "7 dias",
          days30: "30 dias",
          days90: "90 dias",
          custom: "Personalizado",
          customInput: "Período personalizado",
          customHint: "Escolha entre 1 e {{max}} dias",
          daysSuffix: "dias",
          downloadMedia: "Baixar mídias",
          downloadMediaHint: "Imagens, áudios e documentos. Mais lento.",
        },
        buttons: {
          sync: "Sincronizar",
          cancel: "Cancelar",
          background: "Continuar em background",
          close: "Fechar",
        },
        progress: {
          syncing: "Processando {{processed}} mensagens…",
          complete: "Sincronização concluída",
          truncated: "Limite de 2000 mensagens atingido. Rode novamente para pegar mais antigas.",
        },
        stats: {
          imported: "Importadas",
          skipped: "Já existentes",
          errors: "Erros",
        },
      },
      contactImportModal: {
        title: "Planilha de contatos",
        labels: {
          import: "Importar contatos",
          result: "resultados",
          added: "Adicionados",
          savedContact: "Contato salvo",
          errors: "Erros",
        },
        buttons: {
          download: "Baixar planilha modelo",
          import: "Importar contatos",
          background: "Continuar em segundo plano",
          close: "Fechar",
        },
        progress: {
          importing: "Importando {{processed}} de {{total}} contatos...",
          success: "{{count}} importados com sucesso",
          errors: "{{count}} com erro",
          complete: "Importação concluída",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      sideMenu: {
        name: "Menu Lateral Inicial",
        note: "Se habilitado, o menu lateral irá iniciar fechado",
        options: {
          enabled: "Aberto",
          disabled: "Fechado",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          model: "Modelo",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
        },
        formErrors: {
          name: {
            short: "Nome muito curto",
            long: "Nome muito longo",
            required: "Nome é obrigatório",
          },
          prompt: {
            short: "Prompt muito curto",
            required: "Descreva o treinamento para Inteligência Artificial",
          },
          modal: {
            required: "Informe o modelo desejado para o Prompt",
          },
          maxTokens: {
            required: "Informe o número máximo de tokens na resposta",
          },
          temperature: {
            required: "Informe a temperatura",
          },
          apikey: {
            required: "Informe a API Key",
          },
          queueId: {
            required: "Informe a fila",
          },
          maxMessages: {
            required: "Informe o número máximo de mensagens no histórico",
          },
        },
        success: "Prompt salvo com sucesso!",
        setor: "Informe o setor",
        title: {
          add: "Agentes de IA",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Inteligência Artificial",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Agentes de IA",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          basicInfo: "Informações básicas",
          complementaryInfo: "Dados complementares",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do WhatsApp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          whatsapp: "Conexão Origem: ",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          phone: {
            short: "Número muito curto",
            long: "Número muito longo",
          },
          email: {
            invalid: "Email inválido",
          },
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar setor",
          edit: "Editar setor",
        },
        form: {
          name: "Nome",
          nameShort: "Nome curto",
          nameLong: "Nome longo",
          nameRequired: "Nome é obrigatório",
          color: "Cor",
          colorShort: "Cor curta",
          colorLong: "Cor longa",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          ratingMessage: "Mensagem de avaliação",
          token: "Token",
          orderQueue: "Ordem do setor (Bot)",
          integrationId: "Integração",
        },  
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        toasts: {
          success: "Fila salva com sucesso.",
          info: "Clique em salvar para registar as alterações",
        },
        tabs: {
          queueData: "Dados do Setor",
          attendanceTime: "Horários de Atendimento",
        },
      },
      userModal: {
        loading: "Carregando dados do usuário...",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        tabs: {
          personal: "Dados pessoais",
          access: "Acesso",
          service: "Atendimento",
        },
        form: {
          name: "Nome",
          email: "Email",
          cpf: "CPF",
          password: "Senha",
          optionalSuffix: "· opcional",
          passwordKeepHint: "Deixe em branco para não alterar",
          allTicketSwitchTitle: "Avisos de conversas sem setor",
          allTicketSwitchDescription:
            "Recebe também os avisos das conversas que chegam sem setor. Quem vê cada conversa fica em Configurações → Conversas.",
          typingSwitchTitle: "Mostrar “digitando…” ao cliente",
          typingSwitchDescription: "Enquanto você escreve, o cliente vê “digitando…” no WhatsApp.",
          addQueue: "Adicionar setor",
          addAllQueues: "Adicionar todos os setores",
          noQueuesSelected: "Nenhum setor selecionado",
          noQueueAvailable: "Nenhum setor disponível",
          noConnectionAvailable: "Nenhuma conexão disponível",
          maxCompanies: "Máx. empresas",
          maxCompaniesHelper: "Quantas empresas este usuário pode atender",
          groupCompanies: "Empresas do Grupo",
          changePhoto: "Alterar foto",
          profile: "Perfil",
          jobRole: "Cargo",
          noJobRole: "Sem cargo",
          operationalType: "Tipo operacional",
          customizePermissions: "Personalizar permissões",
          countsInIndicators: "Conta nos indicadores de atendimento",
          countsInIndicatorsHelp: "Desligado, a pessoa fica fora dos números de atendimento.",
          attendant: "Atendente",
          supervisor: "Supervisor",
          whatsapp: "Conexão Padrão",
          noWhatsapp: "Nenhuma conexão",
          queues: "Setores do Usuário",
          uploadPhoto: "Carregar Foto",

          allTicket: "Ticket Sem Fila [Invisível]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Desabilitado",
          accessScope: "Escopo de Acesso *",
          accessScopeFull: "Completo (Atendimento + Interno)",
          accessScopeAttendance: "Apenas Atendimento (Tickets, WhatsApp)",
          accessScopeInternal: "Apenas Interno (Chat, CRM)",
          internalLockedNotice: "Chat Interno não está incluso no seu plano. Faça upgrade em Configurações → Faturamento para liberar.",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          password: {
            short: "Senha muito curta",
            long: "Senha muito longa",
          },
          email: {
            required: "Email é obrigatório",
            invalid: "Email inválido",
          },
        },
        labels: {
          liberations: "Liberações",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          saveChanges: "Salvar alterações",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
        },
        form: {
          name: "Nome",
          color: "Cor",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salvo com sucesso.",
      },
      chat: {
        toasts: {
          fillTitle: "Por favor, preencha o título da conversa.",
          fillUser: "Por favor, selecione pelo menos um usuário.",
        },
        modal: {
          title: "Conversa",
          titleField: "Título",
        },
        confirm: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
        chats: "Chats",
        messages: "Mensagens",
        noTicketMessage: "Selecione um ticket para começar a conversar.",
        buttons: {
          close: "Fechar",
          save: "Salvar",
          new: "Nova",
          newChat: "Novo",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        noQueue: "Sem fila",
      },
      tickets: {
        splitter: {
          label: "Redimensionar lista de conversas",
          hint: "Arraste para ajustar a largura. Use as setas do teclado ou dê dois cliques para restaurar.",
        },
        toolbar: {
          menu: "Opções das conversas",
          unread: "Não lidas",
          filters: "Filtros",
          search: "Buscar tickets",
        },
        handledByAi: "Atendido por IA: {{name}}",
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
          unauthorized: "Acesso não permitido",
        },
        filters: {
          user: "Filtro por usuários",
          tags: "Filtro por tags",
          connection: "Filtrar por conexão",
          queues: "Filtrar por Setores",
          emptyQueueWarning: "Selecione pelo menos uma fila (ou 'Sem fila') para aplicar o filtro.",
          tagsPlaceholder: "Filtrar por Etiquetas",
          tagsPopoverTitle: "Etiquetas",
          tagsSearchPlaceholder: "Pesquisar",
          noTagsOption: "Sem etiquetas",
          noTagsFound: "Nenhuma etiqueta encontrada",
          singleSelected: "selecionado",
          multipleSelected: "selecionados",
          showingAll: "Exibindo todos os itens",
          selectAll: "Aplicar todas",
          queuesPopoverTitle: "Setores",
          queuesSearchPlaceholder: "Pesquisar",
          noQueuesFound: "Nenhum setor encontrado",
          noQueueSelected: "Nenhum setor selecionado — escolha ao menos um",
          clear: "Limpar",
          loadingTags: "Carregando etiquetas...",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          groups: { title: "Grupos" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldUserLabel: "Atendente",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        userPlaceholder: "Selecione um atendente",
        userPopoverTitle: "Atendentes",
        userSearchPlaceholder: "Pesquisar atendentes",
        clearUserOption: "Limpar seleção",
        noUsersFound: "Nenhum atendente encontrado",
        showingAllUsers: "Exibindo todos os atendentes",
        noOptions: "Nenhum usuário encontrado com esse nome",
        noSelection: "Selecione um atendente ou uma fila para transferir.",
        queuePopoverTitle: "Filas",
        queueSearchPlaceholder: "Pesquisar filas",
        noQueueOption: "Sem fila",
        noQueuesFound: "Nenhuma fila encontrada",
        singleSelected: "item selecionado",
        showingAll: "Exibindo todas as filas",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        empty: {
          openTitle: "Tudo tranquilo por aqui!",
          openDescription: "Você não possui atendimentos em andamento no momento.",
          openAllDescription: "Não há conversas em atendimento no momento.",
          pendingTitle: "Fila zerada. Boa!",
          pendingDescription: "Nenhuma conversa aguardando atendimento. Tudo em dia por aqui!",
          groupsTitle: "Nenhuma conversa em grupo",
          groupsDescription: "Não há conversas em grupo em andamento no momento.",
          pendingCount: "{{count}} conversa aguardando atendimento",
          pendingCount_plural: "{{count}} conversas aguardando atendimento",
          pendingCountMore: "{{count}} ou mais conversas aguardando atendimento",
          viewPending: "Ver pendentes",
          searchTitle: "Nenhuma conversa encontrada",
          searchDescription: "Não encontramos conversas para “{{term}}”. Tente outro nome, número ou termo.",
          searchFilteredDescription: "Não encontramos conversas para “{{term}}” com os filtros atuais. Tente outro termo ou ajuste os filtros.",
          filteredTitle: "Nenhuma conversa encontrada",
          filteredDescription: "Tente mudar os filtros para ver mais conversas.",
          adjustFilters: "Ajustar filtros",
        },
        pendingHeader: "Aguardando",
        pendingHeaderTab: "Pendente",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
            "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        buttons: {
          accept: "Aceitar",
          closed: "Finalizar",
          reopen: "Reabrir",
        },
      },
      ticketsListItem: {
        tooltip: {
          chatbot: "Chatbot",
          peek: "Espiar Conversa",
          unreplied: "Sem resposta há mais de 10 minutos",
        },
        noQueue: "SEM FILA",
        viewLocation: "Ver localização no mapa",
        typing: "digitando...",
        recording: "gravando áudio...",
      },
      ticketAdvanced: {
        selectTicket: "Selecionar Ticket",
        ticketNav: "Ticket",
        attendanceNav: "Atendimentos",
      },
      newTicketModal: {
        title: "Escolha um contato",
        ticketTitle: "Escolha um ticket",
        searchPlaceholder: "Pesquisar por nome ou telefone",
        tagsPlaceholder: "Etiquetas",
        tagsPopoverTitle: "Etiquetas",
        tagsSearchPlaceholder: "Pesquisar",
        showingAll: "Exibindo todos os itens",
        singleSelected: "item selecionado",
        multipleSelected: "itens selecionados",
        clear: "Limpar",
        noTagsOption: "Sem etiquetas",
        noTagsFound: "Nenhuma etiqueta encontrada",
        createTicket: "Criar ticket",
        existingContactPlaceholder: "Pesquise um contato existente",
        contactSearchHint: "Digite pelo menos 3 caracteres para buscar um contato",
        queuePlaceholder: "Selecione uma fila",
        allQueuesOption: "Todas as filas",
        queuePopoverTitle: "Filas",
        queueSearchPlaceholder: "Pesquisar filas",
        noQueueOption: "Criar sem fila",
        noQueuesFound: "Nenhuma fila encontrada",
        connectionPlaceholder: "Selecione uma conexão",
        allConnectionsOption: "Todas as conexões",
        connectionPopoverTitle: "Conexões",
        loadingConnections: "Carregando conexões...",
        noConnectionsAvailable: "Nenhuma conexão disponível",
        newContact: "Novo contato",
        emptyState: "Nenhum contato encontrado",
        emptyTicketsState: "Nenhum ticket encontrado",
        loadingTags: "Carregando etiquetas...",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      locationPreview: {
        button: "Visualizar",
        openInMaps: "Abrir no Maps",
        showMap: "Ver no mapa",
        hideMap: "Ocultar mapa",
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          dashboardGeral: "Dashboard Geral",
          connections: "Conexões",
          tickets: "Atendimentos",
          quickMessages: "Respostas Rápidas",
          tasks: "Tarefas",
          contacts: "Contatos",
          queues: "Setores",
          tags: "Tags",
          academy: "Treinamentos",
          manageAcademy: "Gerenciar Treinamentos",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          flows: "Fluxos",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          files: "Lista de arquivos",
          prompts: "IA",
          queueIntegration: "Integrações",
          metaTemplates: "Templates Meta",
          smartApproaches: "Abordagens inteligentes",
          integrations: "Integrações",
          workOrders: "Ordens de serviço",
        },
        appBar: {
          refresh: "Recarregar página",
          notRegister: "Sem notificações",
          language: "Idioma",
          jobRole: "Cargo",
          noJobRole: "Sem cargo",
          appearance: "Aparência",
          notificationVolume: "Som das Notificações",
          greeting: {
						hello: "Olá",
						welcome: "Bem vindo a",
						active: "Ativo até",
					},
          user: {
            profile: "Perfil",
            security: "Segurança da conta",
            logout: "Sair",
          },
        },
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
              "Você tem certeza? Essa ação não pode ser revertida! e será removida dos setores e conexões vinculadas",
        },
      },
      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      messagesAPI: {
        title: "API",
        labels: {
          doc: "Documentação para envio de mensagens",
          method: "Métodos de Envio",
          textMessage: "Mensagem de Texto",
          mediaMessage: "Mensagem de Mídia",
          instructions: "Instruções",
          observations: "Observações importantes",
          before1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens.",
          before2:
              "Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
          numberDescription:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
          countryCode: "Código do País",
          number: "Número",
          textMessage2: "1. Mensagens de Texto",
          textMessageInstructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          method2: "Método",
          e: "e",
          tests: "Teste de Envio",
          mediaMessage2: "2. Mensagens de Mídia",
        },
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        toasts: {
          unauthorized:
              "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
          success: "Mensagem enviada com sucesso!",
        },
        buttons: {
          send: "Enviar",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
          error: "Erro ao salvar atalho.",
        },
        validation: {
          shortcodeRequired: "Informe o atalho da resposta rápida.",
          messageRequired: "Informe a mensagem da resposta rápida.",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      leadSettings: {
        tabs: {
          apiTokens: "Tokens de API",
          leadStatuses: "Status dos cards",
        },
        tokens: {
          newToken: "Novo Token",
          webhookTitle: "URL do Webhook para N8N",
          webhookHint: "Envie o header:",
          copyUrl: "Copiar URL",
          urlCopied: "URL do webhook copiada!",
          emptyTitle: "Nenhum token criado",
          emptyDescription: "Crie um token de API para integrar com N8N ou outras plataformas",
          createdAt: "Criado em:",
          deleteTitle: "Excluir Token de API",
          deleteMessage: "Tem certeza que deseja excluir o token \"{name}\"? Esta ação não pode ser desfeita e todas as integrações que usam este token deixarão de funcionar.",
          deleted: "Token excluído com sucesso",
        },
        statuses: {
          newStatus: "Novo Status",
          emptyTitle: "Nenhum status criado",
          emptyDescription: "Crie status personalizados para organizar seus cards",
          default: "Padrão",
          pending: "Pendente",
          completed: "Concluído",
          order: "Ordem",
          deleteTitle: "Excluir Status",
          deleteMessage: "Tem certeza que deseja excluir o status \"{name}\"? Cards com este status serão movidos para o status padrão.",
          deleted: "Status excluído com sucesso",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          nameShort: "Nome curto",
          nameLong: "Nome longo",
          nameRequired: "Nome é obrigatório",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
          success: "Operação realizada com sucesso",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        download: "Clique aqui para baixar planilha exemplo.",
        dialog: {
          name: "Nome",
          nameShort: "Nome curto",
          nameLong: "Nome longo",
          nameRequired: "Nome é obrigatório",
          number: "Número",
          numberShort: "Número curto",
          numberLong: "Número longo",
          whatsapp: "Whatsapp",
          email: "E-mail",
          emailInvalid: "E-mail inválido",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        report: {
          title: "Relatório de",
          title2: "Disparo",
          of: "de",
          validContacts: "Contatos válidos",
          delivered: "Entregues",
          connection: "Conexão",
          contactList: "Lista de Contatos",
          schedule: "Agendamento",
          conclusion: "Conclusão",
        },
        config: {
          interval: "Intervalos",
          randomInterval: "Intervalo Randômico de Disparo",
          biggerInterval: "Intervalo Maior Após",
          greaterInterval: "Intervalo de Disparo Maior",
          noInterval: "Sem Intervalo",
          second: "segundo",
          seconds: "segundos",
          notDefined: "Não definido",
          addVariable: "Adicionar Variável",
          save: "Salvar Configurações",
          shortcut: "Atalho",
          content: "Conteúdo",
          close: "Fechar",
          add: "Adicionar",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        status: {
          inactive: "Inativa",
          programmed: "Programada",
          inProgress: "Em andamento",
          canceled: "Cancelada",
          finished: "Finalizada",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
          notDefined: "Não definida",
          notDefined2: "Não definido",
          notScheduled: "Sem agendamento",
          notConcluded: "Não concluída",
          stopCampaign: "Parar Campanha",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          form: {
            name: "Nome",
            nameShort: "Nome curto",
            nameLong: "Nome longo",
            helper:
                "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalziadas.",
            nameRequired: "Nome é obrigatório",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Lista de Tags",
            fileList: "Lista de Arquivos",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          configSaved: "Configurações salvas",
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      announcements: {
        active: "Ativo",
        inactive: "Inativo",
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        high: "Alta",
        medium: "Média",
        low: "Baixa",
        buttons: {
          add: "Criar Novo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            required: "Campo obrigatório",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
          info: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Setores",
        table: {
          id: "ID",
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
          orderQueue: "Ordenação do setor (bot)",
        },
        buttons: {
          add: "Adicionar fila",
        },
        emptyState: "Nenhuma fila encontrada",
        toasts: {
          success: "Fila deletada com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
              "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Setores",
      },
      users: {
        title: "Usuários",
        table: {
          id: "ID",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          admin: "Admin",
          user: "Usuário",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        invites: {
          button: "Convidar por e-mail",
          title: "Convidar por e-mail",
          subtitle: "A pessoa recebe um link para criar a senha e entrar nesta conta. O convite vale 7 dias.",
          email: "E-mail",
          emailPlaceholder: "nome@empresa.com.br",
          emailInvalid: "Digite um e-mail válido.",
          profile: "Perfil",
          license: "Licença",
          profiles: {
            user: "Atendente",
            admin: "Administrador",
          },
          send: "Enviar convite",
          cancel: "Cancelar",
          sent: "Convite enviado para {{email}}.",
          pendingTitle: "{{count}} convite pendente",
          pendingTitle_plural: "{{count}} convites pendentes",
          expiresIn: "vence em {{count}} dia",
          expiresIn_plural: "vence em {{count}} dias",
          expired: "vencido",
          invitedBy: "enviado por {{name}}",
          resend: "Reenviar",
          resent: "Convite reenviado para {{email}}.",
          revoke: "Excluir",
          revokeTitle: "Excluir o convite?",
          revokeText: "O link enviado para {{email}} deixa de valer.",
          revokeConfirm: "Excluir convite",
          revoked: "Convite excluído.",
        },
        emptyState: "Nenhum usuário encontrado",
        toasts: {
          created: "Usuário criado com sucesso.",
          deleted: "Usuário excluído com sucesso.",
          updated: "Usuário atualizado com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
              "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      todolist: {
        input: "Nova tarefa",
        buttons: {
          add: "Adicionar",
          save: "Salvar",
        },
      },
      helps: {
        title: "Central de Ajuda",
      },
      schedules: {
        title: "Agendamentos",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        messages: {
          date: "Data",
          time: "Hora",
          event: "Evento",
          allDay: "Dia Todo",
          week: "Semana",
          work_week: "Agendamentos",
          day: "Dia",
          month: "Mês",
          previous: "Anterior",
          next: "Próximo",
          yesterday: "Ontem",
          tomorrow: "Amanhã",
          today: "Hoje",
          agenda: "Agenda",
          noEventsInRange: "Não há agendamentos no período.",
          showMore: "mais",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
          deleteAllMessage: "Tem certeza que deseja deletar todas as Tags?",
          deleteAllTitle: "Deletar Todos",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Registros Tagdos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
          deleteAll: "Deletar Todas",
        },
        toasts: {
          deletedAll: "Todas Tags excluídas com sucesso!",
          deleted: "Tag excluído com sucesso.",
        },
      },
      accessControl: {
        tabs: {
          people: "Pessoas",
          roles: "Perfis de acesso",
          history: "Histórico",
        },
        tabsLabel: "Partes de Equipe e permissões",
        roles: {
          agent: "Atendente",
          supervisor: "Supervisor",
          admin: "Administrador",
        },
        roleHelp: {
          agent: "Atende as conversas e cuida dos contatos.",
          supervisor: "Atende e acompanha a equipe: relatórios, fluxos e disparos, só para ver.",
          admin: "Tudo, inclusive a equipe, a empresa e as permissões.",
        },
        licenses: {
          full: "Completa",
          attendance: "Apenas Atendimento",
          internal: "Apenas Interno",
        },
        scopes: {
          none: "Nenhuma",
          own: "Só as próprias",
          queues: "Das filas dele",
          company: "Da empresa toda",
        },
        groups: {
          tickets: "Atendimento",
          contacts: "Contatos e recursos do atendimento",
          reports: "Relatórios",
          settings: "Configurações",
          team: "Equipe e acesso",
          company: "Empresa",
          marketing: "Marketing",
          automation: "Automação e IA",
          crm: "CRM e chat interno",
        },
        origin: {
          default: "Padrão do perfil",
          granted: "Concedida",
          denied: "Negada",
        },
        locks: {
          plan: "Não incluído no plano",
          module: "Módulo não ativado",
          setting: "Desligado pela Sttelar",
          license: "Licença {{license}}",
          admin_only: "Só para Administrador",
          actor: "Você não tem esta permissão",
        },
        readOnly: {
          own: "Você não pode alterar o próprio acesso.",
          impersonating: "No \"Acessar como\" um usuário não dá para alterar acessos.",
          other_companies: "Esta pessoa também está em outra empresa, que você não administra.",
          above: "Esta pessoa tem mais acesso que você.",
        },
        people: {
          search: "Buscar por nome ou e-mail",
          allRoles: "Todos os perfis",
          allLicenses: "Todas as licenças",
          customized: "Com personalizações",
          columns: {
            person: "Pessoa",
            role: "Perfil",
            customizations: "Personalizações",
            license: "Licença",
            queues: "Filas",
            lastAccess: "Último acesso",
          },
          grantedOne: "1 concedida",
          grantedMany: "{{count}} concedidas",
          deniedOne: "1 negada",
          deniedMany: "{{count}} negadas",
          noQueues: "Sem filas",
          never: "Nunca entrou",
          empty: "Ninguém encontrado.",
          open: "Abrir o acesso de {{name}}",
          pageRange: "{{from}}–{{to}} de {{total}}",
          previousPage: "Página anterior",
          nextPage: "Próxima página",
        },
        panel: {
          back: "Pessoas",
          role: "Perfil de acesso",
          restore: "Restaurar padrão do perfil",
          restoreTitle: "Restaurar o padrão do perfil?",
          restoreBody: "As personalizações de {{name}} saem, e o acesso volta ao padrão de {{role}}.",
          restoreConfirm: "Restaurar",
          restoreDirty: "Salve ou descarte as alterações antes.",
          restored: "Acesso de {{name}} voltou ao padrão do perfil.",
          searchPermissions: "Buscar permissão",
          onlyCustomized: "Só personalizadas",
          onlySensitive: "Só sensíveis",
          summary: "{{on}} de {{total}}",
          sensitive: "Sensível",
          backToDefault: "Voltar ao padrão",
          dependsOn: "Depende de: {{names}}",
          nothingFound: "Nenhuma permissão encontrada.",
          discard: "Descartar",
          save: "Salvar",
          confirmTitle: "Salvar o acesso de {{name}}?",
          confirmRole: "Perfil: {{from}} → {{to}}",
          confirmScope: "Conversas: {{from}} → {{to}}",
          confirmGains: "Passa a ter",
          confirmLoses: "Deixa de ter",
          confirmNothing: "O acesso fica igual: só as exceções mudam de lugar.",
          saved: "Acesso de {{name}} salvo.",
          reloaded: "Outra pessoa alterou este acesso. Mostramos o de agora.",
          loadError: "Não foi possível carregar o acesso desta pessoa.",
          previewError: "Não foi possível conferir as mudanças agora. Tente de novo.",
        },
        rolesTab: {
          intro: "O que cada perfil tem por padrão. As exceções de cada pessoa ficam na aba Pessoas.",
          permission: "Permissão",
          included: "Incluída",
          notIncluded: "Não incluída",
        },
        history: {
          person: "Pessoa",
          allPeople: "Todas as pessoas",
          loadingPeople: "Carregando…",
          noPeople: "Ninguém com esse nome.",
          morePeople: "Mostrando {{shown}} de {{total}}. Digite para achar outra pessoa.",
          from: "De",
          to: "Até",
          actions: {
            conversion: "Perfil definido na mudança para as permissões",
            user: {
              create: "Cadastro",
              update: "Perfil ou licença alterado",
            },
            access: {
              overrides: "Exceções alteradas",
              reset: "Padrão do perfil restaurado",
            },
          },
          by: "por {{name}}",
          byAs: "por {{name}}, como {{as}}",
          support: "Suporte Sttelar",
          system: "Sistema",
          removed: "Pessoa excluída",
          role: "Perfil: {{from}} → {{to}}",
          license: "Licença: {{from}} → {{to}}",
          granted: "Concedida: {{name}}",
          denied: "Negada: {{name}}",
          cleared: "Voltou ao padrão: {{name}}",
          empty: "Nenhuma mudança no período.",
          loadMore: "Carregar mais",
        },
        permissions: {
          tickets: {
            view: {
              title: "Ver e atender conversas",
              help: "Lista, abrir, responder, aceitar e reabrir. O nível diz quais conversas.",
            },
            view_no_queue: {
              title: "Ver conversas sem fila",
              help: "As que ainda não entraram em nenhuma fila.",
            },
            view_groups: {
              title: "Ver conversas de grupos",
              help: "Os grupos do WhatsApp.",
            },
            create: {
              title: "Iniciar conversa",
              help: "Com um contato ou um número novo.",
            },
            take_over: {
              title: "Assumir conversa de colega",
              help: "Tirar a conversa de outro atendente.",
            },
            transfer: {
              title: "Transferir conversa",
              help: "Para fila, atendente ou IA, ou devolver à fila.",
            },
            close: {
              title: "Encerrar conversa",
              help: "Marcar a conversa como resolvida.",
            },
            manage_connection: {
              title: "Trocar a conexão da conversa",
              help: "E sincronizar o histórico.",
            },
            spy: {
              title: "Espiar conversa",
              help: "Ver sem assumir.",
            },
            bulk_actions: {
              title: "Ações em massa",
              help: "Encerrar e reatribuir várias conversas de uma vez.",
            },
            delete: {
              title: "Excluir conversa",
              help: "Apaga a conversa e as mensagens.",
            },
          },
          messages: {
            manage_others: {
              title: "Apagar ou editar mensagem de colega",
              help: "Mensagens enviadas por outra pessoa.",
            },
          },
          notes: {
            manage_others: {
              title: "Mexer em observação de colega",
              help: "Editar a de outra pessoa e apagar qualquer uma.",
            },
          },
          contacts: {
            edit: {
              title: "Criar e editar contatos",
              help: "Nome, número e dados do contato.",
            },
            import: {
              title: "Importar contatos",
              help: "De planilha ou do WhatsApp.",
            },
            wallet_manage: {
              title: "Definir o responsável do contato",
              help: "A carteira de clientes.",
            },
            delete: {
              title: "Excluir contato",
              help: "As conversas do contato saem junto.",
            },
          },
          tags: {
            manage: {
              title: "Gerir etiquetas",
              help: "Criar, editar e excluir.",
            },
          },
          quick_replies: {
            manage_company: {
              title: "Gerir respostas rápidas da empresa",
              help: "As que toda a equipe usa.",
            },
          },
          templates: {
            use: {
              title: "Enviar templates",
              help: "Modelos aprovados pela Meta.",
            },
            manage: {
              title: "Gerir templates",
              help: "Criar, editar e excluir na Meta.",
            },
          },
          ai: {
            assist: {
              title: "Reescrever com IA",
              help: "Melhorar o texto antes de enviar.",
            },
          },
          reports: {
            view: {
              title: "Dashboard e indicadores",
              help: "Os números da empresa.",
            },
            view_group: {
              title: "Indicadores do grupo",
              help: "Todas as unidades do grupo.",
            },
          },
          departments: {
            manage: {
              title: "Departamentos",
              help: "Criar e escolher quem vê os números de cada um.",
            },
          },
          queues: {
            manage: {
              title: "Filas e chatbot",
              help: "Criar e configurar.",
            },
          },
          connections: {
            manage: {
              title: "Conexões",
              help: "Configurar, ler o QR code e parear.",
            },
          },
          files: {
            manage: {
              title: "Listas de arquivos",
              help: "Os arquivos que o chatbot envia.",
            },
          },
          schedules: {
            manage: {
              title: "Horários e feriados",
              help: "Quando a empresa atende.",
            },
          },
          settings: {
            manage: {
              title: "Opções do atendimento",
              help: "E os módulos da empresa.",
            },
          },
          team: {
            view: {
              title: "Ver a equipe",
              help: "Com e-mail, perfil e verificação em duas etapas.",
            },
            manage: {
              title: "Gerir a equipe",
              help: "Cadastrar, editar e excluir pessoas; filas, conexão e cargo.",
            },
            manage_access: {
              title: "Gerir permissões",
              help: "Perfil de acesso, licença e exceções de cada pessoa.",
            },
            reset_credentials: {
              title: "Trocar senha e e-mail de outra pessoa",
              help: "E zerar a verificação em duas etapas.",
            },
            manage_companies: {
              title: "Vincular a outras empresas do grupo",
              help: "Dar acesso a outras unidades.",
            },
          },
          company: {
            manage: {
              title: "Dados da empresa",
              help: "Nome, idioma e guia de configuração.",
            },
            security: {
              manage: {
                title: "Segurança da empresa",
                help: "Exigir a verificação em duas etapas.",
              },
            },
          },
          billing: {
            manage: {
              title: "Plano e pagamento",
              help: "Cobrança e forma de pagamento.",
            },
          },
          api_tokens: {
            manage: {
              title: "Tokens da API",
              help: "Acesso de sistemas de fora.",
            },
          },
          integrations: {
            manage: {
              title: "Integrações",
              help: "OpenAI, WooCommerce, Contele e SMS.",
            },
          },
          audiences: {
            view: {
              title: "Ver bases de contatos",
              help: "Bases, segmentos e listas.",
            },
            manage: {
              title: "Gerir bases de contatos",
              help: "Subir bases e criar segmentos e listas.",
            },
          },
          mass_send: {
            view: {
              title: "Acompanhar disparos",
              help: "Os envios em massa.",
            },
            manage: {
              title: "Gerir disparos",
              help: "Criar, pausar e cancelar; descadastros.",
            },
          },
          smart_approaches: {
            view: {
              title: "Ver abordagens inteligentes",
              help: "E os resultados.",
            },
            manage: {
              title: "Gerir abordagens inteligentes",
              help: "Criar e ativar.",
            },
          },
          flows: {
            view: {
              title: "Ver fluxos",
              help: "E os resultados.",
            },
            edit: {
              title: "Editar fluxos",
              help: "Criar, editar e subir arquivos.",
            },
          },
          ai_agents: {
            view: {
              title: "Ver agentes de IA",
              help: "A lista e os detalhes de cada agente.",
            },
            manage: {
              title: "Configurar agentes de IA",
              help: "Arquivos, versões e teste.",
            },
          },
          work_orders: {
            view: {
              title: "Ver ordens de serviço",
              help: "E as fontes delas.",
            },
            start_triage: {
              title: "Iniciar a triagem de uma OS",
              help: "Envia mensagem ao cliente.",
            },
          },
          triage: {
            configure: {
              title: "Configurar a triagem",
              help: "Perguntas e regras da triagem.",
            },
            monitor: {
              title: "Acompanhar triagens",
              help: "As que estão em andamento.",
            },
          },
          crm: {
            use: {
              title: "Usar o CRM",
              help: "Leads e colunas.",
            },
            boards: {
              manage: {
                title: "Gerir quadros do CRM",
                help: "Criar e excluir quadros.",
              },
              share: {
                title: "Compartilhar quadros por link",
                help: "Criar links para quem não tem login ver um quadro, sem poder mudar nada.",
              },
            },
          },
          internal_chat: {
            use: {
              title: "Usar o chat interno",
              help: "Conversar com a equipe.",
            },
            moderate: {
              title: "Moderar o chat interno",
              help: "Criar canais; fixar ou apagar mensagem de outros.",
            },
            invite: {
              title: "Convidar para o chat interno",
              help: "O link de convite cria uma conta nova.",
            },
          },
        },
      },
      settings: {
        schedulesUpdated: "Horários atualizados com sucesso.",
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        groups: {
          account: "Sua conta",
          service: "Atendimento",
          system: "Sistema",
          company: "Empresa",
        },
        area: {
          autosave: "As alterações são salvas automaticamente.",
          saving: "Salvando",
          saved: "Salvo",
          saveError: "Não foi possível salvar. Tente de novo.",
          loadError: "Não foi possível carregar as configurações.",
          retry: "Tentar de novo",
          collapseMenu: "Recolher menu",
          expandMenu: "Mostrar menu",
        },
        search: {
          label: "Buscar nas configurações",
          placeholder: "Buscar configuração",
          clear: "Limpar busca",
          open: "Buscar",
          empty: "Nada encontrado para “{{query}}”.",
          emptyHint: "Tente outra palavra, como “feriado” ou “SMS”.",
          count: "{{count}} resultado(s)",
        },
        sections: {
          security: {
            keywords: "2fa, autenticação, verificação, código, senha, login, acesso, google authenticator, duas etapas",
            title: "Segurança",
            description: "Proteja o acesso à sua conta com a autenticação em duas etapas.",
          },
          schedules: {
            keywords: "horário, expediente, funcionamento, abertura, fechamento, fora do horário, atendimento",
            title: "Horário de atendimento",
            description: "Quando a empresa atende e os dias em que não atende.",
            fields: {
              weeklyHours: {
                keywords: "semana, dias, hora, abre, fecha, segunda, sábado, domingo",
                title: "Horário da semana",
                description: "Dias e horários em que a empresa atende. As conexões com horário próprio usam o delas.",
              },
              exceptions: {
                keywords: "feriado, feriados nacionais, data especial, natal, ano novo, carnaval, folga, recesso, exceção",
                title: "Feriados e datas especiais",
                description: "Valem no lugar do horário da semana na data escolhida, em todas as conexões.",
              },
            },
          },
          conversations: {
            keywords: "quem vê, visibilidade, privacidade, conversas dos colegas, fila, setor",
            title: "Conversas",
            description: "Quem vê as conversas dos atendentes.",
            fields: {
              ticketVisibility: {
                keywords: "só as próprias, filas, setores, empresa toda, ver conversas",
                title: "Quem vê as conversas",
                description:
                  "Só as próprias: as do atendente e as que aguardam nas filas dele. Das filas dele: também as dos colegas. Administradores veem todas.",
                options: {
                  own: "Só as próprias",
                  queues: "Das filas dele",
                  company: "Da empresa toda",
                },
              },
              supervisorTicketVisibility: {
                keywords: "supervisor, supervisores, conversas, filas, empresa toda",
                title: "O que os Supervisores veem",
                description: "Nunca menos do que os atendentes.",
                options: {
                  queues: "Das filas dele",
                  company: "Da empresa toda",
                },
              },
            },
          },
          "quick-replies": {
            keywords: "atalho, mensagens prontas, respostas, compartilhar",
            title: "Respostas rápidas",
            description: "Quem vê as respostas rápidas. O cadastro delas fica no menu Respostas rápidas.",
            fields: {
              quickMessagesScope: {
                keywords: "quem vê, compartilhar, por atendente, por empresa",
                title: "Quem vê as respostas",
                description: "Por atendente: cada um vê só as que criou. Pela empresa: todos veem todas.",
                options: {
                  user: "Cada atendente as suas",
                  company: "Toda a empresa",
                },
              },
            },
          },
          indicators: {
            keywords: "sem resposta, espera, tempo de resposta, cores, alerta, sla, indicador, art",
            title: "Indicadores",
            description: "Avisos de conversas sem resposta e as cores do tempo de resposta.",
            groups: {
              noResponse: {
                title: "Conversas sem resposta",
                description: "Conversas em que o cliente espera resposta há mais de 10 minutos.",
              },
              responseTime: {
                title: "Tempo de resposta",
                description: "Cores do tempo médio de resposta no painel e nos relatórios.",
              },
              shortReplies: {
                title: "Respostas curtas do cliente",
                description: "Mensagens como \"Ok\" e \"👍\" no fim da conversa não contam no tempo de resposta nem no \"sem resposta\".",
              },
            },
            fields: {
              noResponseIndicator: {
                keywords: "aviso, menu, contador, sem resposta",
                title: "Aviso no menu",
                description: "Mostra no menu lateral quantas conversas estão sem resposta.",
              },
              unrepliedClockIcon: {
                keywords: "relógio, lista, vermelho, espera",
                title: "Relógio na lista de conversas",
                description: "Mostra um relógio vermelho ao lado do contato que espera resposta.",
              },
              noResponseBusinessHours: {
                keywords: "horário comercial, expediente, fora do horário",
                title: "Contar só no horário de atendimento",
                description: "Fora do expediente, a espera não conta no gráfico, na lista, no aviso e nos alertas.",
              },
              artThresholds: {
                keywords: "art, verde, amarelo, vermelho, minutos, tempo médio, limite",
                title: "Limites das cores",
                description: "Em minutos. Acima do limite do amarelo, fica vermelho.",
                greenUpTo: "Verde até",
                yellowUpTo: "Amarelo até",
                errors: {
                  integer: "Use números inteiros.",
                  range: "Use valores de 1 a 1440 minutos.",
                  order: "O limite do verde precisa ser menor que o do amarelo.",
                },
              },
              shortReplyFilter: {
                keywords: "ok, emoji, joinha, obrigado, resposta curta, encerrar, comissão",
                title: "Ignorar respostas curtas nos indicadores",
                description: "Mensagem de 1 caractere, só com emoji ou com as palavras abaixo. Vale para as mensagens que chegarem depois de salvar.",
              },
              shortReplyWords: {
                keywords: "palavras, lista, ok, valeu, obrigado",
                title: "Palavras que contam como resposta curta",
                description: "Uma por linha. Valem sozinhas ou juntas, com emoji e pontuação, sem diferença de maiúscula e acento. Com \"?\" no fim, viram pergunta e pedem resposta.",
                restore: "Restaurar padrão",
                errors: {
                  tooMany: "Use até 100 palavras.",
                  tooLong: "Cada palavra pode ter até 30 caracteres.",
                },
              },
              shortReplyStickers: {
                keywords: "figurinha, sticker",
                title: "Figurinha sozinha conta como resposta curta",
                description: "A figurinha de agradecimento no fim da conversa.",
              },
              shortReplyAutoClose: {
                keywords: "fechamento automático, inatividade, encerrar ticket",
                title: "Resposta curta não segura o ticket aberto",
                description: "No fechamento por inatividade da conexão, o \"Ok\" do cliente não conta como resposta dele.",
              },
            },
          },
          calls: {
            keywords: "ligação, ligações, chamada, telefone, voz, recusar, rejeitar",
            title: "Chamadas",
            description: "O que fazer quando um cliente liga pelo WhatsApp.",
            fields: {
              callRejection: {
                keywords: "recusar, rejeitar, mensagem automática, ligação",
                title: "Recusar ligações",
                description: "Recusa a ligação na hora e manda uma mensagem automática ao cliente.",
              },
              callRejectionMessage: {
                title: "Mensagem para o cliente",
                description: "Use {{variable}} para incluir o nome do cliente.",
                placeholder: "Olá {{variable}}! No momento não atendemos ligações por aqui. Escreva sua dúvida por mensagem que respondemos em breve.",
              },
            },
          },
          notifications: {
            keywords: "aviso, notificação, navegador, push, alerta, sms",
            title: "Notificações",
            description: "Avisos no navegador e alerta por SMS para a equipe.",
            groups: {
              browser: {
                title: "No navegador",
                description: "Aparecem na tela de quem está com o sistema aberto.",
              },
              sms: {
                title: "Alerta por SMS",
                description: "Avisa por SMS quando muitas conversas ficam sem resposta.",
              },
            },
            fields: {
              webNotifications: {
                keywords: "navegador, push, mensagem nova, desktop",
                title: "Mensagens novas",
                description: "Mostra um aviso do navegador quando chega mensagem em uma conversa.",
              },
              internalChatNotifications: {
                keywords: "chat interno, menção, mensagem direta",
                title: "Chat interno",
                description: "Mostra um aviso do navegador para mensagens diretas e menções no chat interno.",
              },
              smsAlert: {
                searchTitle: "Alerta por SMS",
                keywords: "sms, celular, telefone, alerta, limite, frequência, teste",
                title: "Ligar o alerta",
                description: "Manda SMS quando a parte de conversas sem resposta passar do limite.",
              },
              smsThreshold: {
                title: "Limite (%)",
                description: "O alerta sai quando a parte de conversas sem resposta passar deste valor.",
              },
              smsInterval: {
                title: "Intervalo entre alertas",
                description: "Tempo mínimo entre um SMS e outro.",
                unit: "Unidade",
                units: {
                  minutes: "Minutos",
                  hours: "Horas",
                  days: "Dias",
                },
              },
              smsPhones: {
                title: "Celulares que recebem o alerta",
                description: "Um número por linha, com DDD.",
              },
              smsTest: {
                title: "Testar o alerta",
                description: "Manda um SMS de teste para o primeiro número da lista.",
                button: "Enviar SMS de teste",
                sending: "Enviando...",
                sent: "SMS de teste enviado para {{phone}}.",
                failed: "Não foi possível enviar: {{error}}",
              },
            },
            toasts: {
              unsupported: "Este navegador não mostra notificações.",
              permissionDenied: "O navegador não deu permissão para mostrar notificações.",
            },
          },
          modules: {
            keywords: "módulos, recursos, ligar, desligar",
            title: "Módulos",
            description: "Recursos que podem ser ligados ou desligados para a empresa.",
            groups: {
              features: {
                title: "Recursos",
              },
              sttelar: {
                title: "Liberados pela Sttelar",
                description: "Só superadministradores veem estas opções.",
              },
            },
            fields: {
              enableAcademy: {
                keywords: "academy, treinamento, cursos, aulas",
                title: "Treinamentos",
                description: "Mostra a área de Treinamentos para a equipe.",
              },
              triageEnabled: {
                keywords: "triagem, ia, inteligência artificial, robô",
                title: "Triagem por IA",
                description: "Libera o cadastro de triagens e o painel de triagem nas conversas desta empresa.",
              },
              triageRetention: {
                keywords: "triagem, retenção, 90 dias, apagar, limpeza, lgpd, dados pessoais",
                title: "Retenção de 90 dias: apagar de verdade",
                description: "Desligado, a limpeza diária só simula: conta o que apagaria das triagens encerradas há mais de 90 dias. Ligado, apaga os documentos e dados delas; fica só o histórico, sem dados pessoais.",
                never: "Ainda não rodou (roda todo dia às 03:30).",
                lastSimulation: "Última simulação em {{date}}: {{sessions}} triagens, {{files}} arquivos, {{notes}} notas-resumo e {{workOrders}} OS seriam apagados.",
                lastDelete: "Última execução em {{date}}: {{sessions}} triagens limpas ({{files}} arquivos, {{notes}} notas-resumo, {{workOrders}} OS); {{remaining}} ficaram para a próxima.",
                confirmTitle: "Apagar de verdade?",
                confirmBody: "A partir da próxima limpeza (todo dia às 03:30), as triagens desta empresa encerradas há mais de 90 dias perdem de vez as fotos, notas fiscais, vídeos e áudios enviados na triagem, os dados lidos, a nota-resumo e os dados da OS. Não dá para desfazer.",
              },
              ticketCloseButton: {
                keywords: "resolver, encerrar, finalizar, fechar, botão, atendente, conversa, ticket",
                title: "Atendentes podem resolver conversas",
                description: "Desligado, só administradores encerram conversas: o botão Resolver some para os atendentes. O fechamento automático e a IA continuam encerrando.",
              },
            },
          },
          company: {
            keywords: "cnpj, razão social, nome fantasia, telefone, e-mail, email, dados fiscais, conta",
            title: "Dados da empresa",
            description: "Os dados fiscais e o contato de cada conta.",
          },
          "job-roles": {
            keywords: "cargo, cargos, função, equipe",
            title: "Cargos",
            description: "Cargos que aparecem no perfil da equipe e no chat interno.",
          },
          departments: {
            keywords: "departamento, departamentos, contas, unidades, dashboard, relatórios, quem vê",
            title: "Departamentos",
            description: "Grupos de contas e quem desta conta vê os números deles no Dashboard.",
          },
          "team-access": {
            keywords: "permissões, perfil de acesso, supervisor, atendente, administrador, exceções, histórico, quem pode",
            title: "Equipe e permissões",
            description: "O perfil de acesso de cada pessoa e as exceções a ele.",
          },
          "company-security": {
            keywords: "2fa, autenticação, obrigatório, política, prazo, equipe, duas etapas",
            title: "Segurança da empresa",
            description: "Defina se a equipe precisa usar a autenticação em duas etapas.",
          },
          billing: {
            keywords: "fatura, faturas, plano, pagamento, cartão, cobrança, assinatura, boleto, upgrade, cancelar",
            title: "Faturamento",
            description: "Plano, forma de pagamento e faturas.",
          },
        },
        companyData: {
          accountLabel: "Conta",
          razaoSocial: "Razão Social",
          nomeFantasia: "Nome Fantasia",
          cnpj: "CNPJ",
          phone: "Telefone",
          email: "E-mail",
          phRazaoSocial: "Ex: Comércio de Roupas LTDA",
          phNomeFantasia: "Ex: Loja do João",
          language: "Idioma das mensagens automáticas aos clientes",
          phEmail: "contato@empresa.com",
          save: "Salvar",
          saved: "Dados atualizados com sucesso.",
          billingHint: "As faturas e a nota fiscal usam os Dados para a cobrança, em Faturamento.",
          invalidCnpj: "CNPJ inválido. Verifique os dígitos.",
        },
        jobRoles: {
          title: "Cargos",
          emptyState: "Nenhum cargo cadastrado para esta empresa.",
          modal: {
            add: "Novo cargo",
            edit: "Editar cargo",
          },
          form: {
            name: "Nome do cargo",
          },
          buttons: {
            add: "Adicionar cargo",
            cancel: "Cancelar",
            save: "Salvar",
          },
          toasts: {
            created: "Cargo criado com sucesso.",
            updated: "Cargo atualizado com sucesso.",
            deleted: "Cargo excluído com sucesso.",
          },
          confirmationModal: {
            deleteTitle: "Excluir cargo",
            deleteMessage: "Os usuários vinculados a este cargo passarão automaticamente para Sem cargo.",
          },
        },
        departments: {
          emptyState: "Nenhum departamento ainda.",
          columns: {
            name: "Departamento",
            companies: "Contas",
            viewers: "Quem vê",
          },
          nobody: "Só os administradores",
          buttons: {
            add: "Novo departamento",
            cancel: "Cancelar",
            save: "Salvar",
            edit: "Editar",
            delete: "Excluir",
          },
          modal: {
            add: "Novo departamento",
            edit: "Editar departamento",
          },
          form: {
            name: "Nome",
            companies: "Contas",
            companiesHelp: "Cada conta fica em um departamento só.",
            viewers: "Quem vê os números",
            viewersHelp: "Pessoas desta conta. Os administradores já veem todos.",
            takenBy: "Em {{name}}",
            noOptions: "Nada encontrado",
          },
          toasts: {
            created: "Departamento criado.",
            updated: "Departamento atualizado.",
            deleted: "Departamento excluído.",
          },
          confirmationModal: {
            deleteTitle: "Excluir departamento",
            deleteMessage: "As contas continuam iguais; só deixam de estar juntas neste departamento.",
          },
        },
        helps: {
          toasts: {
            errorList: "Não foi possível carregar a lista de registros",
            errorOperation: "Não foi possível realizar a operação",
            error:
                "Não foi possível realizar a operação. Verifique se já existe uma helpo com o mesmo nome ou se os campos foram preenchidos corretamente",
            success: "Operação realizada com sucesso!",
          },
          buttons: {
            clean: "Limpar",
            delete: "Excluir",
            save: "Salvar",
          },
          grid: {
            title: "Título",
            description: "Descrição",
            video: "Vídeo",
          },
          confirmModal: {
            title: "Exclusão de Registro",
            confirm: "Deseja realmente excluir esse registro?",
          },
        },
        company: {
          toasts: {
            errorList: "Não foi possível carregar a lista de registros",
            errorOperation: "Não foi possível realizar a operação",
            error:
                "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente",
            success: "Operação realizada com sucesso!",
          },
          confirmModal: {
            title: "Exclusão de Registro",
            confirm: "Deseja realmente excluir esse registro?",
          },
          form: {
            name: "Nome",
            email: "E-mail",
            phone: "Telefone",
            plan: "Plano",
            status: "Status",
            yes: "Sim",
            no: "Não",
            campanhas: "Campanhas",
            enabled: "Habilitadas",
            disabled: "Desabilitadas",
            createdAt: "Criada Em",
          },
          buttons: {
            clear: "Limpar",
            delete: "Excluir",
            user: "Usuário",
            save: "Salvar",
          },
        },
        schedules: {
          form: {
            initialHour: "Hora inicial",
            finalHour: "Hora final",
            save: "Salvar",
            days: {
              monday: "Seg",
              tuesday: "Ter",
              wednesday: "Qua",
              thursday: "Qui",
              friday: "Sex",
              saturday: "Sáb",
              sunday: "Dom",
            },
            workdays: "Dias úteis",
            workdaysHint: "Segunda a sexta",
            allDays: "Todos os dias",
            allDaysHint: "Todos os dias da semana",
            closedDay: "Dia fechado",
            closedNote: "Sem atendimento nesses dias",
            remove: "Remover",
            add: "Adicionar horário",
            empty: "Nenhum horário configurado. Use \"Adicionar horário\" para começar.",
            errors: {
              noDays: "Selecione pelo menos um dia",
              missingTime: "Preencha a hora inicial e a final",
              invalidTime: "Use o formato HH:MM",
              endBeforeStart: "A hora final precisa ser depois da inicial",
            },
          },
          exceptions: {
            add: "Adicionar data",
            empty: "Nenhum feriado ou data especial.",
            loadError: "Não foi possível carregar os feriados.",
            columns: {
              date: "Data",
              note: "Observação",
              status: "Atendimento",
            },
            closed: "Fechado",
            edit: "Editar",
            remove: "Remover",
            dialog: {
              newTitle: "Novo feriado ou data especial",
              editTitle: "Editar data",
              description: "Nesta data, vale o que for definido aqui no lugar do horário da semana.",
              date: "Data",
              closedAllDay: "Fechado o dia todo",
              closedHint: "Sem atendimento nesta data.",
              reducedHint: "Atende só no horário abaixo.",
              hours: "Horário de atendimento",
              note: "Observação (opcional)",
              notePlaceholder: "Ex.: Natal, Ano Novo, meio expediente",
              cancel: "Cancelar",
              create: "Adicionar",
              save: "Salvar",
            },
            errors: {
              date: "Informe a data",
            },
            deleteTitle: "Remover esta data?",
            deleteBody: "Nessa data, volta a valer o horário da semana.",
            deleteConfirm: "Remover",
            national: {
              button: "Feriados nacionais",
              title: "Importar feriados nacionais",
              description: "As datas marcadas entram como dia fechado. Os facultativos vêm desmarcados e os já cadastrados ficam de fora.",
              year: "Ano",
              empty: "Não há mais feriados nacionais neste ano.",
              registered: "já cadastrado",
              optional: "facultativo",
              cancel: "Cancelar",
              import: "Adicionar {{count}} data",
              import_plural: "Adicionar {{count}} datas",
              imported: "{{count}} data adicionada.",
              imported_plural: "{{count}} datas adicionadas.",
              names: {
                newYear: "Confraternização Universal",
                carnivalMonday: "Carnaval (segunda)",
                carnivalTuesday: "Carnaval (terça)",
                goodFriday: "Sexta-feira Santa",
                easter: "Páscoa",
                tiradentes: "Tiradentes",
                labourDay: "Dia do Trabalho",
                corpusChristi: "Corpus Christi",
                independence: "Independência do Brasil",
                aparecida: "Nossa Senhora Aparecida",
                allSouls: "Finados",
                republic: "Proclamação da República",
                blackConsciousness: "Dia da Consciência Negra",
                christmas: "Natal",
              },
            },
            toasts: {
              created: "Data adicionada.",
              updated: "Data atualizada.",
              removed: "Data removida.",
            },
          },
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      startConversationModal: {
        title: "Iniciar conversa",
        subtitle: "Abre um atendimento com este número.",
        number: "Número",
        connection: "Conexão",
        selectConnection: "Selecione a conexão",
        noConnection: "Nenhuma conexão ativa. Conecte um WhatsApp em Conexões para iniciar a conversa.",
        copy: "Copiar número",
        copied: "Número copiado",
        copyFailed: "Não foi possível copiar. Selecione o número e copie manualmente.",
        cancel: "Cancelar",
        start: "Conversar",
        starting: "Iniciando…",
        started: "Conversa iniciada",
        selectRequired: "Selecione uma conexão",
        invalidNumber: "Este número não parece um telefone válido. Confira antes de iniciar a conversa.",
      },
      sendContactModal: {
        menuItem: "Contato",
        title: "Enviar contato",
        searchPlaceholder: "Pesquisar nome ou número",
        thisConnection: "Esta conexão",
        contacts: "Contatos",
        minChars: "Digite pelo menos 3 letras ou números para pesquisar.",
        empty: "Nenhum contato encontrado.",
        cancel: "Cancelar",
        send: "Enviar",
        sending: "Enviando…",
        unconfirmed: "Não foi possível confirmar o envio. Confira o chat antes de tentar de novo.",
      },
      sharedContactCard: {
        contacts: "{{count}} contatos",
        talk: "Conversar",
        copy: "Copiar",
        copied: "Copiado",
        save: "Salvar",
        saving: "Salvando…",
        saved: "Salvo",
        savedToast: "Contato salvo",
        copiedToast: "Número copiado",
        copyFailed: "Não foi possível copiar. Selecione o número e copie manualmente.",
        noNumber: "Sem número",
        showAll: "Ver todos ({{count}})",
        showLess: "Ver menos",
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            download: "Baixar",
          },
        },
        lostCall: "Chamada de voz/vídeo perdida às",
        deletedMessage: "Essa mensagem foi apagada pelo contato",
        aiBadge: "IA",
        aiSentBy: "Mensagem enviada pela IA",
        edited: "Editada",
        audio: "Áudio",
        location: "Localização",
        saudation: "Diga olá para seu novo contato!",
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem",
        placeholderClosed:
            "Reabra ou aceite esse ticket para enviar uma mensagem.",
        placeholderAttendedByOther: "Esta conversa está com outro atendente.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        close: "Fechar",
        expand: "Expandir painel",
        collapse: "Recolher painel",
        copyNumber: "Copiar número",
        numberCopied: "Número copiado",
        copyFailed: "Não foi possível copiar. Selecione o número e copie manualmente.",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
          },
          message: {
            required: "Mensagem é obrigatória",
          },
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        appointmentsModal: {
          title: "Observações do Contato",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket",
          titleFrom: "do contato ",
          message:
              "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      unsavedChanges: {
        hint: "Alterações não salvas",
        title: "Descartar alterações?",
        body: "As alterações ainda não foram salvas. Se continuar, elas serão perdidas.",
        leaveConfirm: "As alterações ainda não foram salvas. Sair mesmo assim?",
        discard: "Descartar",
      },
      confirmationModal: {
        eyebrow: "Confirmação",
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        forward: "Encaminhar",
        edit: "Editar",
        retry: "Reenviar",
        retrying: "Reenviando...",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      editMessageModal: {
        title: "Editar mensagem",
        originalMessage: "Mensagem original:",
        newMessage: "Nova mensagem",
        characters: "caracteres",
        timeRemaining: "Tempo restante",
        timeExpired: "Tempo para edição expirou",
        success: "Mensagem editada com sucesso!",
        errors: {
          emptyMessage: "A mensagem não pode estar vazia",
          noChanges: "Nenhuma alteração detectada",
          timeExpired: "O tempo para edição expirou (limite de 10 minutos)",
        },
        buttons: {
          cancel: "Cancelar",
          save: "Salvar",
        },
      },
      academy: {
        title: "Treinamentos",
        empty: "Nenhum curso disponível no momento.",
        lessons: "aulas",
        progress: "concluído",
        courseContent: "Conteúdo do curso",
        ofLessonsCompleted: "de {{total}} concluídos",
        lessonTag: "AULA",
        back: "Voltar",
        videoUnavailable: "Vídeo indisponível",
        continueWatching: "Continuar assistindo",
        courseCompleted: "Curso concluído",
        markComplete: "Marcar como concluída",
        unmarkComplete: "Desmarcar",
        toasts: {
          disabled: "A Área de Treinamento está desativada.",
          noPermission: "Você não tem permissão para acessar esta área.",
        },
        manage: {
          title: "Gerenciar Treinamentos",
          draft: "Rascunho",
          buttons: {
            cancel: "Cancelar",
            save: "Salvar",
            addCourse: "Novo curso",
            addModule: "Novo módulo",
          },
          validation: {
            titleRequired: "Informe um título (mín. 2 caracteres).",
            videoUrlRequired: "Informe a URL do vídeo.",
          },
          toasts: {
            courseSaved: "Curso salvo.",
            moduleSaved: "Módulo salvo.",
            lessonSaved: "Aula salva.",
            thumbnailRemoved: "Thumbnail removida.",
          },
          confirm: {
            deleteCourse: "Excluir curso",
            deleteModule: "Excluir módulo",
            deleteLesson: "Excluir aula",
            message: "Esta ação não pode ser desfeita.",
          },
          courseModal: {
            addTitle: "Novo curso",
            editTitle: "Editar curso",
            title: "Título",
            description: "Descrição",
            published: "Publicado",
            thumbnail: "Thumbnail (imagem)",
            removeThumbnail: "Remover",
          },
          moduleModal: {
            addTitle: "Novo módulo",
            editTitle: "Editar módulo",
            title: "Título",
          },
          lessonModal: {
            addTitle: "Nova aula",
            editTitle: "Editar aula",
            title: "Título",
            description: "Descrição",
            videoUrl: "URL do vídeo (YouTube ou Vimeo)",
            currentVideo: "Vídeo atual",
            keepHint: "deixe a URL em branco para manter",
          },
        },
      },
      flowResults: {
        back: "Fluxos",
        edit: "Editar fluxo",
        view: "Ver fluxo",
        openEditor: "Abrir o editor",
        active: "Ativo",
        inactive: "Inativo",
        noDescription: "Sem descrição.",
        addDescription: "Adicionar",
        editDescription: "Editar",
        descriptionLabel: "Descrição do fluxo",
        descriptionPlaceholder: "Para que serve este fluxo?",
        save: "Salvar",
        cancel: "Cancelar",
        close: "Fechar",
        saved: "Salvo.",
        refresh: "Atualizar",
        refreshing: "Atualizando…",
        trackingSince: "Medindo desde {{date}}. Antes dessa data não há dado.",
        notTrackedYet: "Ainda sem medição: os números aparecem quando o primeiro contato passar pelo fluxo.",
        disabled: "A medição dos fluxos está desligada neste servidor. Os números não estão sendo atualizados.",
        period: {
          label: "Período",
          "7d": "7 dias",
          "30d": "30 dias",
          "90d": "90 dias",
          custom: "Personalizado",
          from: "De",
          to: "até",
          apply: "Aplicar",
          range: "{{from}} a {{to}}",
        },
        metrics: {
          entries: "Entradas",
          sent: "Enviadas",
          delivered: "Entregues",
          clicks: "Cliques",
          conversions: "Conversões",
          help: {
            entries: "Contatos que entraram no fluxo no período. Cada conversa conta uma vez.",
            sent: "Mensagens que o fluxo enviou e o WhatsApp aceitou.",
            delivered: "Mensagens que chegaram ao celular do contato.",
            clicks: "Links enviados pelo fluxo que o contato abriu. Cada link conta uma vez.",
            conversions: "Compras de quem recebeu mensagem deste fluxo antes de comprar.",
          },
          rate: {
            delivery: "{{value}} das enviadas",
            click: "{{value}} das entregues",
            conversion: "{{value}} das entradas",
          },
          inPeriod: "no período",
          messages: "mensagens",
          sendFailed: "{{count}} não foi enviada",
          sendFailed_plural: "{{count}} não foram enviadas",
          notConfigured: "Não configurado",
          unavailable: "Indisponível",
          configure: "Configurar",
          clicksUnavailableHint: "Este fluxo só envia modelos prontos, e o link deles não pode ser trocado.",
          clicksNotConfiguredHint: "Ligue o rastreio de links para contar.",
          conversionsNotConfiguredHint: "Ligue sua loja para contar as compras.",
          conversionValue: "{{value}} em vendas",
        },
        summary: {
          running: "{{count}} em andamento",
          completed: "{{count}} concluída",
          completed_plural: "{{count}} concluídas",
          failed: "{{count}} com falha",
          cancelled: "{{count}} cancelada",
          cancelled_plural: "{{count}} canceladas",
          read: "{{count}} lida ({{value}} das entregues)",
          read_plural: "{{count}} lidas ({{value}} das entregues)",
        },
        chart: {
          title: "Entradas por dia",
          hint: "Contatos que entraram no fluxo em cada dia.",
          empty: "Nenhuma entrada no período.",
          entries: "{{count}} entrada",
          entries_plural: "{{count}} entradas",
          day: "Dia",
        },
        history: {
          title: "Histórico de execuções",
          subtitle: "Cada contato que entrou no fluxo no período.",
          search: "Buscar por nome ou telefone",
          allStatuses: "Todos os estados",
          allKinds: "Todos os tipos",
          kind: "Tipo",
          columns: {
            contact: "Contato",
            startedAt: "Entrada",
            status: "Estado",
            step: "Etapa atual",
            duration: "Tempo",
            messages: "Mensagens",
          },
          empty: {
            title: "Nenhuma execução no período",
            description: "Quando um contato entrar no fluxo, ele aparece aqui.",
            filtered: "Nenhuma execução com esses filtros.",
          },
          loadMore: "Carregar mais",
          loading: "Carregando…",
          removedContact: "Contato removido",
          noContact: "Sem contato",
          steps: "{{count}} etapa percorrida",
          steps_plural: "{{count}} etapas percorridas",
          sentCount: "{{count}} enviada",
          sentCount_plural: "{{count}} enviadas",
          deliveredCount: "{{count}} entregue",
          deliveredCount_plural: "{{count}} entregues",
          failedMessages: "{{count}} com falha",
          searchWithOrder: "Buscar por nome, telefone ou número da OS",
          order: "OS {{number}}",
          orderStatus: "OS {{number}} · {{status}}",
        },
        status: {
          running: "Em andamento",
          completed: "Concluído",
          failed: "Falhou",
          cancelled: "Cancelado",
        },
        kind: {
          ai_agent: "Agente IA",
          mass_send: "Disparo em massa",
          triage: "Triagem IA",
          order_status: "Atualização de OS",
        },
        endReason: {
          resolved: "A IA encerrou o atendimento",
          transferred: "Passou para uma pessoa",
          ticket_closed: "A conversa foi encerrada",
          human_takeover: "Uma pessoa assumiu a conversa",
          flow_deactivated: "O fluxo foi desativado",
          ticket_removed: "A conversa foi apagada",
          inactivity: "O contato não escreveu mais",
          sent: "Mensagem enviada",
          send_failed: "O envio falhou",
          triage_completed: "Triagem concluída",
          triage_cancelled: "Triagem cancelada",
          triage_failed: "A triagem não pôde continuar",
          opt_out: "O cliente pediu para não receber mensagens",
          invalid_phone: "O aviso não trouxe um telefone válido",
          flow_inactive: "O fluxo foi desligado antes do envio",
          flow_invalid: "O gatilho não tem template ligado",
          expired: "A OS mudou de status há mais de 6 horas",
          event_missing: "Os dados do aviso não estão mais guardados",
          connection_invalid: "A conexão do gatilho não serve mais",
          connection_unavailable: "A conexão estava desconectada",
          template_check: "Não deu para ler os templates da conexão",
          template_unavailable: "O template não está disponível",
          invalid_variables: "Faltou um dado para o template",
          busy: "Outro envio para o cliente estava em andamento",
          send_uncertain: "Não deu para confirmar se saiu",
        },
        detail: {
          title: "Execução",
          openConversation: "Abrir conversa",
          summary: {
            startedAt: "Entrada",
            finishedAt: "Fim",
            stillRunning: "Em andamento",
            duration: "Tempo de execução",
            runs: "Respostas da IA",
          },
          messages: "Mensagens enviadas",
          noMessages: "Nenhuma mensagem enviada.",
          media: "Arquivo enviado",
          deletedMessage: "Mensagem apagada da conversa",
          messageStatus: {
            sent: "Enviada",
            notSent: "Não enviada",
            delivered: "Entregue",
            read: "Lida",
            failed: "Falhou",
          },
          error: "Erro",
          lastError: "Último erro (já recuperado)",
          reason: "Por que não foi enviada",
          orderNumber: "OS",
          orderStatus: "Status da OS",
          unknownError: "Erro sem descrição.",
          triageErrorHint: "O motivo está no acompanhamento da triagem (Fluxos > Gerenciar Triagens).",
          path: "Percurso no fluxo",
          version: "Versão {{number}} do fluxo",
          versionOld: "O fluxo foi editado depois. Este é o desenho que valia nesta execução.",
          noVersion: "O desenho do fluxo desta execução não foi guardado.",
          legend: {
            done: "Passou",
            current: "Etapa atual",
            error: "Falhou",
            pending: "Não passou",
          },
          links: "Links rastreados",
          clicks: "aberto {{count}} vez",
          clicks_plural: "aberto {{count}} vezes",
          notClicked: "não foi aberto",
          conversions: "Conversões",
          order: "Pedido {{id}}",
          reverted: "desfeita (estorno ou cancelamento)",
          timeline: "Linha do tempo",
          noEvents: "Nada registrado ainda.",
          tokens: "{{count}} tokens",
          unknownStep: "Etapa removida do fluxo",
          notFound: "Esta execução não existe mais.",
          event: {
            started: "Entrou no fluxo",
            finished: "Execução encerrada",
            runFailed: "A IA não conseguiu responder",
            nodeDone: "concluído",
            nodeFailed: "Falhou nesta etapa.",
            tool: "Ferramenta {{tool}}",
            linkClicked: "Abriu um link",
            conversion: "Compra atribuída a este fluxo",
          },
          action: {
            send: "A IA respondeu",
            escalate: "A IA passou a conversa para uma pessoa",
            silent: "A IA não respondeu",
            none: "Rodada sem resposta",
          },
        },
        measure: {
          button: "Medição",
          title: "Medição do fluxo",
          copy: "Copiar",
          copied: "Copiado.",
          links: {
            title: "Cliques em links",
            description: "Troca os links das mensagens da IA por um endereço que conta o clique e leva ao mesmo lugar.",
            toggle: "Rastrear links",
            hosts: "Sites rastreados",
            hostsHint: "Só links destes sites são trocados. Informe o site da sua loja.",
            hostPlaceholder: "minhaloja.com.br",
            addHost: "Adicionar",
            removeHost: "Remover {{host}}",
            note: "O link enviado junto com uma ação da IA (etiquetar, transferir) sai sem rastreio.",
            unavailable: "Este fluxo só envia modelos prontos, e o link deles não pode ser trocado.",
          },
          conversions: {
            title: "Conversões",
            description: "Conta as compras de quem recebeu mensagem deste fluxo antes de comprar.",
            source: "Loja",
            none: "Não medir conversões",
            webhookUrl: "Endereço de entrega",
            secret: "Segredo",
            secretOnce: "Copie o segredo agora. Ele não aparece de novo.",
            secretHidden: "O segredo já foi mostrado e não aparece de novo.",
            rotate: "Gerar outro",
            rotateWarning: "A loja usa o segredo atual. Ao gerar outro, os avisos dela deixam de ser aceitos até você colar o novo lá.",
            rotateConfirm: "Gerar outro segredo",
            howTo: "Na loja: WooCommerce > Configurações > Avançado > Webhooks. Crie um webhook com o tópico \"Pedido atualizado\" e cole o endereço e o segredo.",
            sourceError: "Problema no último aviso da loja: {{error}}",
            lastEvent: "Último aviso da loja {{when}}.",
            noEvents: "A loja ainda não mandou nenhum aviso.",
            window: "Prazo para contar",
            windowHint: "Tempo máximo entre a mensagem do fluxo e a compra.",
            days: "{{count}} dia",
            days_plural: "{{count}} dias",
            requireClick: "Só contar se o contato abriu um link do fluxo",
            newSource: "Ligar outra loja",
            firstSource: "Ligar uma loja",
            chooseIntegration: "Escolha a loja",
            create: "Gerar endereço",
            noIntegrations: "Cadastre a loja em Integrações para medir as conversões.",
          },
        },
        errors: {
          forbidden: "Só administradores veem os resultados dos fluxos.",
          notFound: "Este fluxo não existe mais.",
          load: "Não foi possível carregar os resultados.",
          retry: "Tentar de novo",
          history: "Não foi possível carregar o histórico.",
          execution: "Não foi possível carregar esta execução.",
        },
      },
      workOrders: {
        triage: {
          title: "Triagem",
          disabled: "A triagem por IA não está ligada nesta empresa.",
          waiting: "Aguardando para começar (próxima tentativa: {{when}}).",
          failed: "A triagem automática não começou:",
          none: "Nenhuma triagem para esta OS.",
          unnamed: "Triagem",
          openConversation: "Abrir conversa",
          noDefinitions: "Nenhuma triagem publicada começa por OS desta fonte. Ligue na aba Ordens de serviço da triagem (Fluxos > Gerenciar Triagens).",
          start: "Iniciar triagem",
          noPhones: "A OS não tem telefone que sirva para WhatsApp.",
          dialogTitle: "Iniciar triagem pela OS",
          definition: "Triagem",
          chooseDefinition: "Escolha a triagem",
          phone: "Telefone do cliente",
          mobile: "celular",
          landline: "fixo",
          connectionNote: "A conversa abre pela conexão:",
          dialogHint: "Se o cliente já estiver com um atendente, a IA não toma a conversa: a triagem espera e o atendente é avisado.",
          cancel: "Cancelar",
          confirm: "Iniciar",
          started: "Triagem iniciada: a IA vai procurar o cliente.",
          startedHuman: "O cliente já está com um atendente: a triagem ficou esperando e ele foi avisado.",
          chips: {
            waitingHuman: "Aguardando atendente",
            failed: "Não iniciada",
            scheduled: "Agendada",
            none: "Sem triagem",
          },
        },
        title: "Ordens de serviço",
        subtitle: "OS recebidas do sistema do fabricante, enviadas pelo coletor do posto.",
        configure: "Configurar em Integrações",
        search: "Buscar por nº da OS, nome, telefone ou CPF",
        allSources: "Todas as integrações",
        sourceFilter: "Integração",
        inactiveSource: "{{name}} (inativa)",
        sourceHealth: {
          online: "Online",
          offline: "Sem sinal",
          needs_login: "Esperando alguém entrar no portal",
          error: "Último ciclo com erro",
          never: "Coletor ainda sem sinal",
          inactive: "Desativada",
        },
        allStatuses: "Todos os estados",
        allTypes: "Todos os tipos",
        allWarranties: "Todas as garantias",
        warrantyFilter: {
          in: "Em garantia",
          out: "Fora da garantia",
          unknown: "Garantia não informada",
        },
        triageFilter: {
          label: "Triagem",
          all: "Todas",
        },
        sort: {
          label: "Ordenar",
          options: {
            received_desc: "Mais recentes primeiro",
            received_asc: "Mais antigas primeiro",
            number_asc: "Nº da OS, do menor",
            number_desc: "Nº da OS, do maior",
            customer_asc: "Cliente, de A a Z",
            customer_desc: "Cliente, de Z a A",
            city_asc: "Cidade, de A a Z",
            city_desc: "Cidade, de Z a A",
            product_asc: "Produto, de A a Z",
            product_desc: "Produto, de Z a A",
            triage_asc: "Triagem, o que pede alguém primeiro",
            triage_desc: "Triagem, na ordem inversa",
          },
        },
        total: "{{count}} OS",
        loadMore: "Carregar mais",
        updatesAvailable: "Há OS novas ou alteradas.",
        refresh: "Atualizar",
        columns: {
          number: "Nº da OS",
          received: "Recebida",
          status: "Estado",
          type: "Tipo",
          warranty: "Garantia",
          customer: "Cliente",
          city: "Cidade",
          product: "Produto",
          triage: "Triagem",
        },
        empty: {
          title: "Nenhuma OS recebida ainda",
          description: "Assim que o coletor do posto enviar as OS, elas aparecem aqui.",
          filtered: "Nenhuma OS encontrada com esses filtros.",
          noSources: "Esta empresa ainda não recebe OS. A ativação é feita pela Sttelar.",
        },
        source: {
          online: "{{name}}: online, último sinal {{time}}",
          offline: "{{name}}: sem sinal ({{time}}). Confira se o computador do posto está ligado e com internet.",
          needs_login: "{{name}}: o coletor está esperando alguém entrar no portal do fabricante, na janela do robô.",
          error: "{{name}}: o último ciclo do coletor deu erro: {{error}}",
          never: "{{name}}: o coletor ainda não mandou sinal. Configure-o no computador do posto com o token da integração.",
          inactive: "{{name}}: fonte desativada.",
        },
        detail: {
          title: "OS {{number}}",
          close: "Fechar",
          customer: "Cliente",
          name: "Nome",
          document: "CPF/CNPJ",
          phones: "Telefones",
          mentionedWhatsapp: "WhatsApp citado no texto",
          email: "E-mail",
          address: "Endereço",
          product: "Produto",
          brandModel: "Marca e modelo",
          serial: "Número de série",
          category: "Categoria",
          purchaseDate: "Data de compra",
          warrantyEnd: "Fim da garantia",
          warrantyStatus: "Garantia",
          invoice: "Nota fiscal",
          invoiceNumber: "Número da NF",
          reseller: "Revendedor",
          request: "Solicitação do cliente",
          symptom: "Sintoma",
          notes: "Observação do fabricante",
          service: "Atendimento",
          type: "Tipo",
          urgency: "Urgência",
          visit: "Visita agendada",
          acceptedAt: "Aceita pelo posto em",
          openedAt: "Aberta em",
          receipt: "Recebimento",
          receivedAt: "Chegou ao Sttelar Talk",
          lastChangedAt: "Última mudança",
          lastSeenAt: "Último envio do coletor",
          source: "Fonte",
          purged: "Os dados desta OS foram apagados pela retenção.",
        },
      },
      triage: {
        tab: "Triagem",
        badge: "Triagem {{done}}/{{total}}",
        badgeTooltip: "Abrir a triagem desta conversa",
        sessionStatus: {
          PENDING: "Aguardando início",
          IN_PROGRESS: "Em andamento",
          WAITING_CUSTOMER: "Aguardando o cliente",
          COMPLETED: "Concluída",
          CANCELLED: "Cancelada",
          FAILED: "Com falha",
        },
        requirementStatus: {
          NOT_REQUESTED: "Não pedido",
          REQUESTED: "Pedido",
          PROCESSING: "Em análise",
          COMPLETED: "Recebido",
          INVALID: "Inválido",
          WAITING_RESEND: "Aguardando reenvio",
          WAIVED: "Dispensado",
        },
        inputTypes: {
          text: "Texto",
          image: "Imagem",
          document: "Documento",
          document_or_image: "Documento ou imagem",
          video: "Vídeo",
          audio: "Áudio",
        },
        fieldTypes: {
          string: "Texto",
          number: "Número",
          date: "Data",
          cpf_cnpj: "CPF/CNPJ",
          nfe_key: "Chave de NF-e",
          phone: "Telefone",
          email: "E-mail",
        },
        events: {
          TRIAGE_CREATED: "Triagem iniciada",
          TRIAGE_STARTED: "IA começou a conduzir",
          TRIAGE_COMPLETED: "Triagem concluída",
          TRIAGE_HANDOFF: "Entregue à equipe",
          TRIAGE_CANCELLED: "Triagem cancelada",
          TRIAGE_FAILED: "Triagem com falha",
          OUTREACH_SENT: "Mensagem de abertura enviada",
          OUTREACH_FAILED: "Falha ao enviar a abertura",
          FOLLOWUP_SENT: "Lembrete enviado",
          FOLLOWUP_SKIPPED: "Lembrete não enviado",
          REQUIREMENT_REQUESTED: "Item pedido",
          REQUIREMENT_RECEIVED: "Item recebido para análise",
          REQUIREMENT_VALIDATED: "Item validado",
          REQUIREMENT_REJECTED: "Item marcado como inválido",
          ERROR_CODE_DETECTED: "Código de erro identificado",
          REQUIREMENT_WAIVED: "Item dispensado",
          REQUIREMENT_MANUALLY_COMPLETED: "Item marcado como recebido",
          AI_PAUSED: "IA pausada",
          AI_RESUMED: "IA retomada",
          CRM_MOVED: "Card movido no CRM",
          CRM_SKIPPED: "CRM não alterado",
          NOTE_UPDATED: "Anotação atualizada",
          CONTACT_RENAMED: "Nome do contato montado pela triagem",
          DATA_PURGED: "Documentos e dados apagados (retenção de 90 dias)",
          CUSTOMER_EXPORTED: "Local enviado ao Contele",
          CUSTOMER_EXPORT_FAILED: "Falha ao enviar o Local ao Contele",
          CUSTOMER_EXPORT_SKIPPED: "Local não enviado ao Contele",
          ERROR: "Erro",
        },
        noteStages: {
          created: "Nota-resumo criada nas anotações",
          final: "Nota-resumo final nas anotações",
        },
        crmReasons: {
          moved_by_person: "o card foi movido por uma pessoa",
          column_missing: "a coluna de destino não existe mais",
          card_deleted: "o card foi apagado",
        },
        followUpEvents: {
          sent: "{{n}}º lembrete enviado",
          skipped: "{{n}}º lembrete não enviado",
          template: "template {{name}}",
        },
        followUpReasons: {
          window_closed: "a janela de 24 h da API oficial estava fechada e o lembrete não tem template",
        },
        customerExport: {
          status: {
            sentCreated: "Local criado no Contele em {{date}}",
            sentUpdated: "Local atualizado no Contele em {{date}}",
            pending: "Enviando o Local ao Contele…",
            retrying: "O Contele não respondeu: nova tentativa em {{date}}",
            failed: "Local não enviado ao Contele: {{reason}}",
            skipped: "Local não enviado ao Contele: {{reason}}",
          },
          reasons: {
            auth: "o Contele recusou as chaves da conta",
            rejected: "o Contele recusou os dados",
            unavailable: "o Contele não respondeu",
            integration_missing: "a conta do Contele foi removida",
            integration_inactive: "a conta do Contele está desativada",
            keys_missing: "a conta do Contele está sem as chaves",
            data_purged: "os dados da triagem já foram apagados",
            internal: "erro no Talk ao enviar",
            no_name: "falta o nome do cliente",
            no_address: "falta o endereço do cliente",
          },
          outcomes: {
            created: "Local novo",
            updated: "Local atualizado",
          },
          addressChanged: "endereço novo",
          mediaLink: "com o link das mídias",
          account: "Conta: {{name}}",
          retrying: "vai tentar de novo",
          retry: "Enviar de novo",
          retried: "Enviando o Local ao Contele de novo",
        },
        actors: {
          system: "Sistema",
          ai: "IA",
          customer: "Cliente",
          integration: "Integração",
        },
        attention: {
          customer_requested_human: "o cliente pediu para falar com uma pessoa",
          customer_refused: "o cliente não quis continuar a triagem",
          cannot_provide: "o cliente disse que não tem um item obrigatório",
          max_attempts: "as tentativas de um item acabaram",
          ai_unavailable: "a IA ficou indisponível (confira a chave e os créditos da OpenAI em Integrações)",
          ai_limit: "a triagem chegou ao limite de chamadas à IA",
          ai_quota: "as mensagens da IA do mês acabaram",
          billing_suspended: "o envio está suspenso pelo atraso no pagamento",
          send_failed: "não foi possível enviar a resposta ao cliente",
          ticket_with_human: "a OS chegou com o cliente em atendimento: entregue à IA quando quiser",
          no_response: "o cliente não respondeu no prazo da triagem",
          no_reply_to_reminders: "o cliente não respondeu aos lembretes",
        },
        crm: {
          card: "Triagem {{done}}/{{total}}",
          cardPending: "Triagem aguardando início",
          cardAttention: "Triagem: chamar uma pessoa",
          cardCompleted: "Triagem concluída",
          cardCancelled: "Triagem cancelada",
          cardFailed: "Triagem com falha",
          section: "Triagem",
          progress: "{{done}} de {{total}} obrigatórios",
          workOrder: "OS {{number}}",
          openConversation: "Abrir conversa",
          loadError: "Não deu para carregar a triagem deste card.",
        },
        panel: {
          empty: "Nenhuma triagem em andamento nesta conversa.",
          start: "Iniciar triagem",
          chooseDefinition: "Escolha a triagem",
          noDefinitions: "Nenhuma triagem publicada. Um administrador cria em Fluxos > Gerenciar Triagens.",
          group: "Triagem não funciona em conversas de grupo.",
          closed: "Reabra a conversa para iniciar uma triagem.",
          started: "Triagem iniciada.",
          progress: "{{done}} de {{total}} obrigatórios",
          version: "versão {{version}}",
          aiActive: "IA ativa nesta conversa",
          aiPaused: "Uma pessoa conduz a conversa; a IA não responde",
          attention: "Precisa de atenção: {{reason}}",
          nextFollowUp: "Próximo lembrete ({{n}}º de {{total}}): {{date}}",
          nextHandoff: "Sem resposta aos lembretes, passa para uma pessoa em {{date}}",
          workOrder: "OS {{number}}",
          pause: "Pausar IA",
          resume: "Entregar à IA",
          complete: "Concluir",
          cancel: "Cancelar",
          required: "Obrigatório",
          optional: "Opcional",
          attempts: "Tentativa {{attempts}} de {{max}}",
          reason: "Motivo: {{reason}}",
          routedBy: "Pela regra {{detail}}",
          warrantyList: "Lista: {{list}}",
          purged: "Documentos e dados apagados pela retenção em {{date}}.",
          note: "Nota: {{note}}",
          itemActions: "Ações do item",
          actions: {
            complete: "Marcar como recebido",
            invalidate: "Marcar como inválido",
            request: "Marcar como pedido",
            waive: "Dispensar",
            edit: "Corrigir dados",
          },
          timeline: "Linha do tempo",
          history: "Triagens anteriores",
          viewing: "Triagem de {{date}}",
          back: "Voltar",
          unverified: "enviado pelo cliente, sem conferência",
          workOrderToConfirm: "da OS, a confirmar com o cliente",
          problem: {
            title: "Problema do cliente",
            code: "Código de erro {{code}}",
            from: {
              workOrder: "da OS, confirmado pelo cliente",
              manual: "registrado por uma pessoa",
              video: "visto no vídeo",
              audio: "falado pelo cliente",
              customer: "informado pelo cliente",
              attachment: "enviado pelo cliente",
            },
            via: {
              message: "código informado pelo cliente",
              photo: "código lido na foto",
              video: "código visto no vídeo",
            },
          },
          workOrderConfirmed: "da OS, confirmado pelo cliente",
          evidenceOpen: "Abrir o anexo",
          evidenceUnread: "A IA não leu este anexo: confira",
          evidencePhoto: "Foto enviada pelo cliente",
          evidenceKinds: {
            pdf: "PDF",
            file: "Arquivo",
            video: "Vídeo",
            audio: "Áudio",
          },
          answer: "Resposta",
          confidence: "Confiança da leitura da IA",
        },
        dialogs: {
          back: "Voltar",
          confirm: "Confirmar",
          reasonLabel: "Motivo",
          reasonRequired: "Informe o motivo.",
          noteLabel: "Nota (opcional)",
          cancelTitle: "Cancelar a triagem",
          cancelText: "A triagem para aqui e fica no histórico. Se a conversa estava com a IA, ela passa para você.",
          completeTitle: "Concluir a triagem",
          completeText: "Os itens que faltam ficam como estão. Se a conversa estava com a IA, ela passa para você.",
          completePending: "Itens obrigatórios que ainda faltam: {{count}}.",
          invalidateTitle: "Marcar \"{{name}}\" como inválido",
          invalidateText: "Os dados que estavam neste item são descartados.",
          waiveTitle: "Dispensar \"{{name}}\"",
          waiveText: "O item deixa de ser pedido ao cliente.",
          completeItemTitle: "Marcar \"{{name}}\" como recebido",
          completeItemText: "Preencha o que você conferiu (opcional).",
          requestTitle: "Marcar \"{{name}}\" como pedido",
          requestText: "Registra que o item foi pedido ao cliente. Nenhuma mensagem é enviada daqui.",
        editItemTitle: "Corrigir os dados de \"{{name}}\"",
        },
        manager: {
          button: "Gerenciar Triagens",
          title: "Triagens",
          tabs: {
            definitions: "Triagens",
            sessions: "Acompanhamento",
          },
          new: "Nova triagem",
          empty: "Nenhuma triagem cadastrada.",
          emptyHint: "Uma triagem define o que a IA pede ao cliente (fotos, documentos, dados) e o que fazer quando tudo chegar.",
          status: {
            draft: "Rascunho",
            active: "Publicada",
            archived: "Arquivada",
          },
          publishedVersion: "Versão {{version}} publicada",
          notPublished: "Nunca publicada",
          activeSessions: "{{count}} em andamento",
          updatedAt: "Alterada em {{date}}",
          showArchived: "Mostrar arquivadas",
          actions: {
            edit: "Editar",
            duplicate: "Duplicar",
            archive: "Arquivar",
            restore: "Restaurar",
          },
          copyName: "{{name}} (cópia)",
          archiveConfirm: "Arquivar \"{{name}}\"? Ela sai das opções de início; as triagens em andamento continuam.",
          archived: "Triagem arquivada.",
          restored: "Triagem restaurada.",
          duplicated: "Cópia criada como rascunho.",
          published: "Versão {{version}} publicada.",
          saved: "Rascunho salvo.",
          editor: {
            back: "Voltar para a lista",
            newTitle: "Nova triagem",
            howItWorks: "Como funciona",
            tabs: {
              general: "Geral",
              items: "Itens",
              messages: "Mensagens",
              outreach: "Contato ativo",
              workOrders: "Ordens de serviço",
              contact: "Cadastro do contato",
              crm: "CRM",
              followUp: "Lembretes",
              completion: "Conclusão",
            },
            save: "Salvar rascunho",
            publish: "Publicar",
            unpublished: "Há mudanças não publicadas.",
            upToDate: "Versão {{version}} publicada, sem mudanças pendentes.",
            neverPublished: "Rascunho: ainda não publicada.",
            unsaved: "Mudanças não salvas",
            discardConfirm: "Há mudanças não salvas. Sair e descartar?",
            errors: {
              name: "Dê um nome à triagem.",
              noItems: "Adicione ao menos um item.",
              noRequired: "Marque ao menos um item como obrigatório.",
              itemName: "Item {{n}}: dê um nome ao item.",
              itemRequest: "Item {{n}}: escreva a mensagem para pedir.",
              fieldLabel: "Item {{n}}: dê um nome a cada campo de extração.",
              noFields: "Item {{n}}: adicione ao menos um campo ou desligue a extração.",
              completion: "Escreva a mensagem de conclusão.",
              outreachVariable: "Contato ativo: escolha o valor da variável {{n}} do template.",
              outreachFixed: "Contato ativo: escreva o texto fixo da variável {{n}} do template.",
              outreachWorkOrder: "Contato ativo: o template usa dados da OS; ligue o início na aba Ordens de serviço.",
              workOrderSource: "Ordens de serviço: escolha a fonte das OS.",
              workOrderStatuses: "Ordens de serviço: escolha ao menos um estado.",
              workOrderTypes: "Ordens de serviço: escolha ao menos um tipo de OS.",
              workOrderDays: "Ordens de serviço: escolha ao menos um dia para o envio.",
              workOrderWindow: "Ordens de serviço: o horário de envio deve terminar depois de começar.",
              workOrderConnection: "Ordens de serviço: escolha, na aba Contato ativo, a conexão que abre a conversa.",
              crmBoard: "CRM: escolha o quadro.",
              crmEntry: "CRM: escolha a coluna de entrada.",
              crmCompleted: "CRM: escolha a coluna de concluídas.",
              crmSame: "CRM: a entrada e as concluídas precisam ser colunas diferentes.",
              crmRule: "CRM, regra {{n}}: escolha o item e a coluna.",
              crmCompletedOnly: "CRM: a coluna de concluídas é só para as triagens concluídas; escolha outra para \"em triagem\", atenção e regras.",
              crmOnlyPending: "CRM, regra {{n}}: \"único obrigatório que falta\" só vale para item obrigatório.",
              routeValues: "Encaminhamento, regra {{n}}: informe ao menos um valor.",
              routeTooMany: "Encaminhamento, regra {{n}}: no máximo {{max}} valores.",
              routeLong: "Encaminhamento, regra {{n}}: cada valor pode ter até {{max}} caracteres.",
              routeDestination: "Encaminhamento, regra {{n}}: escolha a fila ou a pessoa.",
              warrantyRequired: "{{list}}: marque ao menos um item como obrigatório.",
              routeValuesAt: "Encaminhamento, regra {{n}}, dado {{m}}: informe ao menos um valor.",
              routeTooManyAt: "Encaminhamento, regra {{n}}, dado {{m}}: no máximo {{max}} valores.",
              routeLongAt: "Encaminhamento, regra {{n}}, dado {{m}}: cada valor pode ter até {{max}} caracteres.",
              routeRepeated: "Encaminhamento, regra {{n}}: use cada dado da OS uma vez só.",
              customerExportAccount: "Contele: escolha a conta onde o Local é criado.",
              customerExportNeedsWorkOrders: "Contele: o Local usa os dados da OS; ligue o início na aba Ordens de serviço.",
              followUpNone: "Lembretes: adicione ao menos um lembrete ou desligue os lembretes.",
              followUpTime: "{{n}}º lembrete: o tempo sem resposta vai de 10 minutos a 30 dias.",
              followUpOrder: "{{n}}º lembrete: precisa de mais tempo sem resposta que o anterior.",
              followUpMessage: "{{n}}º lembrete: escreva a mensagem.",
              followUpVariable: "{{n}}º lembrete: escolha o valor da variável {{v}} do template.",
              followUpFinal: "Lembretes: passar para uma pessoa precisa de mais tempo sem resposta que o último lembrete (até 30 dias).",
              followUpDays: "Lembretes: escolha ao menos um dia para o envio.",
              followUpWindow: "Lembretes: o horário de envio deve terminar depois de começar.",
              followUpExpire: "Lembretes: o último passo precisa vir antes de a triagem expirar ({{days}} dias sem resposta, na aba Conclusão).",
              contactNameEmpty: "Cadastro do contato: escreva como fica o nome ou desligue a opção.",
              contactNameTooLong: "Cadastro do contato: o nome pode ter até {{max}} caracteres.",
              contactNameLines: "Cadastro do contato: o nome fica numa linha só.",
              contactNameBraces: "Cadastro do contato: falta abrir ou fechar uma chave { }.",
              contactNameToken: "Cadastro do contato: {{token}} não pode ir no nome. Use os botões abaixo do campo.",
              contactNameWorkOrder: "Cadastro do contato: {{token}} usa dados da OS; ligue o início na aba Ordens de serviço.",
              contactNameNoData: "Cadastro do contato: coloque ao menos um dado no nome (botões abaixo do campo).",
              contactNameTooMany: "Cadastro do contato: use no máximo {{max}} dados no nome.",
            },
            general: {
              name: "Nome",
              namePlaceholder: "Ex.: Garantia Midea",
              description: "Descrição (opcional)",
              model: "Modelo de IA",
              modelHint: "A chave da OpenAI vem de Integrações.",
              aiUser: "Usuário IA",
              aiUserHint: "Aparece como dono da conversa enquanto a IA conduz. Precisa estar com \"IA Ativa\" desligado no cadastro de usuários.",
              aiUserNone: "Escolha um usuário IA",
              aiUserUnusable: "{{name}} (IA Ativa ligada)",
              noAiUsers: "Nenhum usuário IA nesta empresa. Crie um em Usuários, marcado como IA e com \"IA Ativa\" desligado.",
              waitTime: "Espera antes de responder (segundos)",
              waitTimeHint: "Junta mensagens seguidas do cliente numa resposta só.",
            },
            items: {
              add: "Adicionar item",
              empty: "Nenhum item. Adicione o que a IA deve pedir ao cliente.",
              untitled: "Item sem nome",
              name: "Nome do item",
              namePlaceholder: "Ex.: Foto da etiqueta",
              key: "Chave",
              keyHint: "Identificador interno: letras minúsculas, números e _.",
              description: "Descrição (opcional)",
              inputType: "O cliente envia",
              required: "Obrigatório",
              requestMessage: "Mensagem para pedir",
              requestPlaceholder: "Ex.: Por favor, envie uma foto da etiqueta do aparelho.",
              workOrderField: "Dado da OS para confirmar",
              workOrderFieldHint: "Com a triagem começando pela OS, a IA mostra este dado e o cliente confirma ou corrige, em vez de digitar tudo. CPF e campos sensíveis nunca aparecem na mensagem.",
              workOrderFieldNone: "Nenhum: pedir ao cliente",
              compareWith: "Comparar com a OS",
              compareWithNone: "Não comparar",
              compareWithFields: {
                productModel: "Modelo do produto",
                serialNumber: "Número de série",
                invoiceNumber: "Número da nota fiscal",
                purchaseDate: "Data de compra",
                customerDocument: "CPF/CNPJ do cliente",
              },
              workOrderFields: {
                address: "Endereço do cliente",
                buyer: "Nome e CPF/CNPJ do cliente",
                product: "Marca e modelo do produto",
                purchaseDate: "Data de compra",
                problem: "Solicitação do cliente (defeito)",
                invoiceNumber: "Número da nota fiscal",
              },
              retryMessage: "Mensagem para pedir de novo (opcional)",
              aiInstruction: "Instrução para a IA (opcional)",
              aiInstructionPlaceholder: "Ex.: A etiqueta fica na lateral da unidade interna.",
              maxAttempts: "Tentativas",
              onMaxAttempts: "Quando as tentativas acabarem",
              onMax: {
                handoff: "Chamar uma pessoa",
                waive: "Dispensar o item",
                keep_asking: "Continuar pedindo",
              },
              optionalOnMax: "Item opcional: no limite, é dispensado.",
              extraction: "Extrair dados do que o cliente enviar",
              extractionHint: "A IA lê o que chegou e preenche estes campos.",
              minConfidence: "Confiança mínima (%)",
              addField: "Adicionar campo",
              fieldLabel: "Nome do campo",
              fieldKey: "Chave",
              fieldType: "Tipo",
              fieldRequired: "Obrigatório",
              fieldSensitive: "Sensível",
              fieldSensitiveHint: "Mascarado em logs e na linha do tempo.",
              moveUp: "Subir",
              moveDown: "Descer",
              remove: "Remover",
              expand: "Editar item",
              extractsData: "extrai dados",
              isProblem: "Problema do cliente",
              isProblemHint: "Confirmado, aparece no topo do painel do atendente, com o código de erro que o cliente informar na conversa (escrito, falado, na foto do visor ou no vídeo).",
              warranty: {
                split: "Itens diferentes em garantia e fora da garantia",
                splitInfo: "A garantia vem da OS quando a triagem começa. Cada item vale em garantia, fora ou nas duas situações, e a IA pede só os itens da situação da OS.",
                whenUnknown: "Sem a garantia na OS, usar a lista",
                noWorkOrders: "Sem o início pelas OS, toda triagem usa a lista {{list}}.",
                lists: { in: "Em garantia", out: "Fora da garantia" },
                listsAria: "Lista de itens",
                askIn: "Pedir em",
                askInOptions: { both: "Em garantia e fora", in: "Só em garantia", out: "Só fora da garantia" },
                both: "em garantia e fora",
                removeFromList: "Tirar desta lista",
                viewingIn: "O que a IA pede quando a OS está em garantia",
                viewingOut: "O que a IA pede quando a OS está fora da garantia",
                allBoth: "Por enquanto, todos os itens valem em garantia e fora. Para separar, abra um item e escolha em “Pedir em”.",
                emptyList: "Nenhum item nesta lista. Adicione o que a IA deve pedir.",
                turnOffTitle: "Juntar as listas?",
                turnOffText: "As duas listas viram uma só: a IA passa a pedir os {{count}} itens em toda OS.",
                turnOffConfirm: "Juntar",
              },
            },
            messages: {
              replyMode: "Como a IA escreve",
              replyModes: {
                humanized: "Com as próprias palavras, usando as mensagens como base",
                configured: "Exatamente as mensagens configuradas",
              },
              persona: "Persona (opcional)",
              personaPlaceholder: "Ex.: Assistente da assistência técnica. Tom cordial e objetivo, frases curtas.",
              supportText: "Texto de apoio (opcional)",
              supportTextHint: "Informações que a IA pode usar para tirar dúvidas: prazos, horários, endereço.",
              intro: "Mensagem de abertura (opcional)",
              introHint: "Enviada quando a triagem começa.",
              completion: "Mensagem de conclusão",
              completionPlaceholder: "Ex.: Obrigado! Já temos tudo. Nossa equipe vai entrar em contato para agendar.",
              byWarranty: {
                supportText: "Texto de apoio de cada garantia (opcional)",
                completion: "Mensagem de conclusão de cada garantia (opcional)",
                hint: "Vazio: vale o texto de cima.",
              },
            },
            completion: {
              ticketAction: "Quando a triagem terminar",
              actions: {
                close: "Encerrar a conversa",
                keep_pending: "Passar para a equipe",
              },
              ticketActionInfo: "Antes, a IA manda a mensagem de conclusão ao cliente. Se uma pessoa concluir pelo painel, a conversa fica com ela.",
              handoff: "Quando a IA chamar uma pessoa",
              handoffInfo: "Acontece quando o cliente pede um atendente, não responde aos lembretes, esgota as tentativas de um item ou a IA não consegue seguir. Com um atendente escolhido, a conversa vai para ele; sem atendente, fica aguardando na fila.",
              destination: {
                queue: "Fila",
                queueKeep: "Manter a fila atual",
                queueNone: "Sem fila",
                user: "Atendente",
                userNone: "Ninguém: fica aguardando",
                removed: "A fila ou o atendente escolhido mudou (foi apagado ou saiu da fila). Escolha de novo ou deixe em branco.",
              },
              expireTitle: "Cliente parou de responder",
              expireBefore: "Encerrar a triagem depois de",
              expireUnit: "dias (0 = nunca)",
              expireInfo: "A triagem expira e o card do CRM vai para a coluna de atenção. Se a IA estava com a conversa, ela é encerrada sem avaliação e sem mensagem.",
            },
            routes: {
              title: "Exceções pela OS",
              info: "Conforme os dados da OS, mandam a conversa para outra fila ou atendente, no lugar do que está acima (mesmo com “Encerrar a conversa”). Vale a primeira que servir, de cima para baixo.",
              needsWorkOrders: "Só vale com o início pelas OS (aba Ordens de serviço).",
              editRule: "Editar a regra {{n}}",
              noValue: "sem valor",
              goesTo: "Vai para {{destination}}",
              noDestination: "Escolha para onde vai",
              field: "Dado da OS",
              match: "Comparação",
              fields: {
                model: "Modelo",
                brand: "Marca",
                category: "Categoria",
                type: "Tipo da OS",
                warranty: "Garantia",
                city: "Cidade",
                state: "Estado (UF)",
              },
              matches: {
                equals: "é um destes",
                startsWith: "começa com",
                contains: "contém",
              },
              values: "Valores (um por linha)",
              valuesHint: "Pode colar uma lista; maiúsculas e acentos não importam.",
              placeholders: {
                model: "UN50TU8000GXZD\nQN50Q60TAGXZD",
                brand: "Samsung",
                category: "LED TV",
                type: "Em domicílio",
                warranty: "Fora da garantia",
                city: "Passo Fundo",
                state: "RS",
              },
              destination: "Vai para",
              add: "Adicionar regra",
              and: "E",
              addCondition: "E também",
              removeCondition: "Tirar este dado",
              joinLast: "e",
              moveUp: "Subir",
              moveDown: "Descer",
              remove: "Remover regra",
            },
            customerExport: {
              title: "Contele",
              info: "Ao concluir (pela IA ou por uma pessoa), cria no Contele o Local da OS com o nº da OS, o nome, o CPF, o endereço e o telefone do cliente. Se a OS voltar à triagem, o mesmo Local é atualizado, sem apagar o que o time escreveu.",
              enabled: "Criar o Local da OS ao concluir",
              account: "Conta do Contele",
              accountChoose: "Escolha a conta",
              inactiveTag: "desativada",
              inactive: "Esta conta está desativada em Integrações: os envios falham até ela ser ligada de novo.",
              removed: "A conta escolhida foi removida. Escolha outra.",
              removedNone: "A conta escolhida foi removida e não há outra. A Sttelar cadastra em Integrações.",
              noAccounts: "Nenhuma conta do Contele cadastrada. A Sttelar cadastra em Integrações.",
              needsWorkOrders: "Precisa do início pelas OS (aba Ordens de serviço).",
              items: "Levar junto",
              itemsInfo: "O texto vai nas Observações do Local. Foto, vídeo e documento vão por um link que vale 60 dias: quem tiver o link vê os arquivos, sem login.",
              byLink: "pelo link",
            },
            followUp: {
              intro: "Quando o cliente para de responder, a IA manda um lembrete do que falta. O tempo conta a partir do último pedido da IA; se o cliente responder, a contagem recomeça no pedido seguinte.",
              enabled: "Lembrar o cliente que parou de responder",
              stageTitle: "{{n}}º lembrete",
              remove: "Remover lembrete",
              removeStage: "Remover o {{n}}º lembrete",
              after: "Enviar com o cliente sem responder há",
              unit: "Unidade",
              units: {
                minutes: "minutos",
                hours: "horas",
                days: "dias",
              },
              message: "Mensagem",
              messagePlaceholder: "Ex.: Oi, {primeiro_nome}! Ainda aguardamos {item} para seguir com o seu atendimento.",
              messageHint: "A IA escreve o lembrete com as próprias palavras, a partir desta mensagem. Use {primeiro_nome} e {item} (o que falta o cliente mandar).",
              messageHintConfigured: "Enviada exatamente assim. Use {primeiro_nome} e {item} (o que falta o cliente mandar).",
              template: "Template (janela de 24 h fechada)",
              templateHint: "Na API oficial, depois de 24 h sem o cliente escrever, só dá para mandar template. Sem template, o lembrete é pulado nesse caso.",
              templateNone: "Nenhum",
              needsTemplate: "Com 24 h ou mais sem resposta, a janela da API oficial já fechou: sem template, este lembrete não sai.",
              add: "Adicionar lembrete",
              final: "Depois do último lembrete",
              finalWait: "Continuar esperando (a triagem expira com {{days}} dias sem resposta, pela aba Conclusão)",
              finalWaitNever: "Continuar esperando (sem prazo: a aba Conclusão está com 0)",
              finalHandoff: "Passar a conversa para uma pessoa",
              finalAfter: "Com o cliente sem responder há",
              finalToUserQueue: "Vai para {{user}}, em Atendendo, na fila {{queue}}.",
              finalToUser: "Vai para {{user}}, em Atendendo, sem fila.",
              finalToQueue: "Fica aguardando, sem dono, na fila {{queue}}.",
              finalToKeep: "Fica aguardando, sem dono, na fila em que está.",
              finalFrom: "É o destino de \"Quando a IA passar a conversa para uma pessoa\", na aba Conclusão.",
              finalChange: "Mudar destino",
              finalRoutesFirst: "Antes, valem as regras de \"Encaminhar pelos dados da OS\".",
              finalCrmNothingSent: "O card do CRM vai para a atenção. Nada é enviado ao cliente.",
              finalNothingSent: "Nada é enviado ao cliente.",
              window: "Horário de envio",
              windowHint: "Dias e horário (de Brasília) em que um lembrete pode sair. Fora dele, o lembrete espera o próximo horário.",
              countNote: "Exemplo: com lembretes em 4 horas e 1 dia, o cliente que não responder ao pedido das 10h recebe um às 14h e outro às 10h do dia seguinte.",
              stopNote: "Os lembretes param quando o cliente responde, quando uma pessoa assume ou pausa a IA, e quando a triagem termina.",
              metaNote: "API oficial: dentro da janela de 24 h o lembrete sai como mensagem comum; fora dela, só com o template escolhido no lembrete.",
              defaultMessage1: "Oi, {primeiro_nome}! Ainda estamos aguardando {item} para seguir com o seu atendimento.",
              defaultMessage2: "{primeiro_nome}, só lembrando: para continuar o atendimento, precisamos de {item}. É só mandar por aqui.",
            },
            crm: {
              intro: "O card da triagem num quadro do CRM: ele nasce quando a triagem começa e anda sozinho pelas colunas até a de concluídas, onde a equipe de agendamento trabalha.",
              enabled: "Criar e mover o card da triagem no CRM",
              noBoards: "Esta empresa ainda não tem quadro no CRM. Crie um na tela do CRM.",
              board: "Quadro",
              boardNone: "Escolha o quadro",
              columnChoose: "Escolha a coluna",
              columnNone: "Nenhuma (o card fica onde está)",
              entry: "Entrada",
              entryHint: "Onde o card nasce, quando a triagem começa.",
              inProgress: "Em triagem",
              inProgressHint: "Enquanto a IA conduz. Sem ela, o card fica na entrada.",
              attention: "Atenção",
              attentionHint: "Quando a triagem chama uma pessoa ou expira sem resposta.",
              completed: "Concluídas",
              completedHint: "Quando a triagem termina.",
              rules: "Regras por item",
              rulesHint: "Colunas para momentos da triagem (ex.: \"Aguardando nota fiscal\"). Vale a primeira regra que casar, na ordem da lista.",
              ruleItem: "Item",
              ruleItemChoose: "Escolha o item",
              ruleWhen: "Quando",
              ruleColumn: "Coluna",
              ruleRemove: "Remover regra",
              whenOptions: {
                awaiting: "Esperando o cliente",
                only_pending: "Único obrigatório que falta",
              },
              addRule: "Adicionar regra",
              manualNote: "Card que alguém mover para uma coluna fora destas fica onde a pessoa deixou: a triagem não mexe mais nele.",
              cancelNote: "Triagem cancelada por uma pessoa: o card fica onde está.",
            },
            contact: {
              intro: "Monte o nome do contato com dados da triagem, como o número da OS e o nome confirmado. Assim a equipe acha a conversa pela busca.",
              enabled: "Montar o nome do contato com os dados da triagem",
              format: "Nome do contato",
              formatPlaceholder: "Ex.: {os} {nome}",
              formatHint: "Use os botões abaixo para colocar os dados. Pode escrever texto entre eles.",
              groups: {
                contact: "Do contato",
                workOrder: "Da OS",
                items: "Confirmados na conversa",
              },
              tokens: {
                nome: "Nome do cliente",
                primeiro_nome: "Primeiro nome",
                os: "Número da OS",
              },
              workOrderOff: "Para usar os dados da OS, ligue o início pelas OS.",
              workOrderOpen: "Abrir Ordens de serviço",
              itemsNone: "Nenhum item tem dado que possa ir no nome.",
              itemsExcluded: "CPF/CNPJ, campos sensíveis, áudio e vídeo não entram no nome.",
              add: "Colocar \"{{label}}\" no nome",
              preview: "Como fica (exemplo)",
              and: " e ",
              when: {
                title: "Quando muda:",
                start: "quando a triagem começa.",
                items: "quando a IA concluir {{items}}. Se a triagem terminar antes, muda na conclusão, com o que houver.",
                end: "na conclusão da triagem, porque nenhum item confirma o nome do cliente.",
                linkHint: "Para mudar quando a IA confirmar o nome, ligue o item do nome a “Nome e CPF/CNPJ do cliente”.",
                openItems: "Abrir Itens",
              },
              notes: {
                customer: "Nas mensagens, o cliente continua sendo chamado só pelo nome.",
                once: "O nome muda uma vez por triagem. Se alguém editar o nome depois, a edição fica.",
                missing: "Dado que não chegar fica de fora do nome.",
              },
            },
            workOrders: {
              intro: "Comece a triagem pelas ordens de serviço (OS) que chegam da fonte, sem ninguém precisar abrir a conversa.",
              enabled: "Iniciar a triagem pelas ordens de serviço",
              noSources: "Esta empresa ainda não tem fonte de OS. O super admin cadastra em Integrações.",
              source: "Fonte das OS",
              sourceNone: "Escolha a fonte",
              inactive: "inativa",
              startMode: "Início",
              modes: {
                auto: "Automático: a IA procura o cliente assim que a OS chega",
                manual: "Manual: pelo botão na tela Ordens de serviço",
              },
              autoHint: "A OS que chegar (ou mudar) para um dos estados abaixo abre a triagem sozinha, dentro do horário de envio. O botão na tela de OS continua disponível.",
              manualHint: "Nada é enviado sozinho: um admin escolhe a OS e clica em Iniciar triagem.",
              statuses: "Estados da OS",
              statusesHint: "A triagem só começa com a OS num destes estados.",
              types: "Tipos de OS",
              typesHint: "Os tipos de OS que esta triagem atende.",
              window: "Horário de envio",
              windowHint: "Dias e horário (de Brasília) em que a IA pode procurar o cliente. Fora dele, a OS espera o próximo horário.",
              contactName: "O número da OS no nome do contato agora fica na aba Cadastro do contato.",
              contactNameOpen: "Abrir",
              days: "Dias do envio",
              dayNames: {
                d0: "Dom",
                d1: "Seg",
                d2: "Ter",
                d3: "Qua",
                d4: "Qui",
                d5: "Sex",
                d6: "Sáb",
              },
              from: "Das",
              to: "Até",
              connectionNote: "A conversa abre pela conexão escolhida na aba Contato ativo.",
              noConnection: "Escolha a conexão na aba Contato ativo.",
              metaNeedsTemplate: "Na API oficial, o início pela OS precisa de um template na aba Contato ativo: o cliente novo ainda não abriu a janela de 24 h.",
              autoSinceNote: "Ao publicar, o automático vale só para as OS que chegarem daí em diante; as que já estão na lista começam pelo botão.",
              humanNote: "Se o cliente já estiver com um atendente, a IA não toma a conversa: a triagem espera e o atendente é avisado.",
            },
            outreach: {
              intro: "Como a triagem abre a conversa com quem ainda não escreveu. Na API oficial, fora da janela de 24 h, só com um template aprovado; no WAHA, com a mensagem de abertura.",
              connection: "Conexão",
              connectionHint: "A conexão de WhatsApp que abre a conversa.",
              connectionNone: "Nenhuma (a triagem começa só em conversas já abertas)",
              providers: {
                "meta-api": "API oficial",
                waha: "WAHA",
              },
              disconnected: "Esta conexão está desconectada agora.",
              template: "Template",
              templateHint: "Os templates aprovados pela Meta nesta conexão. Crie o seu em Templates Meta; para este uso, a categoria Utilidade é a indicada.",
              loadingTemplates: "Carregando templates…",
              noTemplates: "Nenhum template aprovado nesta conexão.",
              templatesError: "Não deu para carregar os templates desta conexão.",
              chooseTemplate: "Escolha um template para a triagem conseguir abrir a conversa fora da janela de 24 h.",
              mediaHeader: "Tem mídia no cabeçalho, que a triagem ainda não envia.",
              headerVariable: "Tem variável no título, que a triagem ainda não preenche.",
              authTemplate: "É de autenticação, que a triagem não usa.",
              namedVariable: "Usa variável com nome, que a triagem ainda não preenche.",
              codeButton: "Tem botão de código ou de fluxo, que a triagem não envia.",
              urlVariable: "Tem botão de link com variável, que a triagem ainda não preenche.",
              removedConnection: "A conexão escolhida antes foi removida. Escolha outra (ou nenhuma) e salve.",
              missingTemplate: "O template escolhido ({{name}}) não está mais entre os aprovados desta conexão.",
              variables: "Variáveis do template",
              variablesHint: "De onde vem o valor de cada variável do texto.",
              variableLabel: "Valor da variável {{n}}",
              sourceNone: "Escolha",
              sources: {
                contactFirstName: "Primeiro nome do contato",
                contactName: "Nome do contato",
                companyName: "Nome da empresa",
                woCustomerFirstName: "Primeiro nome do cliente (OS)",
                woCustomerName: "Nome do cliente (OS)",
                woNumber: "Número da OS",
                woProductBrand: "Marca do produto (OS)",
                woProductModel: "Modelo do produto (OS)",
                fixed: "Texto fixo",
              },
              fixedPlaceholder: "Texto no lugar da variável",
              fixedLabel: "Texto fixo da variável {{n}}",
              preview: "Prévia (com dados de exemplo)",
              metaInfo: "Depois do template, a IA espera o cliente responder: a Meta só libera texto livre depois da resposta. Termine o template com uma pergunta ou um botão.",
              wahaInfo: "No WAHA não há template: a conversa abre com a mensagem de abertura (aba Mensagens), e a IA segue direto para o primeiro pedido.",
              wahaWarning: "Atenção: mandar a primeira mensagem para quem nunca falou com este número, por um canal não oficial, aumenta o risco de o WhatsApp bloquear o número.",
            },
          },
          sessions: {
            status: "Situação",
            statuses: {
              active: "Em andamento",
              COMPLETED: "Concluídas",
              CANCELLED: "Canceladas",
              FAILED: "Com falha",
              all: "Todas",
            },
            allDefinitions: "Todas as triagens",
            columns: {
              customer: "Cliente",
              definition: "Triagem",
              status: "Situação",
              started: "Início",
              ended: "Fim",
            },
            open: "Abrir conversa",
            noContact: "Contato apagado",
            empty: "Nenhuma triagem encontrada.",
            loadMore: "Carregar mais",
            total: "{{count}} no total",
          },
        },
      },
      smartApproaches: {
        title: "Abordagens inteligentes",
        subtitle: "Mensagens que saem sozinhas quando o cliente não responde a um template da API oficial. Se o cliente responder, os próximos envios param.",
        newFlow: "Novo fluxo",
        noConnection: "Para usar, conecte um número da API oficial em Conexões.",
        onlyAdmins: "Só administradores configuram as abordagens inteligentes.",
        loadError: "Não foi possível carregar os fluxos.",
        conflict: "O template inicial já abre o fluxo ativo \"{{name}}\" nesta conexão. Desative-o antes de ativar este.",
        filtersLabel: "Filtrar fluxos",
        filters: {
          all: "Todos",
          active: "Ativos",
          inactive: "Inativos",
        },
        empty: {
          title: "Nenhum fluxo ainda",
          text: "Crie um fluxo para escolher um template e as mensagens que saem sozinhas quando o cliente não responde.",
          filtered: "Nenhum fluxo neste filtro.",
        },
        active: "Ativo",
        inactive: "Inativo",
        messagesOne: "1 mensagem",
        messagesMany: "{{count}} mensagens",
        openRunsOne: "1 abordagem em andamento",
        openRunsMany: "{{count}} abordagens em andamento",
        activate: "Ativar",
        deactivate: "Desativar",
        edit: "Editar",
        delete: "Excluir",
        activated: "Fluxo ativado.",
        deactivated: "Fluxo desativado.",
        deleted: "Fluxo excluído.",
        confirmDeactivateTitle: "Desativar o fluxo?",
        confirmDeactivateText: "As abordagens em andamento ({{count}}) param agora: as mensagens automáticas delas não vão sair. As conversas continuam abertas.",
        confirmDeleteTitle: "Excluir o fluxo?",
        confirmDeleteText: "O fluxo sai da lista e o template volta a ser comum. As abordagens em andamento param. Os números continuam no Dashboard.",
        issues: {
          unchecked: "Não deu para conferir os templates na Meta agora.",
          line: "{{step}}: o template \"{{name}}\" está {{status}} na Meta.",
          initial: "Template inicial",
          step: "{{n}}ª mensagem",
          status: {
            PAUSED: "pausado",
            DISABLED: "desativado",
            REJECTED: "recusado",
            PENDING: "em análise",
            IN_APPEAL: "em recurso",
            MISSING: "excluído",
            other: "indisponível",
          },
        },
        sequence: {
          now: "agora",
          after: "+{{hours}} h",
        },
        days: {
          d0: "dom.",
          d1: "seg.",
          d2: "ter.",
          d3: "qua.",
          d4: "qui.",
          d5: "sex.",
          d6: "sáb.",
          range: "{{from}} a {{to}}",
        },
        ordinals: {
          n1: "1ª",
          n2: "2ª",
          n3: "3ª",
        },
        duration: {
          minutes: "{{minutes}} min",
          hours: "{{hours}} h",
          hoursMinutes: "{{hours}} h {{minutes}} min",
        },
        when: {
          soon: "em instantes",
          in: "em {{duration}}",
          at: "em {{date}} às {{time}}",
          late: "com atraso",
        },
        bar: {
          title: "Abordagem inteligente",
          active: "Abordagem inteligente ativa",
          awaiting: "aguardando resposta",
          sent: "{{step}} mensagem enviada",
          next: "{{step}} mensagem {{when}}",
          allSent: "todas as mensagens enviadas, aguardando resposta",
          interrupted: "Abordagem inteligente interrompida",
          completed: "Abordagem inteligente concluída",
          cancelledTitle: "Abordagem inteligente cancelada",
          replied: "o cliente respondeu (após a {{step}} mensagem)",
          noReply: "sem resposta",
          void: "a 1ª mensagem não foi entregue",
          hint: "Enviar uma mensagem na conversa cancela os próximos envios automáticos.",
          details: "Detalhes",
          cancel: "Cancelar fluxo inteligente",
          dismiss: "Esconder",
          cancelled: {
            manual: "pelo atendente",
            manualBy: "por {{name}}",
            agent_message: "uma mensagem foi enviada na conversa",
            agent_messageBy: "{{name}} enviou uma mensagem",
            ticket_closed: "atendimento encerrado",
            flow_disabled: "fluxo desativado",
            opt_out: "o cliente pediu para não receber mensagens",
            expired: "a {{step}} mensagem atrasou demais e não foi enviada",
            other: "os envios automáticos pararam",
          },
          failed: {
            template_unavailable: "o template da {{step}} mensagem não está aprovado na Meta",
            invalid_variables: "faltou o valor de uma variável da {{step}} mensagem",
            no_phone: "o contato não tem número de telefone",
            send_failed: "a Meta recusou a {{step}} mensagem",
            send_uncertain: "não deu para confirmar o envio da {{step}} mensagem",
            delivery_failed: "a {{step}} mensagem não foi entregue",
            start_interrupted: "o envio da 1ª mensagem não foi confirmado",
            other: "erro no envio da {{step}} mensagem",
          },
        },
        details: {
          title: "Abordagem inteligente",
          close: "Fechar",
          step: "{{step}} mensagem",
          planned: "Prevista: {{hours}} h depois da anterior, se o cliente não responder",
          scheduled: "Agendada: sai {{when}}",
          reply: "O cliente respondeu",
          startedBy: "Iniciada por {{name}} · {{date}}",
          startedAt: "Iniciada · {{date}}",
          status: {
            sent: "Enviada",
            delivered: "Entregue",
            read: "Lida",
            failed: "Falhou",
            sending: "Enviando",
            cancelled: "Não enviada",
            uncertain: "Envio não confirmado",
            expired: "Não enviada: atrasou demais",
          },
        },
        cancel: {
          title: "Cancelar fluxo inteligente?",
          text: "As próximas mensagens automáticas desta conversa não vão sair. O atendimento continua aberto.",
          confirm: "Cancelar fluxo",
          done: "Fluxo inteligente cancelado.",
        },
        messageMark: "Envio automático · Abordagem inteligente ({{step}} de {{total}})",
        messageMarkTitle: "Enviada pelo sistema porque o cliente não respondeu",
        modal: {
          filter: "Inteligentes",
          tooltip: "Abordagem Inteligente – Follow-up automático",
          sectionTitle: "Abordagem inteligente",
          first: "Agora: este template",
          afterFirst: "Após {{hours}} h sem resposta",
          afterNext: "Após mais {{hours}} h sem resposta",
          stop: "Se o cliente responder, os próximos envios são cancelados.",
          window: "Horário dos envios automáticos: {{window}}.",
          onlyFirst: "Fluxo de 1 mensagem: nada sai sozinho; a resposta do cliente conta no Dashboard.",
          notice: {
            blocked: "Esta conversa já tem uma abordagem inteligente em andamento ({{name}}). Para enviar outro template inteligente, cancele a atual.",
            cancels: "Esta conversa tem uma abordagem inteligente em andamento ({{name}}). Enviar este template cancela os próximos envios automáticos.",
            unknown: "Esta conversa tem uma abordagem inteligente em andamento ({{name}}). Um template comum cancela os próximos envios automáticos; um template inteligente só sai depois de cancelar a atual.",
          },
          cancelRun: "Cancelar abordagem atual",
          started: "Abordagem inteligente iniciada: a {{step}} mensagem sai {{when}} se o cliente não responder.",
          startedSingle: "Template enviado. Abordagem inteligente iniciada.",
          notStarted: "Template enviado, mas a abordagem inteligente não começou: as próximas mensagens não vão sair sozinhas.",
        },
        dashboard: {
          title: "Abordagens inteligentes",
          help: "Abordagens que começaram no período: quantos clientes responderam e depois de qual mensagem.",
          flowFilter: "Filtrar por fluxo",
          templateFilter: "Filtrar por template inicial",
          allFlows: "Todos os fluxos",
          allTemplates: "Todos os templates",
          deleted: "{{name}} (excluído)",
          started: "Iniciadas",
          replied: "Responderam",
          noReply: "Sem resposta",
          inProgress: "Aguardando resposta",
          rate: "Taxa de resposta",
          rateHelp: "Das abordagens que já terminaram, quantas tiveram resposta. As que aguardam resposta entram quando o prazo do fluxo acabar.",
          chartTitle: "Respostas por mensagem",
          chartHelp: "Depois de qual mensagem o cliente respondeu.",
          stepLabel: "{{step}} mensagem",
          repliedAfter: "responderam após a {{step}} mensagem",
          tableLabel: "Ver a tabela por",
          byFlow: "Por fluxo",
          byTemplate: "Por template",
          columns: {
            flow: "Fluxo",
            template: "Template inicial",
            started: "Iniciadas",
            replied: "Responderam",
            noReply: "Sem resposta",
            rate: "Taxa",
          },
          empty: "Nenhuma abordagem inteligente começou neste período.",
          loadError: "Não foi possível carregar os números.",
          refreshError: "Não foi possível atualizar os números: os de antes estão esmaecidos.",
          retry: "Tentar de novo",
        },
        editor: {
          titleNew: "Novo fluxo",
          titleEdit: "Editar fluxo",
          close: "Fechar",
          name: "Nome do fluxo",
          namePlaceholder: "Ex.: Recuperação de cliente – Assistência técnica",
          connection: "Conexão da API oficial",
          chooseConnection: "Escolha a conexão",
          connectionFirst: "Escolha a conexão para ver os templates aprovados.",
          count: "Quantidade de mensagens",
          countHint: "Contando a primeira, enviada pelo atendente.",
          initial: "Template inicial",
          initialHint: "O atendente envia este template pelo chat; o fluxo começa quando a Meta aceita o envio.",
          chooseTemplate: "Escolha o template",
          loadingTemplates: "Carregando os templates aprovados...",
          templatesError: "Não foi possível carregar os templates desta conexão.",
          missingTemplate: "O template \"{{name}}\" não está mais aprovado nesta conexão. Escolha outro.",
          stepTitle: "{{n}}ª mensagem",
          stepSubFirst: "Sai se o cliente não responder à 1ª mensagem.",
          stepSubNext: "Sai se o cliente continuar sem responder.",
          hours: "Horas sem resposta",
          hoursHint: "Contadas do envio da mensagem anterior ({{min}} a {{max}}).",
          template: "Template",
          templateHint: "Só podem sair sozinhos templates sem imagem, vídeo ou documento no cabeçalho, sem variável no cabeçalho ou no link e que não sejam de autenticação.",
          sources: {
            contactFirstName: "Primeiro nome do contato",
            contactName: "Nome do contato",
            companyName: "Nome da empresa",
            companyExample: "Assistência",
            initial: "Valor da 1ª mensagem: {{var}}",
            initialExample: "[{{var}} da 1ª mensagem]",
            fixed: "Texto fixo",
          },
          window: "Horário dos envios automáticos",
          windowHint: "Horário de Brasília. A mensagem que vencer fora desse horário sai na próxima abertura.",
          attribution: "Janela de atribuição (horas)",
          attributionHint: "Até quantas horas depois da última mensagem a resposta do cliente conta para o fluxo no Dashboard ({{min}} a {{max}}).",
          activeLabel: "Fluxo ativo",
          preview: "Prévia da sequência",
          previewFirst: "1ª · agora, enviada pelo atendente",
          previewAfterFirst: "2ª · após {{hours}} h sem resposta",
          previewAfterNext: "3ª · após mais {{hours}} h sem resposta",
          previewNoTemplate: "Escolha o template para ver a mensagem.",
          previewStop: "Se o cliente responder em qualquer momento, os próximos envios são cancelados.",
          costNote: "Cada mensagem automática é um template cobrado pela Meta.",
          editNote: "As mudanças valem para as próximas abordagens. As que estão em andamento seguem como começaram; para pará-las, desative o fluxo.",
          cancel: "Cancelar",
          save: "Salvar",
          saving: "Salvando...",
          created: "Fluxo criado.",
          saved: "Fluxo salvo.",
          discardTitle: "Descartar as alterações?",
          discardText: "As mudanças feitas neste fluxo não foram salvas.",
          discard: "Descartar",
          templateProblems: {
            authTemplate: "é de autenticação",
            namedVariable: "usa variável com nome",
            mediaHeader: "tem imagem, vídeo ou documento no cabeçalho",
            headerVariable: "tem variável no cabeçalho",
            codeButton: "tem botão de código ou de fluxo",
            urlVariable: "tem variável no link do botão",
          },
          problems: {
            name: "Dê um nome ao fluxo.",
            connection: "Escolha a conexão.",
            initial: "Escolha o template inicial.",
            hours: "{{n}}ª mensagem: as horas vão de {{min}} a {{max}}.",
            template: "{{n}}ª mensagem: escolha o template.",
            variable: "{{n}}ª mensagem: escolha o valor da variável {{variable}}.",
            fixed: "{{n}}ª mensagem: escreva o texto fixo da variável {{variable}}.",
            days: "Marque pelo menos um dia para os envios automáticos.",
            window: "O horário dos envios precisa começar antes de terminar.",
            attribution: "A janela de atribuição vai de {{min}} a {{max}} horas.",
          },
        },
      },
      backendErrors: {
        ERR_AI_UNAVAILABLE: "A IA ainda não está disponível nesta conta. Tente de novo em alguns minutos.",
        ERR_AI_KEY_REQUIRED: "Para usar a IA nesta Empresa, cadastre a chave da OpenAI em Integrações ou fale com a Sttelar.",
        ERR_AI_TEXT_TOO_LONG: "O texto é grande demais para a IA. Encurte e tente de novo.",
        ERR_AI_SETUP_INVALID_URL: "Confira o endereço do site, como suaempresa.com.br.",
        ERR_AI_SETUP_DESCRIPTION_SHORT: "Conte um pouco mais sobre o negócio (pelo menos 40 caracteres).",
        ERR_AI_SETUP_TOO_MANY: "Muitas tentativas nesta hora. Tente de novo mais tarde.",
        ERR_AI_SETUP_EMPTY: "Não encontramos informações no site. Você pode descrever o negócio.",
        ERR_AI_SETUP_BUSY: "A IA está ocupada agora. Tente de novo em instantes.",
        ERR_AI_SETUP_FAILED: "Não deu para montar a base agora. Tente de novo.",
        ERR_AI_SETUP_NOT_FOUND: "Esta preparação expirou. Comece de novo.",
        ERR_AI_SETUP_INVALID_NAME: "O nome da IA precisa ter de 2 a 60 caracteres.",
        ERR_AI_SETUP_KNOWLEDGE_SHORT: "A base ficou curta demais. Escreva um pouco mais.",
        ERR_AI_SETUP_KNOWLEDGE_LONG: "A base passou do tamanho máximo. Resuma um pouco.",
        ERR_AI_SETUP_AGENT_NOT_FOUND: "Não encontramos este agente. Comece de novo.",
        ERR_AI_SETUP_INVALID_SOURCE: "Escolha o site ou a descrição.",
        ERR_AI_SETUP_RUNNING: "Já tem uma base sendo preparada nesta conta. Espere ela terminar.",
        ERR_AI_SETUP_OTHER_FLOW: "Outro fluxo ativo já atende todas as conexões desta conta. Desative-o em Fluxos antes de ativar a IA.",
        ERR_AI_SETUP_VERSION_NOT_FOUND: "Não encontramos esta versão da IA. Salve de novo e teste antes de ativar.",
        ERR_TRIAGE_DISABLED: "A triagem por IA não está liberada para esta empresa.",
        ERR_TRIAGE_ALREADY_ACTIVE: "Esta conversa já tem uma triagem em andamento.",
        ERR_TRIAGE_SESSION_NOT_FOUND: "Triagem não encontrada.",
        ERR_TRIAGE_DEFINITION_NOT_FOUND: "Triagem não encontrada.",
        ERR_TRIAGE_REQUIREMENT_NOT_FOUND: "Item da triagem não encontrado.",
        ERR_TRIAGE_VERSION_NOT_FOUND: "Versão da triagem não encontrada.",
        ERR_INVALID_ACTION: "Ação inválida.",
        ERR_INVALID_ID: "Identificador inválido.",
        ERR_SMART_APPROACH_CONNECTION: "Escolha uma conexão da API oficial desta empresa.",
        ERR_SMART_APPROACH_TEMPLATES_UNAVAILABLE: "Não deu para ler os templates na Meta agora. Tente de novo em instantes.",
        ERR_SMART_APPROACH_NOT_FOUND: "Fluxo não encontrado.",
        ERR_SMART_APPROACH_ACTIVE: "Esta conversa já tem uma abordagem inteligente em andamento. Cancele-a antes de enviar outro template inteligente.",
        ERR_SMART_APPROACH_RUN_NOT_FOUND: "Abordagem não encontrada.",
        ERR_SMART_APPROACH_NOT_ACTIVE: "Esta abordagem não tem mais envios pendentes.",
        ERR_SMART_APPROACH_TEMPLATE_IN_USE: "O template inicial já abre outro fluxo ativo nesta conexão. Desative o outro antes.",
        ERR_INVALID_PARAMS: "Parâmetros inválidos.",
        ERR_INVALID_SETTING_VALUE: "Valor inválido para esta configuração.",
        ERR_WORK_ORDER_NOT_FOUND: "Ordem de serviço não encontrada.",
        ERR_TICKETNOTE_TOO_LONG: "A anotação pode ter no máximo 255 caracteres.",
        ERR_TICKETNOTE_READ_ONLY: "A nota-resumo da triagem é escrita pelo sistema: não dá para editar nem excluir.",
        ERR_TICKETNOTE_CONTACT_REQUIRED: "Informe o contato da anotação.",
        ERR_SUPER_ONLY: "Somente superadministradores podem usar esta ferramenta.",
        ERR_TICKET_CLOSE_DISABLED: "Nesta empresa, só administradores podem resolver conversas.",
        ERR_INVALID_TICKET_STATUS: "Situação da conversa inválida.",
        ERR_INVALID_FILTERS: "Filtros inválidos. Revise os status e o período.",
        ERR_NOTHING_TO_DELETE: "Nada mais a excluir com esses filtros — os dados mudaram desde a prévia.",
        ERR_NOTHING_TO_RESOLVE: "Nada mais a resolver com esses filtros — as conversas mudaram desde a prévia.",
        ERR_INVALID_PASSWORD: "Senha incorreta.",
        ERR_INVALID_CONFIRMATION_PHRASE: "A frase de confirmação não confere.",
        ERR_TOO_MANY_ATTEMPTS: "Muitas tentativas. Aguarde 15 minutos e tente de novo.",
        ERR_TOO_MANY_AUTH_ATTEMPTS: "Muitas tentativas. Aguarde alguns minutos e tente de novo.",
        ERR_ACCOUNT_SETUP_PENDING: "Seu cadastro está pronto, mas a configuração da empresa ainda não foi liberada.",
        ERR_AUTH_LINK_INVALID: "Este link não vale mais. Peça um novo.",
        ERR_PASSWORD_TOO_SHORT: "A senha precisa ter pelo menos 8 caracteres.",
        ERR_PASSWORD_TOO_LONG: "A senha é longa demais. Use até 72 caracteres.",
        ERR_SIGNUP_DISABLED: "O cadastro de novas contas está fechado no momento.",
        ERR_SIGNUP_INVALID_NAME: "Informe seu nome completo.",
        ERR_INVALID_EMAIL: "Informe um e-mail válido.",
        ERR_EMAIL_DOMAIN_NOT_FOUND: "Esse domínio de e-mail não existe. Confira se digitou certo.",
        ERR_EMAIL_DISPOSABLE: "Use um e-mail que você acessa sempre, não um temporário.",
        ERR_TERMS_NOT_ACCEPTED: "Para criar a conta, aceite os Termos de Uso e a Política de Privacidade.",
        ERR_META_NUMBER_IN_USE: "Esse número já está ligado a outra Empresa. Fale com a Sttelar.",
        ERR_AI_DAILY_LIMIT: "Você chegou ao limite de uso da IA por hoje neste recurso. Amanhã libera de novo.",
        ERR_EMAIL_ALREADY_EXISTS: "Já existe uma pessoa com este e-mail.",
        ERR_EMAIL_NOT_VERIFIED: "Confirme seu e-mail para fazer isso. Dá para reenviar o link pela faixa no topo da tela.",
        ERR_MESSAGE_NOT_FOUND: "Mensagem não encontrada.",
        ERR_BOARD_NOT_FOUND: "Quadro não encontrado.",
        ERR_SHARE_NOT_FOUND: "Link não encontrado.",
        ERR_SHARE_EXPIRED: "Este link já expirou. Crie um novo.",
        ERR_SHARE_REVOKED: "Este link foi revogado. Crie um novo.",
        ERR_SHARE_NAME_REQUIRED: "Dê um nome ao link.",
        ERR_SHARE_NAME_TOO_LONG: "O nome do link pode ter até 80 caracteres.",
        ERR_SHARE_INVALID_EXPIRATION: "Data de validade inválida.",
        ERR_SHARE_EXPIRATION_TOO_SOON: "A validade precisa ser de pelo menos 5 minutos a partir de agora.",
        ERR_SHARE_EXPIRATION_TOO_LATE: "A validade pode ser de até 1 ano. Para mais, use um link permanente.",
        ERR_SHARE_PASSWORD_REQUIRED: "Digite a senha.",
        ERR_SHARE_PASSWORD_TOO_SHORT: "A senha precisa ter pelo menos 8 caracteres.",
        ERR_SHARE_PASSWORD_TOO_LONG: "A senha está longa demais.",
        ERR_SHARE_INVALID_OPTION: "Opção inválida.",
        ERR_SHARE_LIMIT_REACHED: "Este quadro já tem 50 links ativos. Revogue algum antes de criar outro.",
        ERR_SHARE_LINK_UNAVAILABLE: "Não dá para mostrar este link de novo. Gere um novo link.",
        ERR_SHARE_URL_UNAVAILABLE: "O endereço da plataforma não está configurado. Fale com o suporte.",
        ERR_LEAD_NOT_FOUND: "Card não encontrado.",
        ERR_LEAD_STATUS_NOT_FOUND: "Coluna não encontrada.",
        ERR_STATUS_HAS_LEADS: "Esta coluna ainda tem cards. Mova-os para outra coluna antes de excluir.",
        ERR_ENTRY_COLUMN_CANNOT_BE_COMPLETED: "A coluna de entrada dos cards novos não pode ser de conclusão.",
        ERR_MFA_INVALID_OTP: "Código de verificação inválido.",
        ERR_ADMIN_OPERATION_IN_PROGRESS: "Já existe uma operação em andamento nesta conexão.",
        ERR_ADMIN_OPERATION_NOT_FOUND: "Operação não encontrada.",
        ERR_ADMIN_OPERATION_NOT_ACTIVE: "Esta operação já terminou.",
        ERR_ADMIN_OPERATION_NOT_RESUMABLE: "Só dá para retomar uma operação que falhou.",
        ERR_ADMIN_OPERATION_PREVIEW_EXPIRED: "A prévia ficou antiga (mais de 30 minutos).",
        ERR_QUEUE_UNAVAILABLE: "A fila de processamento está indisponível. Tente de novo em instantes.",
        ERR_NO_ATTENDANCE_ACCESS: "Seu perfil não tem acesso ao módulo de Atendimento.",
        ERR_ACADEMY_DISABLED: "A Área de Treinamento está desativada para esta empresa.",
        ERR_ACADEMY_INVALID_VIDEO_URL: "URL de vídeo inválida. Use um link do YouTube ou Vimeo.",
        ERR_ACADEMY_COURSE_NOT_FOUND: "Curso não encontrado.",
        ERR_ACADEMY_MODULE_NOT_FOUND: "Módulo não encontrado.",
        ERR_ACADEMY_LESSON_NOT_FOUND: "Aula não encontrada.",
        ERR_INTERNAL_SERVER_ERROR:
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
            "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
            "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
            "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
            "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
            "Usuário ou senha incorretos",
        ERR_COMPANY_DISABLED:
            "A empresa está desativada, contate o suporte da Sttelar para mais detalhes.",
        ERR_CANNOT_DISABLE_SYSTEM_COMPANY:
            "A empresa do sistema não pode ser desativada.",
        ERR_USER_DONT_EXISTS:
            "Usuário não encontrado. Verifique o e-mail informado.",
        ERR_SENDING_WAPP_MSG:
            "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_EDIT_WAPP_MSG: "Não foi possível editar a mensagem do WhatsApp.",
        ERR_EDIT_ONLY_OWN_MESSAGES: "Você só pode editar suas próprias mensagens.",
        ERR_EDIT_ONLY_WAHA_PROVIDER: "Edição de mensagens só está disponível para conexões não oficiais.",
        ERR_EDIT_TIME_LIMIT_EXCEEDED: "O tempo para edição expirou (limite de 10 minutos).",
        ERR_CANNOT_EDIT_DELETED_MESSAGE: "Não é possível editar uma mensagem deletada.",
        ERR_CANNOT_EDIT_MEDIA_MESSAGE: "Não é possível editar mensagens com mídia.",
        ERR_EMPTY_MESSAGE_BODY: "A mensagem não pode estar vazia.",
        ERR_META_API_DELETE_NOT_ALLOWED: "A Meta Cloud API não permite deletar mensagens enviadas. Esta é uma limitação da API oficial do WhatsApp Business.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
            "A criação do usuário foi desabilitada pelo administrador.",
        ERR_WORKFLOW_NOT_FOUND: "Este fluxo não existe mais.",
        ERR_AI_AGENT_NOT_FOUND: "Este agente não existe mais.",
        ERR_AI_AGENT_IN_USE: "Este agente atende em algum fluxo. Troque o agente nesses fluxos antes de excluir.",
        ERR_AI_AGENT_INVALID_AI_USER: "Escolha um usuário IA desta empresa como atendente.",
        ERR_AI_AGENT_INVALID_REASONING: "Escolha um nível de raciocínio da lista.",
        ERR_AI_AGENT_INVALID_STYLE: "Escolha um estilo de resposta da lista.",
        ERR_WORKFLOW_NODE_NOT_AI_AGENT: "Este bloco não é de IA. Abra o fluxo de novo e tente outra vez.",
        ERR_WORKFLOW_NODE_HAS_AGENT: "Este bloco já usa um agente.",
        ERR_AI_AGENT_CONVERT_INCOMPLETE: "Algum caso ou arquivo deste bloco não cabe inteiro no agente. Revise os casos e os arquivos e tente de novo.",
        ERR_WORKFLOW_AGENT_REQUIRED: "Para ativar o fluxo, escolha o agente do bloco \"Agente IA\" ou, no Personalizado, escreva o texto.",
        ERR_WORKFLOW_AGENT_NOT_FOUND: "O agente escolhido no bloco \"Agente IA\" não existe mais. Escolha outro.",
        ERR_SETUP_ALREADY_DONE: "Sua empresa já foi criada. Entre de novo para continuar.",
        ERR_SETUP_INVALID_COMPANY_NAME: "Use um nome de empresa com 2 a 80 caracteres.",
        ERR_SETUP_INVALID_ACCOUNT_NAME: "Use um nome de conta com 2 a 80 caracteres.",
        ERR_SETUP_COMPANY_REQUIRED: "Primeiro diga o nome da empresa.",
        ERR_SETUP_NOT_FOUND: "Não há configuração em andamento para esta conta.",
        ERR_SETUP_INVALID_STEP: "Esse passo da configuração não existe.",
        ERR_INVITE_NO_COMPANY: "Sua conta não está numa Empresa. Fale com o suporte.",
        ERR_INVITE_INVALID_ACCOUNTS: "Escolha uma conta da sua Empresa para o convite.",
        ERR_INVITE_ALREADY_MEMBER: "Essa pessoa já faz parte da Empresa.",
        ERR_INVITE_ALREADY_PENDING: "Já há um convite aberto para esse e-mail. Reenvie o que está na lista.",
        ERR_INVITE_NOT_FOUND: "Esse convite não está mais na lista. Atualize a página.",
        ERR_INVITE_RESEND_TOO_SOON: "O convite acabou de ser enviado. Espere um minuto para reenviar.",
        ERR_INVITE_INVALID: "Este convite não vale mais. Peça um novo a quem convidou você.",
        ERR_INVITE_OTHER_EMAIL: "Este convite é para outro e-mail. Entre com o e-mail do convite.",
        ERR_INVITE_PROFILE_MISMATCH: "Você já está nesta Empresa com outro perfil. Peça a quem convidou para conferir o seu acesso.",
        ERR_INVITE_LOGIN_REQUIRED: "Esse e-mail já tem conta. Entre com ele para aceitar o convite.",
        ERR_INVALID_PROFILE: "Escolha um perfil válido.",
        ERR_INVALID_ACCESS_SCOPE: "Escolha uma licença válida.",
        ERR_BILLING_PERSON_TYPE: "Escolha pessoa física ou jurídica.",
        ERR_BILLING_NAME: "Digite o nome completo ou a razão social.",
        ERR_BILLING_CPF: "CPF inválido.",
        ERR_BILLING_CNPJ: "CNPJ inválido.",
        ERR_BILLING_EMAIL: "E-mail de cobrança inválido.",
        ERR_BILLING_EMAIL_IN_USE: "Este e-mail de cobrança já é usado por outra Empresa. Use outro.",
        ERR_BILLING_PHONE: "Telefone inválido: use o DDD e o número.",
        ERR_BILLING_ZIP: "CEP inválido.",
        ERR_BILLING_ADDRESS: "Preencha o endereço, o número, o bairro e a cidade.",
        ERR_BILLING_STATE: "Escolha a UF.",
        ERR_BILLING_NO_COMPANY: "Esta conta não está numa Empresa.",
        ERR_BILLING_REDUCTION_LATER: "Para diminuir o plano ou as licenças, use Reduzir na renovação.",
        ERR_BILLING_NOTHING_TO_CHANGE: "Escolha o que aumentar.",
        ERR_BILLING_NO_SUBSCRIPTION: "A Empresa não tem assinatura para alterar.",
        ERR_BILLING_NO_SAVED_CARD: "A assinatura não tem cartão salvo: pague com Pix ou boleto.",
        ERR_BILLING_STARTER_CHANGE_LATER: "Para passar do Starter com Chat Interno para o Basic ou o Pro, fale com o suporte.",
        ERR_BILLING_TOO_MANY_ATTEMPTS: "Muitas tentativas de contratação hoje. Tente de novo amanhã ou fale com o suporte.",
        ERR_BILLING_DISABLED: "A cobrança está indisponível no momento. Tente mais tarde.",
        ERR_BILLING_INVALID_PAYMENT_METHOD: "Escolha uma forma de pagamento válida.",
        ERR_BILLING_CARD_TOKEN: "Confira os dados do cartão.",
        ERR_BILLING_NOT_ON_PLANS: "A cobrança desta Empresa é feita pelo suporte da Sttelar.",
        ERR_BILLING_COURTESY: "A Empresa está em cortesia e não é cobrada.",
        ERR_BILLING_ALREADY_SUBSCRIBED: "A Empresa já tem um plano contratado. Para mudar, fale com o suporte.",
        ERR_BILLING_NOTHING_TO_CHARGE: "Escolha o que contratar.",
        ERR_BILLING_BOLETO_MINIMUM: "Boleto só a partir de R$ 50,00. Escolha outra forma de pagamento.",
        ERR_BILLING_REDUCTION_BOLETO_MINIMUM: "No boleto, a mensalidade não fica abaixo de R$ 50,00: ficar só com o Chat Interno é no cartão. Fale com o suporte da Sttelar, ou cancele o plano.",
        ERR_BILLING_PROFILE_REQUIRED: "Preencha os dados para a cobrança antes de contratar.",
        ERR_BILLING_GATEWAY: "A Pagar.me não respondeu. Tente de novo em instantes.",
        ERR_BILLING_REQUEST_OPEN: "Já existe um pedido aguardando pagamento.",
        ERR_BILLING_RESUME_PENDING: "Estamos conferindo o pedido para desfazer o cancelamento. Tente de novo em alguns minutos.",
        ERR_BILLING_CARD_REJECTED: "O cartão não foi aceito. Confira os dados ou use outro cartão.",
        ERR_BILLING_REQUEST_NOT_FOUND: "Pedido não encontrado.",
        ERR_BILLING_ALREADY_PAID: "Este pedido já foi pago e o plano já mudou.",
        ERR_BILLING_RENEWING: "A renovação do plano está chegando. Tente de novo depois dela.",
        ERR_BILLING_BOLETO_TOO_LATE: "Faltam menos de 10 dias para a renovação: pague no cartão ou no Pix.",
        ERR_BILLING_QUOTE_CHANGED: "O valor mudou desde o cálculo. Confira e pague de novo.",
        ERR_BILLING_PAYMENT_PENDING: "Há uma mensalidade pendente. Regularize o pagamento antes de alterar ou cancelar o plano.",
        ERR_BILLING_REQUEST_CREATING: "Ainda estamos conferindo este pedido. Espere alguns minutos antes de desistir.",
        ERR_BILLING_CONTRACT_MISMATCH: "O contrato da Empresa foi ajustado pelo suporte. Para alterar o plano, fale com o suporte da Sttelar.",
        ERR_BILLING_REDUCTION_SCHEDULED: "Há uma redução agendada para a renovação. Desfaça a redução para mudar o plano agora.",
        ERR_BILLING_INCREASE_IS_CHANGE: "Para aumentar, use Alterar plano.",
        ERR_BILLING_REDUCTION_NOT_CHEAPER: "Esta redução não baixa a mensalidade (o preço do plano mudou). Fale com o suporte da Sttelar.",
        ERR_BILLING_UNKNOWN_ITEM: "A assinatura foi ajustada na Pagar.me fora do Sttelar Talk. Fale com o suporte da Sttelar.",
        ERR_BILLING_DUPLICATE_ITEM: "A assinatura tem um item repetido na Pagar.me. Fale com o suporte da Sttelar.",
        ERR_BILLING_REQUEST_CLOSED: "Este pedido já foi encerrado.",
        ERR_BILLING_INVALID_PLAN: "Escolha o Basic ou o Pro.",
        ERR_BILLING_INVALID_SEATS: "Número de licenças inválido.",
        ERR_BILLING_INVALID_INTERNAL_CHAT: "Número de licenças de Chat Interno inválido.",
        ERR_BILLING_INVALID_AI_PACK: "Escolha um dos pacotes de IA.",
        ERR_BILLING_AI_PACK_NOT_ALLOWED: "O pacote de IA é do Basic e do Pro.",
        ERR_COMPANY_REQUIRED: "Escolha a conta.",
        ERR_NO_COMPANY_ACCESS: "Você não tem mais acesso a essa conta. Recarregue a página.",
        ERR_USER_NOT_FOUND: "Usuário não encontrado.",
        ERR_WORKFLOW_EXECUTION_NOT_FOUND: "Esta execução não existe mais.",
        ERR_WORKFLOW_DESCRIPTION_TOO_LONG: "A descrição passa de 500 letras.",
        ERR_TRACK_LINK_HOSTS_REQUIRED: "Informe pelo menos um site para rastrear os links.",
        ERR_INVALID_TRACK_LINK_HOSTS: "Um dos sites não é válido. Use o formato minhaloja.com.br.",
        ERR_TOO_MANY_TRACK_LINK_HOSTS: "São no máximo 20 sites rastreados por fluxo.",
        ERR_INVALID_CONVERSION_SOURCE: "Esta loja não está disponível para o fluxo.",
        ERR_CONVERSION_SOURCE_EXISTS: "Esta loja já tem um endereço de webhook.",
        ERR_CONVERSION_SOURCE_NOT_FOUND: "Loja não encontrada.",
        ERR_INTEGRATION_NOT_FOUND: "Integração não encontrada.",
        ERR_INTEGRATION_REQUIRED: "Escolha a loja.",
        ERR_INVALID_LANGUAGE: "Idioma inválido: escolha português, inglês ou espanhol.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_USER_IN_OTHER_COMPANIES: "Esta pessoa também está em outra empresa, que você não administra.",
        ERR_ACCESS_UNAVAILABLE: "Não foi possível conferir o seu acesso agora. Tente de novo em instantes.",
        ERR_ACCESS_OWN: "Ninguém altera o próprio acesso. Peça a outro Administrador.",
        ERR_ACCESS_IMPERSONATING: "No \"Acessar como\" um usuário não dá para alterar acessos.",
        ERR_ACCESS_TARGET_ABOVE: "Esta pessoa tem mais acesso que você, por isso você não pode alterá-la.",
        ERR_ACCESS_GRANT_ABOVE: "Você só pode dar as permissões que você também tem.",
        ERR_ACCESS_NO_HOME: "A pessoa precisa ficar com as conversas ou com o chat interno.",
        ERR_ACCESS_LAST_ADMIN: "A empresa precisa de ao menos um Administrador. Defina outro antes.",
        ERR_NO_EMPRESA: "Esta conta não faz parte de uma empresa com outras contas.",
        ERR_INVALID_DEPARTMENT: "Preencha o nome e escolha ao menos uma conta.",
        ERR_DEPARTMENT_NOT_FOUND: "Departamento não encontrado.",
        ERR_DEPARTMENT_NAME_TAKEN: "Já existe um departamento com esse nome.",
        ERR_COMPANY_NAME_ALREADY_EXISTS: "Já existe uma conta com esse nome.",
        ERR_COMPANY_GROUP_INVALID_NAME: "O nome da empresa precisa ter de 2 a 255 caracteres.",
        ERR_COMPANY_GROUP_NOT_FOUND: "Empresa não encontrada.",
        ERR_COMPANY_GROUP_NAME_TAKEN: "Já existe outra empresa com esse nome.",
        ERR_COMPANY_GROUP_STANDALONE: "Conta sem empresa nomeada: o nome dela é o da conta. Edite a conta.",
        ERR_PLAN_LIMIT_USERS: "O plano da empresa chegou ao limite de usuários.",
        ERR_PLAN_LIMIT_INTERNAL_CHAT: "O plano da empresa chegou ao limite de usuários com Chat Interno.",
        ERR_PLAN_LIMIT_ACCOUNTS: "O plano da empresa chegou ao limite de contas.",
        ERR_PLAN_LIMIT_WHATSAPPS: "O plano da empresa chegou ao limite de números de WhatsApp.",
        ERR_PLAN_LIMIT_CRM_BOARDS: "O plano da empresa chegou ao limite de quadros do CRM.",
        ERR_MESSAGE_SEND_IN_PROGRESS: "Esta mensagem já está sendo enviada.",
        ERR_MESSAGE_QUOTA_COMMON: "As mensagens do mês acabaram. O envio volta quando o ciclo renovar ou o plano aumentar; fale com o administrador.",
        ERR_MESSAGE_QUOTA_AI: "As mensagens da IA do mês acabaram. A IA volta quando o ciclo renovar ou o pacote aumentar.",
        ERR_COMMERCIAL_REASON_REQUIRED: "Escreva o motivo (pelo menos 3 letras).",
        ERR_COMMERCIAL_INVALID_PLAN: "Plano inválido.",
        ERR_COMMERCIAL_INVALID_MODE: "Escolha como os limites funcionam.",
        ERR_COMMERCIAL_MODE_WITHOUT_PLAN: "Escolha um plano para ligar os limites.",
        ERR_COMMERCIAL_INVALID_SEATS: "Licenças contratadas abaixo do mínimo do plano.",
        ERR_COMMERCIAL_INVALID_INTERNAL_CHAT: "Número de licenças de Chat Interno inválido.",
        ERR_COMMERCIAL_INVALID_AI_PACK: "Pacote de IA inválido.",
        ERR_COMMERCIAL_AI_PACK_NOT_ALLOWED: "Esse plano não tem pacote de IA. Para dar mais IA, conceda uma exceção.",
        ERR_COMMERCIAL_INVALID_DATES: "Datas inválidas: o fim precisa ser depois do começo e de hoje.",
        ERR_COMMERCIAL_INVALID_ITEM: "Escolha o que a exceção muda.",
        ERR_COMMERCIAL_INVALID_VALUE: "Valor inválido.",
        ERR_COMMERCIAL_INVALID_USER: "Escolha uma pessoa desta Empresa.",
        ERR_COMMERCIAL_KIND_NOT_AVAILABLE: "Esse tipo de exceção ainda não está disponível.",
        ERR_COMMERCIAL_EXCEPTION_NOT_FOUND: "Exceção não encontrada.",
        ERR_COMMERCIAL_EXCEPTION_REVOKED: "Essa exceção já foi revogada.",
        ERR_DEPARTMENT_ACCOUNT_TAKEN: "Uma das contas já está em outro departamento.",
        ERR_DEPARTMENT_INVALID_ACCOUNT: "Escolha só contas desta empresa.",
        ERR_DEPARTMENT_INVALID_VIEWER: "Escolha só pessoas desta conta.",
        ERR_DEPARTMENT_WITHOUT_ACCOUNTS: "Este departamento não tem contas ativas.",
        ERR_ACCESS_CHANGED: "Outra pessoa alterou este acesso agora há pouco. Recarregue e tente de novo.",
        ERR_ACCESS_INVALID: "Os dados do acesso não são válidos. Recarregue a página e tente de novo.",
        ERR_ACCESS_ADMIN_ONLY: "Esta permissão é só do perfil Administrador.",
        ERR_CANNOT_REMOVE_ACTIVE_COMPANY: "Não é possível remover a Conta ativa do usuário. Defina outra Conta como principal antes.",
        ERR_COMPANY_NOT_ASSIGNED: "Esta Conta não está vinculada ao usuário.",
        ERR_COMPANY_ALREADY_ASSIGNED: "Esta Conta já está vinculada ao usuário.",
        ERR_COMPANY_NOT_IN_GROUP: "A Conta precisa pertencer à mesma Empresa do usuário.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_CONTACT_NOT_SHAREABLE: "Esse contato não tem um número de telefone que possa ser enviado.",
        ERR_CONTACT_SEND_UNSUPPORTED: "Esta conexão não envia cartões de contato.",
        ERR_SEND_CONTACT: "Não foi possível enviar o contato. Tente de novo.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_MAX_PINNED_TICKETS: "Máximo de 3 conversas fixadas atingido.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_TICKET_NO_CONNECTION: "Este ticket não possui uma conexão WhatsApp definida. Selecione uma conexão antes de resolver.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
            "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
            "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
            "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_QUICKMESSAGE_DUPLICATED_SHORTCODE:
            "Já existe uma resposta rápida com este atalho. Por favor, escolha outro.",
        ERR_QUICKMESSAGE_INVALID_NAME:
            "O atalho deve ter no mínimo 3 caracteres.",
        ERR_QUICKMESSAGE_REQUIRED:
            "O atalho e a mensagem são obrigatórios.",
        ERR_TAG_INVALID_NAME:
            "O nome da etiqueta deve ter no mínimo 3 caracteres.",
        ERR_TAG_NAME_REQUIRED:
            "O nome da etiqueta é obrigatório.",
        ERR_BILLING_CANCELLATION_SCHEDULED: "Há um cancelamento agendado. Desfaça o cancelamento para mudar o plano.",
        ERR_BILLING_SUBSCRIPTION_NOT_STARTED: "A assinatura retomada ainda não começou. Depois que ela começar, dá para mudar o plano.",
        ERR_BILLING_CARD_UNAVAILABLE: "O cartão cadastrado não está disponível. Fale com o suporte da Sttelar para continuar no plano.",
        ERR_BILLING_RESUME_CANCELED: "A assinatura nova foi cancelada na Pagar.me. Fale com o suporte da Sttelar para continuar no plano.",
        ERR_SENDING_SUSPENDED: "O envio de mensagens está suspenso por pagamento pendente. O pagamento é feito em Faturamento, por quem administra a empresa.",
        ERR_BILLING_PAYMENT_PROCESSING: "O pagamento no cartão está em análise. Espere alguns minutos e atualize.",
        ERR_BILLING_OVERDUE_CARD_REFUSED: "O cartão foi recusado de novo. Pague no Pix.",
        ERR_BILLING_DISPUTE_OUTCOME: "Escolha o resultado: ganha ou perdida.",
        ERR_BILLING_DISPUTE_NOT_FOUND: "Contestação não encontrada nesta Empresa.",
        ERR_BILLING_DISPUTE_RESOLVED: "Esta contestação já tem resultado.",
        ERR_INTERNAL_CHAT_SUSPENDED: "O Chat Interno está suspenso por pagamento pendente. Fale com o administrador da empresa.",
        ERR_BILLING_OVERDUE_IN_PROGRESS: "O pagamento da fatura vencida já está sendo preparado. Espere um instante.",
        ERR_BILLING_NOT_OVERDUE: "Não há fatura vencida para pagar.",
        ERR_BILLING_OVERDUE_BOLETO_SETTLING: "O boleto ainda pode estar em confirmação (até 3 dias úteis). Se não pagou, use a linha digitável dele.",
        ERR_BILLING_OVERDUE_CANCEL_FAILED: "Não deu para preparar o Pix agora. Tente de novo em alguns minutos.",
        ERR_BILLING_NOTHING_TO_RETRY: "Não há fatura recusada no cartão para tentar de novo.",
        ERR_BILLING_NOT_SUSPENDED: "A Empresa não está suspensa.",
        ERR_BILLING_REFUND_REASON: "Conte o motivo do estorno (pelo menos 10 caracteres).",
        ERR_BILLING_REFUND_CHARGE: "Cobrança não encontrada nesta Empresa.",
        ERR_BILLING_REFUND_NOT_PAID: "Só uma cobrança paga, sem contestação no cartão, pode ser estornada.",
        ERR_BILLING_REFUND_AMOUNT: "O valor passa do que ainda pode ser estornado desta cobrança.",
        ERR_BILLING_REFUND_OPEN: "Já há um pedido de estorno em andamento para esta cobrança.",
        ERR_BILLING_REFUND_DECISION: "Escolha: recusar, aprovar como correção ou como anulação.",
        ERR_BILLING_REFUND_NOT_FOUND: "Pedido de estorno não encontrado nesta Empresa.",
        ERR_BILLING_REFUND_DECIDED: "Este pedido de estorno já foi decidido.",
        ERR_BILLING_REFUND_FAILED: "A Pagar.me não fez o estorno agora. O pedido segue aprovado: tente de novo.",
        ERR_BILLING_REFUND_NOT_APPROVED: "Este estorno não está aprovado esperando a devolução.",
        ERR_COMMERCIAL_INVALID_KIND: "Tipo de exceção inválido.",
        ERR_BILLING_REFUND_MISMATCH: "O valor estornado na Pagar.me não confere com o pedido. Confira no painel dela; depois, marque como feito ou desfaça a aprovação.",
        ERR_BILLING_REFUND_ALREADY_SENT: "A Pagar.me já estornou (ou está estornando) esta cobrança: use \"Tentar de novo\" para conferir.",
        ERR_ADEQUACY_INVALID: "A escolha veio incompleta. Abra de novo e tente outra vez.",
        ERR_ADEQUACY_UNKNOWN_ITEM: "Algum item mudou desde que a tela abriu. Abra a escolha de novo.",
        ERR_ADEQUACY_SELF: "Você não pode tirar a si mesmo.",
        ERR_ADEQUACY_NO_ACCOUNT: "Pelo menos uma conta precisa ficar.",
        ERR_ADEQUACY_USER_WITHOUT_ACCOUNT: "Quem fica precisa ter acesso a uma conta que fica.",
        ERR_ADEQUACY_NO_ADMIN: "Pelo menos um administrador precisa ficar.",
        ERR_ADEQUACY_INTERNAL_ONLY: "Quem só usa o Chat Interno não pode ficar sem ele: tire a pessoa ou mantenha o Chat Interno.",
        ERR_ADEQUACY_SHARED_PERSON: "Esta pessoa também está em outra Empresa: o Chat Interno dela não muda por aqui.",
        ERR_ADEQUACY_OVER_LIMIT: "A escolha ainda passa dos limites do plano.",
        ERR_ADEQUACY_CHANGED: "A situação mudou desde que a escolha abriu. Abra de novo para ver o que vale agora.",
        ERR_HISTORY_INVALID_TOPIC: "Assunto do histórico inválido.",
        ERR_HISTORY_INVALID_PAGE: "Página do histórico inválida.",
        ERR_ADEQUACY_NOT_NEEDED: "Não há o que escolher agora.",
        ERR_ARCHIVE_NOT_FOUND: "Este item não está mais arquivado.",
        ERR_ARCHIVE_ACCOUNT_INACTIVE: "A conta deste item está arquivada: restaure a conta antes.",
        ERR_ARCHIVE_USER_WITHOUT_ACCOUNT: "Esta pessoa não tem acesso a uma conta em uso: restaure a conta dela antes.",
        ERR_PLAN_ADEQUACY_REQUIRED: "Acesso restrito: o administrador precisa escolher, em Faturamento, o que fica no plano.",
        ERR_WHATSAPP_ARCHIVED: "Este número foi arquivado na adequação ao plano e não envia mensagens.",
        ERR_ACCOUNT_ARCHIVED: "Esta conta foi arquivada na adequação ao plano. Fale com o administrador da sua Empresa.",
        ERR_MEMBER_ARCHIVED: "Seu acesso a esta Empresa foi arquivado na adequação ao plano. Fale com o administrador.",
      },
      messageSearch: {
        title: "Pesquisar mensagens com",
        placeholder: "Pesquisar mensagens...",
        noResults: "Nenhuma mensagem encontrada",
        startTyping: "Digite algo para pesquisar mensagens",
      },
      templateModal: {
        title: "Selecionar Template",
        searchPlaceholder: "Buscar por nome ou conteúdo...",
        loading: "Carregando templates...",
        recents: "Recentes",
        favorites: "Favoritos",
        favorite: "Favoritar template",
        unfavorite: "Remover dos favoritos",
        all: "Todos",
        previewEmpty: "Selecione um template para ver o preview",
        sentToast: "Template \"{name}\" enviado com sucesso!",
        categories: {
          all: "Todos",
          marketing: "Marketing",
          utility: "Utilitário",
          auth: "Autenticação",
          other: "Outro",
        },
        empty: {
          title: "Nenhum template encontrado",
          description: "Configure templates aprovados na sua conta Meta for Developers para usar esta funcionalidade.",
        },
        noResults: {
          title: "Sem resultados",
          description: "Tente outra busca ou remova o filtro de categoria.",
        },
        hints: {
          navigate: "navegar",
          send: "enviar",
          close: "fechar",
        },
        buttons: {
          cancel: "Cancelar",
          send: "Enviar template",
          sending: "Enviando...",
        },
      },
      internalChat: {
        jobRoleRequired: {
          title: "Selecione seu cargo",
          intro: "Pra usar o Chat Interno, escolha o cargo que melhor representa sua função na empresa. Ele aparecerá ao lado do seu nome nas conversas.",
          empty: "Nenhum cargo cadastrado. Peça ao administrador pra cadastrar cargos em Configurações → Cargos.",
          confirm: "Confirmar",
          saving: "Salvando...",
          toastSaved: "Cargo definido",
        },
      },
    },
  },
};

export { messages };
